// source: Messages.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.ProtoMessages.AutoLightControlValues', null, global);
goog.exportSymbol('proto.ProtoMessages.BigDataMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.Bool', null, global);
goog.exportSymbol('proto.ProtoMessages.CCUData', null, global);
goog.exportSymbol('proto.ProtoMessages.CCUPreset', null, global);
goog.exportSymbol('proto.ProtoMessages.CCUPreset.PresetType', null, global);
goog.exportSymbol('proto.ProtoMessages.CGEngineLogoDisplay', null, global);
goog.exportSymbol('proto.ProtoMessages.CGEngineType', null, global);
goog.exportSymbol('proto.ProtoMessages.CGEngineType.Type', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraControlMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraControlMessage.CameraControlMessageType', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraData', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraData.Type', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraFPSChangeStatus', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraFPSChangeStatus.Status', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraFramesData', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraFramesFailureReplyMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraFramesReplyMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraFramesRequestMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraInfo', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraInformation', null, global);
goog.exportSymbol('proto.ProtoMessages.CameraPairingInformationMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.CaptureFramesReplyType', null, global);
goog.exportSymbol('proto.ProtoMessages.CcuUpdateMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.CheckPipCameraPairedReply', null, global);
goog.exportSymbol('proto.ProtoMessages.CheckPipCameraPairedRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.CoachingAdditionalAngleInfo', null, global);
goog.exportSymbol('proto.ProtoMessages.CoachingAdditionalAngleList', null, global);
goog.exportSymbol('proto.ProtoMessages.CommandMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.ConfigurationAction', null, global);
goog.exportSymbol('proto.ProtoMessages.ConfigurationHistoryMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.ConfigurationHistoryParameter', null, global);
goog.exportSymbol('proto.ProtoMessages.ConfigurationMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.ConfigurationParameter', null, global);
goog.exportSymbol('proto.ProtoMessages.CoordinatorMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.DataChunkMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.Double', null, global);
goog.exportSymbol('proto.ProtoMessages.DriveInformation', null, global);
goog.exportSymbol('proto.ProtoMessages.EventInfo', null, global);
goog.exportSymbol('proto.ProtoMessages.ExistingCalibrationRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.FileChunkMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.FileTransferMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.FileTransferMessage.FileType', null, global);
goog.exportSymbol('proto.ProtoMessages.FileTransferMessage.TransferType', null, global);
goog.exportSymbol('proto.ProtoMessages.Float', null, global);
goog.exportSymbol('proto.ProtoMessages.FrameType', null, global);
goog.exportSymbol('proto.ProtoMessages.GeneralMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.GeneralStatus', null, global);
goog.exportSymbol('proto.ProtoMessages.GeneralStatus.Status', null, global);
goog.exportSymbol('proto.ProtoMessages.GraphicEngineInfo', null, global);
goog.exportSymbol('proto.ProtoMessages.GroundPoint', null, global);
goog.exportSymbol('proto.ProtoMessages.Int32', null, global);
goog.exportSymbol('proto.ProtoMessages.Int64', null, global);
goog.exportSymbol('proto.ProtoMessages.MessageType', null, global);
goog.exportSymbol('proto.ProtoMessages.MessageType.Type', null, global);
goog.exportSymbol('proto.ProtoMessages.NasInfo', null, global);
goog.exportSymbol('proto.ProtoMessages.NetworkConfigType', null, global);
goog.exportSymbol('proto.ProtoMessages.NetworkConfigType.Type', null, global);
goog.exportSymbol('proto.ProtoMessages.NetworkInfo', null, global);
goog.exportSymbol('proto.ProtoMessages.NetworkTestRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.NetworkTestResult', null, global);
goog.exportSymbol('proto.ProtoMessages.NetworkValidation', null, global);
goog.exportSymbol('proto.ProtoMessages.OcrCameraParametersRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.OcrCameraParametersResponse', null, global);
goog.exportSymbol('proto.ProtoMessages.OcrCameraParams', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingCameraTestResponse', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingFullNetworkTestRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingGPUTestResponse', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingGetCurrentNetworkRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingHandshakeReply', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingHandshakeRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingNetworkSetupRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingNetworkSetupResponse', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingOcrAutoFocusRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingOcrZoomRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingPipCameraPairingRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingPipCameraPairingResponse', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingRunPipInSetupModeRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.OnboardingStopPipInSetupModeRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.OperatingSystemMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.OperatingSystemMessage.Type', null, global);
goog.exportSymbol('proto.ProtoMessages.PairingInProgressQuery', null, global);
goog.exportSymbol('proto.ProtoMessages.PairingInProgressResponse', null, global);
goog.exportSymbol('proto.ProtoMessages.PairingStage', null, global);
goog.exportSymbol('proto.ProtoMessages.PairingStageUpdate', null, global);
goog.exportSymbol('proto.ProtoMessages.PairingStageUpdate.PairingErrorCode', null, global);
goog.exportSymbol('proto.ProtoMessages.PanoramaInfo', null, global);
goog.exportSymbol('proto.ProtoMessages.PipCameraChangeExposureModeChange', null, global);
goog.exportSymbol('proto.ProtoMessages.PipCameraFocusRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.PipCameraGainChangeRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.PipCameraIrisChangeRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.PipCameraPairingComplete', null, global);
goog.exportSymbol('proto.ProtoMessages.PipCameraZoomRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.Point2D', null, global);
goog.exportSymbol('proto.ProtoMessages.RealtimeInformationMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.RefreshOcrImageAndPreview', null, global);
goog.exportSymbol('proto.ProtoMessages.RunPairingWithData', null, global);
goog.exportSymbol('proto.ProtoMessages.RunPairingWithData.FrameStandard', null, global);
goog.exportSymbol('proto.ProtoMessages.RunPairingWithData.Type', null, global);
goog.exportSymbol('proto.ProtoMessages.RunPairingWithData.VideoStandard', null, global);
goog.exportSymbol('proto.ProtoMessages.ScoreboardType', null, global);
goog.exportSymbol('proto.ProtoMessages.ScoreboardType.Type', null, global);
goog.exportSymbol('proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.SingleParamInformationMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.SportTypeInfo', null, global);
goog.exportSymbol('proto.ProtoMessages.SportsType', null, global);
goog.exportSymbol('proto.ProtoMessages.SportsType.Type', null, global);
goog.exportSymbol('proto.ProtoMessages.StartAdditionalAngleCameraPairing', null, global);
goog.exportSymbol('proto.ProtoMessages.StaticInformationMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.StatusInformationMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.StreamsInfo', null, global);
goog.exportSymbol('proto.ProtoMessages.String', null, global);
goog.exportSymbol('proto.ProtoMessages.SwitchInfo', null, global);
goog.exportSymbol('proto.ProtoMessages.SwitchType', null, global);
goog.exportSymbol('proto.ProtoMessages.SwitchType.Type', null, global);
goog.exportSymbol('proto.ProtoMessages.SystemMode', null, global);
goog.exportSymbol('proto.ProtoMessages.SystemMode.Mode', null, global);
goog.exportSymbol('proto.ProtoMessages.SystemType', null, global);
goog.exportSymbol('proto.ProtoMessages.SystemType.Type', null, global);
goog.exportSymbol('proto.ProtoMessages.TestPorts', null, global);
goog.exportSymbol('proto.ProtoMessages.TestPortsResult', null, global);
goog.exportSymbol('proto.ProtoMessages.TestPortsResult.Result', null, global);
goog.exportSymbol('proto.ProtoMessages.TestStatus', null, global);
goog.exportSymbol('proto.ProtoMessages.TestStatus.StatusType', null, global);
goog.exportSymbol('proto.ProtoMessages.TestStatusResult', null, global);
goog.exportSymbol('proto.ProtoMessages.TestStatusResult.Result', null, global);
goog.exportSymbol('proto.ProtoMessages.TestStatusResult.StatusType', null, global);
goog.exportSymbol('proto.ProtoMessages.ToggleSetupMode', null, global);
goog.exportSymbol('proto.ProtoMessages.Token', null, global);
goog.exportSymbol('proto.ProtoMessages.TokenRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.TokenResponse', null, global);
goog.exportSymbol('proto.ProtoMessages.Uint64', null, global);
goog.exportSymbol('proto.ProtoMessages.VenueSelfTestRequest', null, global);
goog.exportSymbol('proto.ProtoMessages.VenueSelfTestResponse', null, global);
goog.exportSymbol('proto.ProtoMessages.VersionMessage', null, global);
goog.exportSymbol('proto.ProtoMessages.VpuStatus', null, global);
goog.exportSymbol('proto.ProtoMessages.VpuStatus.Status', null, global);
goog.exportSymbol('proto.ProtoMessages.WorkingHours', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CoordinatorMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CoordinatorMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CoordinatorMessage.displayName = 'proto.ProtoMessages.CoordinatorMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.MessageType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.MessageType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.MessageType.displayName = 'proto.ProtoMessages.MessageType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.GeneralStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.GeneralStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.GeneralStatus.displayName = 'proto.ProtoMessages.GeneralStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SwitchType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.SwitchType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SwitchType.displayName = 'proto.ProtoMessages.SwitchType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.ScoreboardType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.ScoreboardType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.ScoreboardType.displayName = 'proto.ProtoMessages.ScoreboardType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CGEngineType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CGEngineType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CGEngineType.displayName = 'proto.ProtoMessages.CGEngineType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SystemMode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.SystemMode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SystemMode.displayName = 'proto.ProtoMessages.SystemMode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SystemType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.SystemType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SystemType.displayName = 'proto.ProtoMessages.SystemType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.VpuStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.VpuStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.VpuStatus.displayName = 'proto.ProtoMessages.VpuStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SportsType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.SportsType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SportsType.displayName = 'proto.ProtoMessages.SportsType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CameraFPSChangeStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CameraFPSChangeStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CameraFPSChangeStatus.displayName = 'proto.ProtoMessages.CameraFPSChangeStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.String = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.String, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.String.displayName = 'proto.ProtoMessages.String';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.Bool = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.Bool, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.Bool.displayName = 'proto.ProtoMessages.Bool';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.Float = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.Float, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.Float.displayName = 'proto.ProtoMessages.Float';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.Double = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.Double, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.Double.displayName = 'proto.ProtoMessages.Double';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.Uint64 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.Uint64, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.Uint64.displayName = 'proto.ProtoMessages.Uint64';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.Int64 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.Int64, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.Int64.displayName = 'proto.ProtoMessages.Int64';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.Int32 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.Int32, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.Int32.displayName = 'proto.ProtoMessages.Int32';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CoachingAdditionalAngleInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CoachingAdditionalAngleInfo.displayName = 'proto.ProtoMessages.CoachingAdditionalAngleInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CoachingAdditionalAngleList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.CoachingAdditionalAngleList.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.CoachingAdditionalAngleList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CoachingAdditionalAngleList.displayName = 'proto.ProtoMessages.CoachingAdditionalAngleList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.NasInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.NasInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.NasInfo.displayName = 'proto.ProtoMessages.NasInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.NetworkConfigType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.NetworkConfigType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.NetworkConfigType.displayName = 'proto.ProtoMessages.NetworkConfigType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.NetworkInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.NetworkInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.NetworkInfo.displayName = 'proto.ProtoMessages.NetworkInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CommandMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.CommandMessage.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.CommandMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CommandMessage.displayName = 'proto.ProtoMessages.CommandMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CameraInformation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CameraInformation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CameraInformation.displayName = 'proto.ProtoMessages.CameraInformation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.ConfigurationParameter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.ConfigurationParameter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.ConfigurationParameter.displayName = 'proto.ProtoMessages.ConfigurationParameter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.ConfigurationMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.ConfigurationMessage.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.ConfigurationMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.ConfigurationMessage.displayName = 'proto.ProtoMessages.ConfigurationMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.ConfigurationHistoryParameter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.ConfigurationHistoryParameter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.ConfigurationHistoryParameter.displayName = 'proto.ProtoMessages.ConfigurationHistoryParameter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.ConfigurationHistoryMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.ConfigurationHistoryMessage.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.ConfigurationHistoryMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.ConfigurationHistoryMessage.displayName = 'proto.ProtoMessages.ConfigurationHistoryMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.GeneralMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.GeneralMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.GeneralMessage.displayName = 'proto.ProtoMessages.GeneralMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.StatusInformationMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.StatusInformationMessage.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.StatusInformationMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.StatusInformationMessage.displayName = 'proto.ProtoMessages.StatusInformationMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.RealtimeInformationMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.RealtimeInformationMessage.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.RealtimeInformationMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.RealtimeInformationMessage.displayName = 'proto.ProtoMessages.RealtimeInformationMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SingleParamInformationMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.SingleParamInformationMessage.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.SingleParamInformationMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SingleParamInformationMessage.displayName = 'proto.ProtoMessages.SingleParamInformationMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CameraPairingInformationMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CameraPairingInformationMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CameraPairingInformationMessage.displayName = 'proto.ProtoMessages.CameraPairingInformationMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CameraData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CameraData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CameraData.displayName = 'proto.ProtoMessages.CameraData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.RunPairingWithData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.RunPairingWithData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.RunPairingWithData.displayName = 'proto.ProtoMessages.RunPairingWithData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CcuUpdateMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CcuUpdateMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CcuUpdateMessage.displayName = 'proto.ProtoMessages.CcuUpdateMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.PanoramaInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.PanoramaInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.PanoramaInfo.displayName = 'proto.ProtoMessages.PanoramaInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CCUData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CCUData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CCUData.displayName = 'proto.ProtoMessages.CCUData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.AutoLightControlValues = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.AutoLightControlValues, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.AutoLightControlValues.displayName = 'proto.ProtoMessages.AutoLightControlValues';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.FileTransferMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.FileTransferMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.FileTransferMessage.displayName = 'proto.ProtoMessages.FileTransferMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.DriveInformation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.DriveInformation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.DriveInformation.displayName = 'proto.ProtoMessages.DriveInformation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.StaticInformationMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.StaticInformationMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.StaticInformationMessage.displayName = 'proto.ProtoMessages.StaticInformationMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.EventInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.EventInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.EventInfo.displayName = 'proto.ProtoMessages.EventInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.WorkingHours = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.WorkingHours, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.WorkingHours.displayName = 'proto.ProtoMessages.WorkingHours';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.StreamsInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.StreamsInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.StreamsInfo.displayName = 'proto.ProtoMessages.StreamsInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SwitchInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.SwitchInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SwitchInfo.displayName = 'proto.ProtoMessages.SwitchInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CGEngineLogoDisplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CGEngineLogoDisplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CGEngineLogoDisplay.displayName = 'proto.ProtoMessages.CGEngineLogoDisplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.GraphicEngineInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.GraphicEngineInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.GraphicEngineInfo.displayName = 'proto.ProtoMessages.GraphicEngineInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.VersionMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.VersionMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.VersionMessage.displayName = 'proto.ProtoMessages.VersionMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OperatingSystemMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OperatingSystemMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OperatingSystemMessage.displayName = 'proto.ProtoMessages.OperatingSystemMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.Token = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.Token, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.Token.displayName = 'proto.ProtoMessages.Token';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.ToggleSetupMode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.ToggleSetupMode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.ToggleSetupMode.displayName = 'proto.ProtoMessages.ToggleSetupMode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CameraFramesData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.CameraFramesData.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.CameraFramesData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CameraFramesData.displayName = 'proto.ProtoMessages.CameraFramesData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.TestPorts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.TestPorts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.TestPorts.displayName = 'proto.ProtoMessages.TestPorts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.TestPortsResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.TestPortsResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.TestPortsResult.displayName = 'proto.ProtoMessages.TestPortsResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.TestStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.TestStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.TestStatus.displayName = 'proto.ProtoMessages.TestStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.TestStatusResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.TestStatusResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.TestStatusResult.displayName = 'proto.ProtoMessages.TestStatusResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.NetworkTestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.NetworkTestRequest.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.NetworkTestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.NetworkTestRequest.displayName = 'proto.ProtoMessages.NetworkTestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.NetworkTestResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.NetworkTestResult.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.NetworkTestResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.NetworkTestResult.displayName = 'proto.ProtoMessages.NetworkTestResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.NetworkValidation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.NetworkValidation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.NetworkValidation.displayName = 'proto.ProtoMessages.NetworkValidation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CCUPreset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CCUPreset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CCUPreset.displayName = 'proto.ProtoMessages.CCUPreset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.BigDataMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.BigDataMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.BigDataMessage.displayName = 'proto.ProtoMessages.BigDataMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.DataChunkMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.DataChunkMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.DataChunkMessage.displayName = 'proto.ProtoMessages.DataChunkMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.FileChunkMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.FileChunkMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.FileChunkMessage.displayName = 'proto.ProtoMessages.FileChunkMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CameraFramesRequestMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CameraFramesRequestMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CameraFramesRequestMessage.displayName = 'proto.ProtoMessages.CameraFramesRequestMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CameraFramesReplyMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CameraFramesReplyMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CameraFramesReplyMessage.displayName = 'proto.ProtoMessages.CameraFramesReplyMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CameraFramesFailureReplyMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CameraFramesFailureReplyMessage.displayName = 'proto.ProtoMessages.CameraFramesFailureReplyMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.Point2D = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.Point2D, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.Point2D.displayName = 'proto.ProtoMessages.Point2D';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.GroundPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.GroundPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.GroundPoint.displayName = 'proto.ProtoMessages.GroundPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SportTypeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.SportTypeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SportTypeInfo.displayName = 'proto.ProtoMessages.SportTypeInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage.displayName = 'proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.displayName = 'proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.displayName = 'proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.displayName = 'proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CheckPipCameraPairedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CheckPipCameraPairedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CheckPipCameraPairedRequest.displayName = 'proto.ProtoMessages.CheckPipCameraPairedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CheckPipCameraPairedReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CheckPipCameraPairedReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CheckPipCameraPairedReply.displayName = 'proto.ProtoMessages.CheckPipCameraPairedReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.PipCameraPairingComplete = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.PipCameraPairingComplete, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.PipCameraPairingComplete.displayName = 'proto.ProtoMessages.PipCameraPairingComplete';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.PipCameraFocusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.PipCameraFocusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.PipCameraFocusRequest.displayName = 'proto.ProtoMessages.PipCameraFocusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.PipCameraZoomRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.PipCameraZoomRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.PipCameraZoomRequest.displayName = 'proto.ProtoMessages.PipCameraZoomRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.PipCameraIrisChangeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.PipCameraIrisChangeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.PipCameraIrisChangeRequest.displayName = 'proto.ProtoMessages.PipCameraIrisChangeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.PipCameraChangeExposureModeChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.PipCameraChangeExposureModeChange.displayName = 'proto.ProtoMessages.PipCameraChangeExposureModeChange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.PipCameraGainChangeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.PipCameraGainChangeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.PipCameraGainChangeRequest.displayName = 'proto.ProtoMessages.PipCameraGainChangeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OcrCameraParametersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OcrCameraParametersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OcrCameraParametersRequest.displayName = 'proto.ProtoMessages.OcrCameraParametersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OcrCameraParametersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OcrCameraParametersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OcrCameraParametersResponse.displayName = 'proto.ProtoMessages.OcrCameraParametersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OcrCameraParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OcrCameraParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OcrCameraParams.displayName = 'proto.ProtoMessages.OcrCameraParams';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.StartAdditionalAngleCameraPairing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.StartAdditionalAngleCameraPairing.displayName = 'proto.ProtoMessages.StartAdditionalAngleCameraPairing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.PairingStageUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.PairingStageUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.PairingStageUpdate.displayName = 'proto.ProtoMessages.PairingStageUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.ExistingCalibrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.ExistingCalibrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.ExistingCalibrationRequest.displayName = 'proto.ProtoMessages.ExistingCalibrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.RefreshOcrImageAndPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.RefreshOcrImageAndPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.RefreshOcrImageAndPreview.displayName = 'proto.ProtoMessages.RefreshOcrImageAndPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingGetCurrentNetworkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.displayName = 'proto.ProtoMessages.OnboardingGetCurrentNetworkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingNetworkSetupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingNetworkSetupRequest.displayName = 'proto.ProtoMessages.OnboardingNetworkSetupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingFullNetworkTestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingFullNetworkTestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingFullNetworkTestRequest.displayName = 'proto.ProtoMessages.OnboardingFullNetworkTestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingNetworkSetupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingNetworkSetupResponse.displayName = 'proto.ProtoMessages.OnboardingNetworkSetupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.PairingInProgressQuery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.PairingInProgressQuery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.PairingInProgressQuery.displayName = 'proto.ProtoMessages.PairingInProgressQuery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.PairingInProgressResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.PairingInProgressResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.PairingInProgressResponse.displayName = 'proto.ProtoMessages.PairingInProgressResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.TokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.TokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.TokenRequest.displayName = 'proto.ProtoMessages.TokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.TokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.TokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.TokenResponse.displayName = 'proto.ProtoMessages.TokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.VenueSelfTestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.VenueSelfTestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.VenueSelfTestRequest.displayName = 'proto.ProtoMessages.VenueSelfTestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingCameraTestResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingCameraTestResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingCameraTestResponse.displayName = 'proto.ProtoMessages.OnboardingCameraTestResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingGPUTestResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingGPUTestResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingGPUTestResponse.displayName = 'proto.ProtoMessages.OnboardingGPUTestResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.VenueSelfTestResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.VenueSelfTestResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.VenueSelfTestResponse.displayName = 'proto.ProtoMessages.VenueSelfTestResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingHandshakeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingHandshakeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingHandshakeRequest.displayName = 'proto.ProtoMessages.OnboardingHandshakeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingHandshakeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingHandshakeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingHandshakeReply.displayName = 'proto.ProtoMessages.OnboardingHandshakeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingOcrZoomRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingOcrZoomRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingOcrZoomRequest.displayName = 'proto.ProtoMessages.OnboardingOcrZoomRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingOcrAutoFocusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingOcrAutoFocusRequest.displayName = 'proto.ProtoMessages.OnboardingOcrAutoFocusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingPipCameraPairingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingPipCameraPairingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingPipCameraPairingRequest.displayName = 'proto.ProtoMessages.OnboardingPipCameraPairingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingPipCameraPairingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingPipCameraPairingResponse.displayName = 'proto.ProtoMessages.OnboardingPipCameraPairingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingRunPipInSetupModeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.displayName = 'proto.ProtoMessages.OnboardingRunPipInSetupModeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.OnboardingStopPipInSetupModeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.displayName = 'proto.ProtoMessages.OnboardingStopPipInSetupModeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CameraInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ProtoMessages.CameraInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CameraInfo.displayName = 'proto.ProtoMessages.CameraInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ProtoMessages.CameraControlMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ProtoMessages.CameraControlMessage.repeatedFields_, null);
};
goog.inherits(proto.ProtoMessages.CameraControlMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ProtoMessages.CameraControlMessage.displayName = 'proto.ProtoMessages.CameraControlMessage';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CoordinatorMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CoordinatorMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CoordinatorMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CoordinatorMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    messagetypestr: jspb.Message.getFieldWithDefault(msg, 2, ""),
    messagecontent: msg.getMessagecontent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CoordinatorMessage}
 */
proto.ProtoMessages.CoordinatorMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CoordinatorMessage;
  return proto.ProtoMessages.CoordinatorMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CoordinatorMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CoordinatorMessage}
 */
proto.ProtoMessages.CoordinatorMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessagetypestr(value);
      break;
    case 5:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMessagecontent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CoordinatorMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CoordinatorMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CoordinatorMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CoordinatorMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagetypestr();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessagecontent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      5,
      f
    );
  }
};


/**
 * optional string messageTypeStr = 2;
 * @return {string}
 */
proto.ProtoMessages.CoordinatorMessage.prototype.getMessagetypestr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CoordinatorMessage} returns this
 */
proto.ProtoMessages.CoordinatorMessage.prototype.setMessagetypestr = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes messageContent = 5;
 * @return {!(string|Uint8Array)}
 */
proto.ProtoMessages.CoordinatorMessage.prototype.getMessagecontent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * optional bytes messageContent = 5;
 * This is a type-conversion wrapper around `getMessagecontent()`
 * @return {string}
 */
proto.ProtoMessages.CoordinatorMessage.prototype.getMessagecontent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMessagecontent()));
};


/**
 * optional bytes messageContent = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessagecontent()`
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CoordinatorMessage.prototype.getMessagecontent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMessagecontent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.ProtoMessages.CoordinatorMessage} returns this
 */
proto.ProtoMessages.CoordinatorMessage.prototype.setMessagecontent = function(value) {
  return jspb.Message.setProto3BytesField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.MessageType.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.MessageType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.MessageType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.MessageType.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.MessageType}
 */
proto.ProtoMessages.MessageType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.MessageType;
  return proto.ProtoMessages.MessageType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.MessageType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.MessageType}
 */
proto.ProtoMessages.MessageType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.MessageType.Type} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.MessageType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.MessageType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.MessageType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.MessageType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.MessageType.Type = {
  SYSTEM_INFO: 0,
  REALTIME_INFO: 1,
  STATIC_INFO: 2,
  COMMAND: 3,
  SAVE_CONFIGURATION: 4,
  COACHING_ADDITIONAL_ANGLE_INFO: 5,
  FILE_IMPORT: 6,
  VERSION: 7,
  SINGLE_PARAM_INFO: 8,
  CCU_UPDATE: 9,
  LOG: 10,
  CONFIGURATION: 11,
  NETWORK_TESTS: 13,
  NETWORK_VALIDATION: 14,
  OPERATING_SYSTEM: 15,
  OTHER: 99
};

/**
 * optional Type value = 1;
 * @return {!proto.ProtoMessages.MessageType.Type}
 */
proto.ProtoMessages.MessageType.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.MessageType.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.MessageType.Type} value
 * @return {!proto.ProtoMessages.MessageType} returns this
 */
proto.ProtoMessages.MessageType.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.GeneralStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.GeneralStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.GeneralStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.GeneralStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.GeneralStatus}
 */
proto.ProtoMessages.GeneralStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.GeneralStatus;
  return proto.ProtoMessages.GeneralStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.GeneralStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.GeneralStatus}
 */
proto.ProtoMessages.GeneralStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.GeneralStatus.Status} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.GeneralStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.GeneralStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.GeneralStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.GeneralStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.GeneralStatus.Status = {
  NONE: 0,
  GOOD: 1,
  BAD: 2
};

/**
 * optional Status value = 1;
 * @return {!proto.ProtoMessages.GeneralStatus.Status}
 */
proto.ProtoMessages.GeneralStatus.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.GeneralStatus.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.GeneralStatus.Status} value
 * @return {!proto.ProtoMessages.GeneralStatus} returns this
 */
proto.ProtoMessages.GeneralStatus.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SwitchType.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SwitchType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SwitchType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SwitchType.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SwitchType}
 */
proto.ProtoMessages.SwitchType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SwitchType;
  return proto.ProtoMessages.SwitchType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SwitchType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SwitchType}
 */
proto.ProtoMessages.SwitchType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.SwitchType.Type} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SwitchType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SwitchType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SwitchType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SwitchType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.SwitchType.Type = {
  NONE: 0,
  DLINK: 1,
  CISCO: 2
};

/**
 * optional Type value = 1;
 * @return {!proto.ProtoMessages.SwitchType.Type}
 */
proto.ProtoMessages.SwitchType.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.SwitchType.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.SwitchType.Type} value
 * @return {!proto.ProtoMessages.SwitchType} returns this
 */
proto.ProtoMessages.SwitchType.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.ScoreboardType.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.ScoreboardType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.ScoreboardType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ScoreboardType.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.ScoreboardType}
 */
proto.ProtoMessages.ScoreboardType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.ScoreboardType;
  return proto.ProtoMessages.ScoreboardType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.ScoreboardType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.ScoreboardType}
 */
proto.ProtoMessages.ScoreboardType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.ScoreboardType.Type} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.ScoreboardType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.ScoreboardType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.ScoreboardType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ScoreboardType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.ScoreboardType.Type = {
  NONE: 0,
  CGENGINE: 1,
  PIP: 2
};

/**
 * optional Type value = 1;
 * @return {!proto.ProtoMessages.ScoreboardType.Type}
 */
proto.ProtoMessages.ScoreboardType.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.ScoreboardType.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.ScoreboardType.Type} value
 * @return {!proto.ProtoMessages.ScoreboardType} returns this
 */
proto.ProtoMessages.ScoreboardType.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CGEngineType.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CGEngineType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CGEngineType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CGEngineType.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CGEngineType}
 */
proto.ProtoMessages.CGEngineType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CGEngineType;
  return proto.ProtoMessages.CGEngineType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CGEngineType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CGEngineType}
 */
proto.ProtoMessages.CGEngineType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.CGEngineType.Type} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CGEngineType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CGEngineType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CGEngineType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CGEngineType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.CGEngineType.Type = {
  WEB: 0,
  SPORTZCAST: 1,
  DAKTRONICS: 2,
  REST: 3,
  HOCKEYTECH: 4,
  OUTFITTERS: 5,
  NEVCO: 6,
  OCR: 7,
  ENHANCED_PIP: 8,
  FULLPIP: 9
};

/**
 * optional Type value = 1;
 * @return {!proto.ProtoMessages.CGEngineType.Type}
 */
proto.ProtoMessages.CGEngineType.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.CGEngineType.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.CGEngineType.Type} value
 * @return {!proto.ProtoMessages.CGEngineType} returns this
 */
proto.ProtoMessages.CGEngineType.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SystemMode.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SystemMode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SystemMode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SystemMode.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SystemMode}
 */
proto.ProtoMessages.SystemMode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SystemMode;
  return proto.ProtoMessages.SystemMode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SystemMode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SystemMode}
 */
proto.ProtoMessages.SystemMode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.SystemMode.Mode} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SystemMode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SystemMode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SystemMode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SystemMode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.SystemMode.Mode = {
  WORKING_HOURS: 0,
  APPLICATION: 1,
  MAINTENANCE: 2
};

/**
 * optional Mode value = 1;
 * @return {!proto.ProtoMessages.SystemMode.Mode}
 */
proto.ProtoMessages.SystemMode.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.SystemMode.Mode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.SystemMode.Mode} value
 * @return {!proto.ProtoMessages.SystemMode} returns this
 */
proto.ProtoMessages.SystemMode.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SystemType.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SystemType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SystemType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SystemType.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SystemType}
 */
proto.ProtoMessages.SystemType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SystemType;
  return proto.ProtoMessages.SystemType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SystemType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SystemType}
 */
proto.ProtoMessages.SystemType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.SystemType.Type} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SystemType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SystemType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SystemType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SystemType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.SystemType.Type = {
  S_TYPE: 0,
  P_TYPE: 1,
  S2_TYPE: 2,
  S3_TYPE: 3,
  PRIME_TYPE: 4,
  S2_MOBILITY_TYPE: 5,
  S2S_TYPE: 6
};

/**
 * optional Type value = 1;
 * @return {!proto.ProtoMessages.SystemType.Type}
 */
proto.ProtoMessages.SystemType.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.SystemType.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.SystemType.Type} value
 * @return {!proto.ProtoMessages.SystemType} returns this
 */
proto.ProtoMessages.SystemType.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.VpuStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.VpuStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.VpuStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.VpuStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.VpuStatus}
 */
proto.ProtoMessages.VpuStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.VpuStatus;
  return proto.ProtoMessages.VpuStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.VpuStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.VpuStatus}
 */
proto.ProtoMessages.VpuStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.VpuStatus.Status} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.VpuStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.VpuStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.VpuStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.VpuStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.VpuStatus.Status = {
  OFF: 0,
  SLEEP: 1,
  INIT: 2,
  ON: 3,
  PROCESSING: 4
};

/**
 * optional Status value = 1;
 * @return {!proto.ProtoMessages.VpuStatus.Status}
 */
proto.ProtoMessages.VpuStatus.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.VpuStatus.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.VpuStatus.Status} value
 * @return {!proto.ProtoMessages.VpuStatus} returns this
 */
proto.ProtoMessages.VpuStatus.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SportsType.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SportsType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SportsType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SportsType.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SportsType}
 */
proto.ProtoMessages.SportsType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SportsType;
  return proto.ProtoMessages.SportsType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SportsType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SportsType}
 */
proto.ProtoMessages.SportsType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.SportsType.Type} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SportsType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SportsType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SportsType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SportsType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.SportsType.Type = {
  OTHER: 0,
  SOCCER: 1,
  BASKETBALL: 2,
  HANDBALL: 3,
  AMERICAN_FOOTBALL: 4,
  RUGBY: 5,
  FIELD_HOCKEY: 6,
  ICE_HOCKEY: 7,
  ROLLER_HOCKEY: 8,
  FUTSAL: 9,
  SOCCER_TACTICAL: 10,
  FUTSAL_TACTICAL: 11,
  WRESTLING: 12,
  VOLLEYBALL: 13,
  GYMNASTICS: 14,
  LEFT_SIDE: 15,
  CENTER: 16,
  RIGHT_SIDE: 17,
  BASEBALL: 18,
  BASKETBALL_TACTICAL: 19,
  ROLLER_HOCKEY_TACTICAL: 20,
  HANDBALL_TACTICAL: 21
};

/**
 * optional Type value = 1;
 * @return {!proto.ProtoMessages.SportsType.Type}
 */
proto.ProtoMessages.SportsType.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.SportsType.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.SportsType.Type} value
 * @return {!proto.ProtoMessages.SportsType} returns this
 */
proto.ProtoMessages.SportsType.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CameraFPSChangeStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CameraFPSChangeStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CameraFPSChangeStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraFPSChangeStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CameraFPSChangeStatus}
 */
proto.ProtoMessages.CameraFPSChangeStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CameraFPSChangeStatus;
  return proto.ProtoMessages.CameraFPSChangeStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CameraFPSChangeStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CameraFPSChangeStatus}
 */
proto.ProtoMessages.CameraFPSChangeStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.CameraFPSChangeStatus.Status} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CameraFPSChangeStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CameraFPSChangeStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CameraFPSChangeStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraFPSChangeStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.CameraFPSChangeStatus.Status = {
  UNKNOWN: 0,
  ALLOW: 1,
  DONOT_ALLOW: 2
};

/**
 * optional Status value = 1;
 * @return {!proto.ProtoMessages.CameraFPSChangeStatus.Status}
 */
proto.ProtoMessages.CameraFPSChangeStatus.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.CameraFPSChangeStatus.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.CameraFPSChangeStatus.Status} value
 * @return {!proto.ProtoMessages.CameraFPSChangeStatus} returns this
 */
proto.ProtoMessages.CameraFPSChangeStatus.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.String.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.String.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.String} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.String.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.String}
 */
proto.ProtoMessages.String.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.String;
  return proto.ProtoMessages.String.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.String} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.String}
 */
proto.ProtoMessages.String.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.String.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.String.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.String} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.String.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.ProtoMessages.String.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.String} returns this
 */
proto.ProtoMessages.String.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.Bool.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.Bool.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.Bool} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Bool.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.Bool.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.Bool;
  return proto.ProtoMessages.Bool.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.Bool} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.Bool.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.Bool.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.Bool.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.Bool} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Bool.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.ProtoMessages.Bool.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.Bool} returns this
 */
proto.ProtoMessages.Bool.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.Float.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.Float.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.Float} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Float.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.Float}
 */
proto.ProtoMessages.Float.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.Float;
  return proto.ProtoMessages.Float.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.Float} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.Float}
 */
proto.ProtoMessages.Float.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.Float.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.Float.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.Float} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Float.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
};


/**
 * optional float value = 1;
 * @return {number}
 */
proto.ProtoMessages.Float.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.Float} returns this
 */
proto.ProtoMessages.Float.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.Double.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.Double.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.Double} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Double.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.Double}
 */
proto.ProtoMessages.Double.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.Double;
  return proto.ProtoMessages.Double.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.Double} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.Double}
 */
proto.ProtoMessages.Double.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.Double.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.Double.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.Double} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Double.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.ProtoMessages.Double.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.Double} returns this
 */
proto.ProtoMessages.Double.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.Uint64.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.Uint64.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.Uint64} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Uint64.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.Uint64}
 */
proto.ProtoMessages.Uint64.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.Uint64;
  return proto.ProtoMessages.Uint64.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.Uint64} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.Uint64}
 */
proto.ProtoMessages.Uint64.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.Uint64.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.Uint64.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.Uint64} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Uint64.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 value = 1;
 * @return {number}
 */
proto.ProtoMessages.Uint64.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.Uint64} returns this
 */
proto.ProtoMessages.Uint64.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.Int64.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.Int64.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.Int64} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Int64.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.Int64}
 */
proto.ProtoMessages.Int64.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.Int64;
  return proto.ProtoMessages.Int64.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.Int64} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.Int64}
 */
proto.ProtoMessages.Int64.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.Int64.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.Int64.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.Int64} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Int64.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.ProtoMessages.Int64.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.Int64} returns this
 */
proto.ProtoMessages.Int64.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.Int32.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.Int32.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.Int32} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Int32.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.Int32}
 */
proto.ProtoMessages.Int32.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.Int32;
  return proto.ProtoMessages.Int32.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.Int32} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.Int32}
 */
proto.ProtoMessages.Int32.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.Int32.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.Int32.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.Int32} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Int32.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.ProtoMessages.Int32.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.Int32} returns this
 */
proto.ProtoMessages.Int32.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CoachingAdditionalAngleInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CoachingAdditionalAngleInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: (f = msg.getName()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    url: (f = msg.getUrl()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    enabled: (f = msg.getEnabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleInfo}
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CoachingAdditionalAngleInfo;
  return proto.ProtoMessages.CoachingAdditionalAngleInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CoachingAdditionalAngleInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleInfo}
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setUrl(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CoachingAdditionalAngleInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CoachingAdditionalAngleInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getUrl();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getEnabled();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional String name = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.getName = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleInfo} returns this
*/
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleInfo} returns this
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional String url = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.getUrl = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleInfo} returns this
*/
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.setUrl = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleInfo} returns this
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.clearUrl = function() {
  return this.setUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.hasUrl = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Bool enabled = 3;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.getEnabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 3));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleInfo} returns this
*/
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.setEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleInfo} returns this
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.clearEnabled = function() {
  return this.setEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CoachingAdditionalAngleInfo.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.CoachingAdditionalAngleList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CoachingAdditionalAngleList.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CoachingAdditionalAngleList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CoachingAdditionalAngleList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CoachingAdditionalAngleList.toObject = function(includeInstance, msg) {
  var f, obj = {
    aadetailsList: jspb.Message.toObjectList(msg.getAadetailsList(),
    proto.ProtoMessages.CoachingAdditionalAngleInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleList}
 */
proto.ProtoMessages.CoachingAdditionalAngleList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CoachingAdditionalAngleList;
  return proto.ProtoMessages.CoachingAdditionalAngleList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CoachingAdditionalAngleList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleList}
 */
proto.ProtoMessages.CoachingAdditionalAngleList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.CoachingAdditionalAngleInfo;
      reader.readMessage(value,proto.ProtoMessages.CoachingAdditionalAngleInfo.deserializeBinaryFromReader);
      msg.addAadetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CoachingAdditionalAngleList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CoachingAdditionalAngleList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CoachingAdditionalAngleList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CoachingAdditionalAngleList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAadetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ProtoMessages.CoachingAdditionalAngleInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CoachingAdditionalAngleInfo aaDetails = 1;
 * @return {!Array<!proto.ProtoMessages.CoachingAdditionalAngleInfo>}
 */
proto.ProtoMessages.CoachingAdditionalAngleList.prototype.getAadetailsList = function() {
  return /** @type{!Array<!proto.ProtoMessages.CoachingAdditionalAngleInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.CoachingAdditionalAngleInfo, 1));
};


/**
 * @param {!Array<!proto.ProtoMessages.CoachingAdditionalAngleInfo>} value
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleList} returns this
*/
proto.ProtoMessages.CoachingAdditionalAngleList.prototype.setAadetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ProtoMessages.CoachingAdditionalAngleInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleInfo}
 */
proto.ProtoMessages.CoachingAdditionalAngleList.prototype.addAadetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ProtoMessages.CoachingAdditionalAngleInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.CoachingAdditionalAngleList} returns this
 */
proto.ProtoMessages.CoachingAdditionalAngleList.prototype.clearAadetailsList = function() {
  return this.setAadetailsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.NasInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.NasInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.NasInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NasInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: (f = msg.getPath()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    copypano: (f = msg.getCopypano()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    copyhd: (f = msg.getCopyhd()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    copyjpeg: (f = msg.getCopyjpeg()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    nasenabled: (f = msg.getNasenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    username: (f = msg.getUsername()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    password: (f = msg.getPassword()) && proto.ProtoMessages.String.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.NasInfo}
 */
proto.ProtoMessages.NasInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.NasInfo;
  return proto.ProtoMessages.NasInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.NasInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.NasInfo}
 */
proto.ProtoMessages.NasInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setPath(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setCopypano(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setCopyhd(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setCopyjpeg(value);
      break;
    case 5:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setNasenabled(value);
      break;
    case 6:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setUsername(value);
      break;
    case 7:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.NasInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.NasInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.NasInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NasInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getCopypano();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getCopyhd();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getCopyjpeg();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getNasenabled();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getUsername();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getPassword();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
};


/**
 * optional String path = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.NasInfo.prototype.getPath = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.NasInfo} returns this
*/
proto.ProtoMessages.NasInfo.prototype.setPath = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NasInfo} returns this
 */
proto.ProtoMessages.NasInfo.prototype.clearPath = function() {
  return this.setPath(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NasInfo.prototype.hasPath = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Bool copyPano = 2;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.NasInfo.prototype.getCopypano = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 2));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.NasInfo} returns this
*/
proto.ProtoMessages.NasInfo.prototype.setCopypano = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NasInfo} returns this
 */
proto.ProtoMessages.NasInfo.prototype.clearCopypano = function() {
  return this.setCopypano(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NasInfo.prototype.hasCopypano = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Bool copyHd = 3;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.NasInfo.prototype.getCopyhd = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 3));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.NasInfo} returns this
*/
proto.ProtoMessages.NasInfo.prototype.setCopyhd = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NasInfo} returns this
 */
proto.ProtoMessages.NasInfo.prototype.clearCopyhd = function() {
  return this.setCopyhd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NasInfo.prototype.hasCopyhd = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Bool copyJpeg = 4;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.NasInfo.prototype.getCopyjpeg = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 4));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.NasInfo} returns this
*/
proto.ProtoMessages.NasInfo.prototype.setCopyjpeg = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NasInfo} returns this
 */
proto.ProtoMessages.NasInfo.prototype.clearCopyjpeg = function() {
  return this.setCopyjpeg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NasInfo.prototype.hasCopyjpeg = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Bool NasEnabled = 5;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.NasInfo.prototype.getNasenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 5));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.NasInfo} returns this
*/
proto.ProtoMessages.NasInfo.prototype.setNasenabled = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NasInfo} returns this
 */
proto.ProtoMessages.NasInfo.prototype.clearNasenabled = function() {
  return this.setNasenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NasInfo.prototype.hasNasenabled = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional String username = 6;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.NasInfo.prototype.getUsername = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 6));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.NasInfo} returns this
*/
proto.ProtoMessages.NasInfo.prototype.setUsername = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NasInfo} returns this
 */
proto.ProtoMessages.NasInfo.prototype.clearUsername = function() {
  return this.setUsername(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NasInfo.prototype.hasUsername = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional String password = 7;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.NasInfo.prototype.getPassword = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 7));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.NasInfo} returns this
*/
proto.ProtoMessages.NasInfo.prototype.setPassword = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NasInfo} returns this
 */
proto.ProtoMessages.NasInfo.prototype.clearPassword = function() {
  return this.setPassword(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NasInfo.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.NetworkConfigType.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.NetworkConfigType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.NetworkConfigType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NetworkConfigType.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.NetworkConfigType}
 */
proto.ProtoMessages.NetworkConfigType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.NetworkConfigType;
  return proto.ProtoMessages.NetworkConfigType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.NetworkConfigType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.NetworkConfigType}
 */
proto.ProtoMessages.NetworkConfigType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.NetworkConfigType.Type} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.NetworkConfigType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.NetworkConfigType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.NetworkConfigType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NetworkConfigType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.NetworkConfigType.Type = {
  DHCP: 0,
  STATIC: 1
};

/**
 * optional Type value = 1;
 * @return {!proto.ProtoMessages.NetworkConfigType.Type}
 */
proto.ProtoMessages.NetworkConfigType.prototype.getValue = function() {
  return /** @type {!proto.ProtoMessages.NetworkConfigType.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.NetworkConfigType.Type} value
 * @return {!proto.ProtoMessages.NetworkConfigType} returns this
 */
proto.ProtoMessages.NetworkConfigType.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.NetworkInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.NetworkInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.NetworkInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NetworkInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    networktype: (f = msg.getNetworktype()) && proto.ProtoMessages.NetworkConfigType.toObject(includeInstance, f),
    ipaddress: (f = msg.getIpaddress()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    subnetmask: (f = msg.getSubnetmask()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    deafultgateway: (f = msg.getDeafultgateway()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    dns1: (f = msg.getDns1()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    dns2: (f = msg.getDns2()) && proto.ProtoMessages.String.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.NetworkInfo}
 */
proto.ProtoMessages.NetworkInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.NetworkInfo;
  return proto.ProtoMessages.NetworkInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.NetworkInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.NetworkInfo}
 */
proto.ProtoMessages.NetworkInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.NetworkConfigType;
      reader.readMessage(value,proto.ProtoMessages.NetworkConfigType.deserializeBinaryFromReader);
      msg.setNetworktype(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setIpaddress(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setSubnetmask(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setDeafultgateway(value);
      break;
    case 5:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setDns1(value);
      break;
    case 6:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setDns2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.NetworkInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.NetworkInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.NetworkInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NetworkInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworktype();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.NetworkConfigType.serializeBinaryToWriter
    );
  }
  f = message.getIpaddress();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getSubnetmask();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getDeafultgateway();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getDns1();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getDns2();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
};


/**
 * optional NetworkConfigType networkType = 1;
 * @return {?proto.ProtoMessages.NetworkConfigType}
 */
proto.ProtoMessages.NetworkInfo.prototype.getNetworktype = function() {
  return /** @type{?proto.ProtoMessages.NetworkConfigType} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.NetworkConfigType, 1));
};


/**
 * @param {?proto.ProtoMessages.NetworkConfigType|undefined} value
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
*/
proto.ProtoMessages.NetworkInfo.prototype.setNetworktype = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
 */
proto.ProtoMessages.NetworkInfo.prototype.clearNetworktype = function() {
  return this.setNetworktype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NetworkInfo.prototype.hasNetworktype = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional String ipAddress = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.NetworkInfo.prototype.getIpaddress = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
*/
proto.ProtoMessages.NetworkInfo.prototype.setIpaddress = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
 */
proto.ProtoMessages.NetworkInfo.prototype.clearIpaddress = function() {
  return this.setIpaddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NetworkInfo.prototype.hasIpaddress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional String subnetMask = 3;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.NetworkInfo.prototype.getSubnetmask = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 3));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
*/
proto.ProtoMessages.NetworkInfo.prototype.setSubnetmask = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
 */
proto.ProtoMessages.NetworkInfo.prototype.clearSubnetmask = function() {
  return this.setSubnetmask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NetworkInfo.prototype.hasSubnetmask = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional String deafultGateway = 4;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.NetworkInfo.prototype.getDeafultgateway = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 4));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
*/
proto.ProtoMessages.NetworkInfo.prototype.setDeafultgateway = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
 */
proto.ProtoMessages.NetworkInfo.prototype.clearDeafultgateway = function() {
  return this.setDeafultgateway(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NetworkInfo.prototype.hasDeafultgateway = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional String dns1 = 5;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.NetworkInfo.prototype.getDns1 = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 5));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
*/
proto.ProtoMessages.NetworkInfo.prototype.setDns1 = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
 */
proto.ProtoMessages.NetworkInfo.prototype.clearDns1 = function() {
  return this.setDns1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NetworkInfo.prototype.hasDns1 = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional String dns2 = 6;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.NetworkInfo.prototype.getDns2 = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 6));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
*/
proto.ProtoMessages.NetworkInfo.prototype.setDns2 = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.NetworkInfo} returns this
 */
proto.ProtoMessages.NetworkInfo.prototype.clearDns2 = function() {
  return this.setDns2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.NetworkInfo.prototype.hasDns2 = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.CommandMessage.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CommandMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CommandMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CommandMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CommandMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    formatjpegrecordings: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    formatlocalrecordings: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    resetpoe: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    restartvpu: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    startvpu: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    stopvpu: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    restartcomputer: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    sendpanoramarequest: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    sendccupresetsrequest: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    deletepreset: (f = msg.getDeletepreset()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    savepreset: (f = msg.getSavepreset()) && proto.ProtoMessages.CCUPreset.toObject(includeInstance, f),
    requestporttestingList: jspb.Message.toObjectList(msg.getRequestporttestingList(),
    proto.ProtoMessages.TestPorts.toObject, includeInstance),
    getcameras: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    restorecameraparams: (f = msg.getRestorecameraparams()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    sendheadsetupframesrequest: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    requestostype: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    restartpip: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    restartcoordinator: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    restartcg: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    restartagent: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    updatelastcalibrationtime: jspb.Message.getBooleanFieldWithDefault(msg, 21, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CommandMessage}
 */
proto.ProtoMessages.CommandMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CommandMessage;
  return proto.ProtoMessages.CommandMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CommandMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CommandMessage}
 */
proto.ProtoMessages.CommandMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFormatjpegrecordings(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFormatlocalrecordings(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResetpoe(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRestartvpu(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStartvpu(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStopvpu(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRestartcomputer(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendpanoramarequest(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendccupresetsrequest(value);
      break;
    case 10:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setDeletepreset(value);
      break;
    case 11:
      var value = new proto.ProtoMessages.CCUPreset;
      reader.readMessage(value,proto.ProtoMessages.CCUPreset.deserializeBinaryFromReader);
      msg.setSavepreset(value);
      break;
    case 12:
      var value = new proto.ProtoMessages.TestPorts;
      reader.readMessage(value,proto.ProtoMessages.TestPorts.deserializeBinaryFromReader);
      msg.addRequestporttesting(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGetcameras(value);
      break;
    case 14:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setRestorecameraparams(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendheadsetupframesrequest(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestostype(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRestartpip(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRestartcoordinator(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRestartcg(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRestartagent(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUpdatelastcalibrationtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CommandMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CommandMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CommandMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CommandMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFormatjpegrecordings();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getFormatlocalrecordings();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getResetpoe();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getRestartvpu();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getStartvpu();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getStopvpu();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getRestartcomputer();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getSendpanoramarequest();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getSendccupresetsrequest();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDeletepreset();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getSavepreset();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ProtoMessages.CCUPreset.serializeBinaryToWriter
    );
  }
  f = message.getRequestporttestingList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.ProtoMessages.TestPorts.serializeBinaryToWriter
    );
  }
  f = message.getGetcameras();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getRestorecameraparams();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getSendheadsetupframesrequest();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getRequestostype();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getRestartpip();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getRestartcoordinator();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getRestartcg();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getRestartagent();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getUpdatelastcalibrationtime();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
};


/**
 * optional bool formatJpegRecordings = 1;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getFormatjpegrecordings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setFormatjpegrecordings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool formatLocalRecordings = 2;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getFormatlocalrecordings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setFormatlocalrecordings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool resetPoe = 3;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getResetpoe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setResetpoe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool restartVpu = 4;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getRestartvpu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setRestartvpu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool startVpu = 5;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getStartvpu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setStartvpu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool stopVpu = 6;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getStopvpu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setStopvpu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool restartComputer = 7;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getRestartcomputer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setRestartcomputer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool sendPanoramaRequest = 8;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getSendpanoramarequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setSendpanoramarequest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool sendCcuPresetsRequest = 9;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getSendccupresetsrequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setSendccupresetsrequest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional String deletePreset = 10;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CommandMessage.prototype.getDeletepreset = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 10));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
*/
proto.ProtoMessages.CommandMessage.prototype.setDeletepreset = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.clearDeletepreset = function() {
  return this.setDeletepreset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.hasDeletepreset = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional CCUPreset savePreset = 11;
 * @return {?proto.ProtoMessages.CCUPreset}
 */
proto.ProtoMessages.CommandMessage.prototype.getSavepreset = function() {
  return /** @type{?proto.ProtoMessages.CCUPreset} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CCUPreset, 11));
};


/**
 * @param {?proto.ProtoMessages.CCUPreset|undefined} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
*/
proto.ProtoMessages.CommandMessage.prototype.setSavepreset = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.clearSavepreset = function() {
  return this.setSavepreset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.hasSavepreset = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * repeated TestPorts requestPortTesting = 12;
 * @return {!Array<!proto.ProtoMessages.TestPorts>}
 */
proto.ProtoMessages.CommandMessage.prototype.getRequestporttestingList = function() {
  return /** @type{!Array<!proto.ProtoMessages.TestPorts>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.TestPorts, 12));
};


/**
 * @param {!Array<!proto.ProtoMessages.TestPorts>} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
*/
proto.ProtoMessages.CommandMessage.prototype.setRequestporttestingList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.ProtoMessages.TestPorts=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.TestPorts}
 */
proto.ProtoMessages.CommandMessage.prototype.addRequestporttesting = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.ProtoMessages.TestPorts, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.clearRequestporttestingList = function() {
  return this.setRequestporttestingList([]);
};


/**
 * optional bool getCameras = 13;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getGetcameras = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setGetcameras = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional String restoreCameraParams = 14;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CommandMessage.prototype.getRestorecameraparams = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 14));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
*/
proto.ProtoMessages.CommandMessage.prototype.setRestorecameraparams = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.clearRestorecameraparams = function() {
  return this.setRestorecameraparams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.hasRestorecameraparams = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional bool sendHeadSetupFramesRequest = 15;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getSendheadsetupframesrequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setSendheadsetupframesrequest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool requestOsType = 16;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getRequestostype = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setRequestostype = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool restartPip = 17;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getRestartpip = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setRestartpip = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional bool restartCoordinator = 18;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getRestartcoordinator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setRestartcoordinator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional bool restartCg = 19;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getRestartcg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setRestartcg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional bool restartAgent = 20;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getRestartagent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setRestartagent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional bool updateLastCalibrationTime = 21;
 * @return {boolean}
 */
proto.ProtoMessages.CommandMessage.prototype.getUpdatelastcalibrationtime = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CommandMessage} returns this
 */
proto.ProtoMessages.CommandMessage.prototype.setUpdatelastcalibrationtime = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CameraInformation.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CameraInformation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CameraInformation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraInformation.toObject = function(includeInstance, msg) {
  var f, obj = {
    firmwareversion: (f = msg.getFirmwareversion()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    uid: (f = msg.getUid()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    speed: (f = msg.getSpeed()) && proto.ProtoMessages.Uint64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CameraInformation}
 */
proto.ProtoMessages.CameraInformation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CameraInformation;
  return proto.ProtoMessages.CameraInformation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CameraInformation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CameraInformation}
 */
proto.ProtoMessages.CameraInformation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setFirmwareversion(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setUid(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Uint64;
      reader.readMessage(value,proto.ProtoMessages.Uint64.deserializeBinaryFromReader);
      msg.setSpeed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CameraInformation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CameraInformation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CameraInformation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraInformation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirmwareversion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getUid();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getSpeed();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Uint64.serializeBinaryToWriter
    );
  }
};


/**
 * optional String firmwareVersion = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CameraInformation.prototype.getFirmwareversion = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CameraInformation} returns this
*/
proto.ProtoMessages.CameraInformation.prototype.setFirmwareversion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraInformation} returns this
 */
proto.ProtoMessages.CameraInformation.prototype.clearFirmwareversion = function() {
  return this.setFirmwareversion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraInformation.prototype.hasFirmwareversion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional String uid = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CameraInformation.prototype.getUid = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CameraInformation} returns this
*/
proto.ProtoMessages.CameraInformation.prototype.setUid = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraInformation} returns this
 */
proto.ProtoMessages.CameraInformation.prototype.clearUid = function() {
  return this.setUid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraInformation.prototype.hasUid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Uint64 speed = 3;
 * @return {?proto.ProtoMessages.Uint64}
 */
proto.ProtoMessages.CameraInformation.prototype.getSpeed = function() {
  return /** @type{?proto.ProtoMessages.Uint64} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Uint64, 3));
};


/**
 * @param {?proto.ProtoMessages.Uint64|undefined} value
 * @return {!proto.ProtoMessages.CameraInformation} returns this
*/
proto.ProtoMessages.CameraInformation.prototype.setSpeed = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraInformation} returns this
 */
proto.ProtoMessages.CameraInformation.prototype.clearSpeed = function() {
  return this.setSpeed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraInformation.prototype.hasSpeed = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.ConfigurationParameter.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.ConfigurationParameter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.ConfigurationParameter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ConfigurationParameter.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, ""),
    defaultvalue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    description: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.ConfigurationParameter}
 */
proto.ProtoMessages.ConfigurationParameter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.ConfigurationParameter;
  return proto.ProtoMessages.ConfigurationParameter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.ConfigurationParameter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.ConfigurationParameter}
 */
proto.ProtoMessages.ConfigurationParameter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultvalue(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.ConfigurationParameter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.ConfigurationParameter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.ConfigurationParameter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ConfigurationParameter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDefaultvalue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.ProtoMessages.ConfigurationParameter.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.ConfigurationParameter} returns this
 */
proto.ProtoMessages.ConfigurationParameter.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.ProtoMessages.ConfigurationParameter.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.ConfigurationParameter} returns this
 */
proto.ProtoMessages.ConfigurationParameter.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.ProtoMessages.ConfigurationParameter.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.ConfigurationParameter} returns this
 */
proto.ProtoMessages.ConfigurationParameter.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string defaultValue = 4;
 * @return {string}
 */
proto.ProtoMessages.ConfigurationParameter.prototype.getDefaultvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.ConfigurationParameter} returns this
 */
proto.ProtoMessages.ConfigurationParameter.prototype.setDefaultvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool enabled = 5;
 * @return {boolean}
 */
proto.ProtoMessages.ConfigurationParameter.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.ConfigurationParameter} returns this
 */
proto.ProtoMessages.ConfigurationParameter.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.ProtoMessages.ConfigurationParameter.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.ConfigurationParameter} returns this
 */
proto.ProtoMessages.ConfigurationParameter.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.ConfigurationMessage.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.ConfigurationMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.ConfigurationMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.ConfigurationMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ConfigurationMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: jspb.Message.getFieldWithDefault(msg, 1, 0),
    configparamList: jspb.Message.toObjectList(msg.getConfigparamList(),
    proto.ProtoMessages.ConfigurationParameter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.ConfigurationMessage}
 */
proto.ProtoMessages.ConfigurationMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.ConfigurationMessage;
  return proto.ProtoMessages.ConfigurationMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.ConfigurationMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.ConfigurationMessage}
 */
proto.ProtoMessages.ConfigurationMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.ConfigurationAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.ConfigurationParameter;
      reader.readMessage(value,proto.ProtoMessages.ConfigurationParameter.deserializeBinaryFromReader);
      msg.addConfigparam(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.ConfigurationMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.ConfigurationMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.ConfigurationMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ConfigurationMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getConfigparamList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.ProtoMessages.ConfigurationParameter.serializeBinaryToWriter
    );
  }
};


/**
 * optional ConfigurationAction action = 1;
 * @return {!proto.ProtoMessages.ConfigurationAction}
 */
proto.ProtoMessages.ConfigurationMessage.prototype.getAction = function() {
  return /** @type {!proto.ProtoMessages.ConfigurationAction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.ConfigurationAction} value
 * @return {!proto.ProtoMessages.ConfigurationMessage} returns this
 */
proto.ProtoMessages.ConfigurationMessage.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated ConfigurationParameter configParam = 2;
 * @return {!Array<!proto.ProtoMessages.ConfigurationParameter>}
 */
proto.ProtoMessages.ConfigurationMessage.prototype.getConfigparamList = function() {
  return /** @type{!Array<!proto.ProtoMessages.ConfigurationParameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.ConfigurationParameter, 2));
};


/**
 * @param {!Array<!proto.ProtoMessages.ConfigurationParameter>} value
 * @return {!proto.ProtoMessages.ConfigurationMessage} returns this
*/
proto.ProtoMessages.ConfigurationMessage.prototype.setConfigparamList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ProtoMessages.ConfigurationParameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.ConfigurationParameter}
 */
proto.ProtoMessages.ConfigurationMessage.prototype.addConfigparam = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ProtoMessages.ConfigurationParameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.ConfigurationMessage} returns this
 */
proto.ProtoMessages.ConfigurationMessage.prototype.clearConfigparamList = function() {
  return this.setConfigparamList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.ConfigurationHistoryParameter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.ConfigurationHistoryParameter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ConfigurationHistoryParameter.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    changeddate: jspb.Message.getFieldWithDefault(msg, 2, 0),
    oldvalue: jspb.Message.getFieldWithDefault(msg, 3, ""),
    newvalue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    changedby: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.ConfigurationHistoryParameter}
 */
proto.ProtoMessages.ConfigurationHistoryParameter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.ConfigurationHistoryParameter;
  return proto.ProtoMessages.ConfigurationHistoryParameter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.ConfigurationHistoryParameter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.ConfigurationHistoryParameter}
 */
proto.ProtoMessages.ConfigurationHistoryParameter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChangeddate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOldvalue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewvalue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangedby(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.ConfigurationHistoryParameter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.ConfigurationHistoryParameter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ConfigurationHistoryParameter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChangeddate();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOldvalue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNewvalue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getChangedby();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.ConfigurationHistoryParameter} returns this
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 changedDate = 2;
 * @return {number}
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.getChangeddate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.ConfigurationHistoryParameter} returns this
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.setChangeddate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string oldValue = 3;
 * @return {string}
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.getOldvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.ConfigurationHistoryParameter} returns this
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.setOldvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string newValue = 4;
 * @return {string}
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.getNewvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.ConfigurationHistoryParameter} returns this
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.setNewvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string changedBy = 5;
 * @return {string}
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.getChangedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.ConfigurationHistoryParameter} returns this
 */
proto.ProtoMessages.ConfigurationHistoryParameter.prototype.setChangedby = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.ConfigurationHistoryMessage.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.ConfigurationHistoryMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.ConfigurationHistoryMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.ConfigurationHistoryMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ConfigurationHistoryMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: jspb.Message.getFieldWithDefault(msg, 1, 0),
    configparamList: jspb.Message.toObjectList(msg.getConfigparamList(),
    proto.ProtoMessages.ConfigurationHistoryParameter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.ConfigurationHistoryMessage}
 */
proto.ProtoMessages.ConfigurationHistoryMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.ConfigurationHistoryMessage;
  return proto.ProtoMessages.ConfigurationHistoryMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.ConfigurationHistoryMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.ConfigurationHistoryMessage}
 */
proto.ProtoMessages.ConfigurationHistoryMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.ConfigurationAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.ConfigurationHistoryParameter;
      reader.readMessage(value,proto.ProtoMessages.ConfigurationHistoryParameter.deserializeBinaryFromReader);
      msg.addConfigparam(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.ConfigurationHistoryMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.ConfigurationHistoryMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.ConfigurationHistoryMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ConfigurationHistoryMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getConfigparamList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.ProtoMessages.ConfigurationHistoryParameter.serializeBinaryToWriter
    );
  }
};


/**
 * optional ConfigurationAction action = 1;
 * @return {!proto.ProtoMessages.ConfigurationAction}
 */
proto.ProtoMessages.ConfigurationHistoryMessage.prototype.getAction = function() {
  return /** @type {!proto.ProtoMessages.ConfigurationAction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.ConfigurationAction} value
 * @return {!proto.ProtoMessages.ConfigurationHistoryMessage} returns this
 */
proto.ProtoMessages.ConfigurationHistoryMessage.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated ConfigurationHistoryParameter configParam = 2;
 * @return {!Array<!proto.ProtoMessages.ConfigurationHistoryParameter>}
 */
proto.ProtoMessages.ConfigurationHistoryMessage.prototype.getConfigparamList = function() {
  return /** @type{!Array<!proto.ProtoMessages.ConfigurationHistoryParameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.ConfigurationHistoryParameter, 2));
};


/**
 * @param {!Array<!proto.ProtoMessages.ConfigurationHistoryParameter>} value
 * @return {!proto.ProtoMessages.ConfigurationHistoryMessage} returns this
*/
proto.ProtoMessages.ConfigurationHistoryMessage.prototype.setConfigparamList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ProtoMessages.ConfigurationHistoryParameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.ConfigurationHistoryParameter}
 */
proto.ProtoMessages.ConfigurationHistoryMessage.prototype.addConfigparam = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ProtoMessages.ConfigurationHistoryParameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.ConfigurationHistoryMessage} returns this
 */
proto.ProtoMessages.ConfigurationHistoryMessage.prototype.clearConfigparamList = function() {
  return this.setConfigparamList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.GeneralMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.GeneralMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.GeneralMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.GeneralMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    messagetype: (f = msg.getMessagetype()) && proto.ProtoMessages.MessageType.toObject(includeInstance, f),
    statusinformationmessage: (f = msg.getStatusinformationmessage()) && proto.ProtoMessages.StatusInformationMessage.toObject(includeInstance, f),
    realtimeinformationmessage: (f = msg.getRealtimeinformationmessage()) && proto.ProtoMessages.RealtimeInformationMessage.toObject(includeInstance, f),
    staticinformationmessage: (f = msg.getStaticinformationmessage()) && proto.ProtoMessages.StaticInformationMessage.toObject(includeInstance, f),
    commandmessage: (f = msg.getCommandmessage()) && proto.ProtoMessages.CommandMessage.toObject(includeInstance, f),
    coachingadditionalanglemessage: (f = msg.getCoachingadditionalanglemessage()) && proto.ProtoMessages.CoachingAdditionalAngleList.toObject(includeInstance, f),
    fileimportexportfile: (f = msg.getFileimportexportfile()) && proto.ProtoMessages.FileTransferMessage.toObject(includeInstance, f),
    versionmessage: (f = msg.getVersionmessage()) && proto.ProtoMessages.VersionMessage.toObject(includeInstance, f),
    singleparaminformationmessage: (f = msg.getSingleparaminformationmessage()) && proto.ProtoMessages.SingleParamInformationMessage.toObject(includeInstance, f),
    ccuupdatemessage: (f = msg.getCcuupdatemessage()) && proto.ProtoMessages.CcuUpdateMessage.toObject(includeInstance, f),
    configurationaction: (f = msg.getConfigurationaction()) && proto.ProtoMessages.ConfigurationMessage.toObject(includeInstance, f),
    networktestrequest: (f = msg.getNetworktestrequest()) && proto.ProtoMessages.NetworkTestRequest.toObject(includeInstance, f),
    networkvalidation: (f = msg.getNetworkvalidation()) && proto.ProtoMessages.NetworkValidation.toObject(includeInstance, f),
    operatingsystemmessage: (f = msg.getOperatingsystemmessage()) && proto.ProtoMessages.OperatingSystemMessage.toObject(includeInstance, f),
    configurationhistoryaction: (f = msg.getConfigurationhistoryaction()) && proto.ProtoMessages.ConfigurationHistoryMessage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.GeneralMessage}
 */
proto.ProtoMessages.GeneralMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.GeneralMessage;
  return proto.ProtoMessages.GeneralMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.GeneralMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.GeneralMessage}
 */
proto.ProtoMessages.GeneralMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.MessageType;
      reader.readMessage(value,proto.ProtoMessages.MessageType.deserializeBinaryFromReader);
      msg.setMessagetype(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.StatusInformationMessage;
      reader.readMessage(value,proto.ProtoMessages.StatusInformationMessage.deserializeBinaryFromReader);
      msg.setStatusinformationmessage(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.RealtimeInformationMessage;
      reader.readMessage(value,proto.ProtoMessages.RealtimeInformationMessage.deserializeBinaryFromReader);
      msg.setRealtimeinformationmessage(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.StaticInformationMessage;
      reader.readMessage(value,proto.ProtoMessages.StaticInformationMessage.deserializeBinaryFromReader);
      msg.setStaticinformationmessage(value);
      break;
    case 5:
      var value = new proto.ProtoMessages.CommandMessage;
      reader.readMessage(value,proto.ProtoMessages.CommandMessage.deserializeBinaryFromReader);
      msg.setCommandmessage(value);
      break;
    case 6:
      var value = new proto.ProtoMessages.CoachingAdditionalAngleList;
      reader.readMessage(value,proto.ProtoMessages.CoachingAdditionalAngleList.deserializeBinaryFromReader);
      msg.setCoachingadditionalanglemessage(value);
      break;
    case 7:
      var value = new proto.ProtoMessages.FileTransferMessage;
      reader.readMessage(value,proto.ProtoMessages.FileTransferMessage.deserializeBinaryFromReader);
      msg.setFileimportexportfile(value);
      break;
    case 8:
      var value = new proto.ProtoMessages.VersionMessage;
      reader.readMessage(value,proto.ProtoMessages.VersionMessage.deserializeBinaryFromReader);
      msg.setVersionmessage(value);
      break;
    case 9:
      var value = new proto.ProtoMessages.SingleParamInformationMessage;
      reader.readMessage(value,proto.ProtoMessages.SingleParamInformationMessage.deserializeBinaryFromReader);
      msg.setSingleparaminformationmessage(value);
      break;
    case 10:
      var value = new proto.ProtoMessages.CcuUpdateMessage;
      reader.readMessage(value,proto.ProtoMessages.CcuUpdateMessage.deserializeBinaryFromReader);
      msg.setCcuupdatemessage(value);
      break;
    case 12:
      var value = new proto.ProtoMessages.ConfigurationMessage;
      reader.readMessage(value,proto.ProtoMessages.ConfigurationMessage.deserializeBinaryFromReader);
      msg.setConfigurationaction(value);
      break;
    case 14:
      var value = new proto.ProtoMessages.NetworkTestRequest;
      reader.readMessage(value,proto.ProtoMessages.NetworkTestRequest.deserializeBinaryFromReader);
      msg.setNetworktestrequest(value);
      break;
    case 16:
      var value = new proto.ProtoMessages.NetworkValidation;
      reader.readMessage(value,proto.ProtoMessages.NetworkValidation.deserializeBinaryFromReader);
      msg.setNetworkvalidation(value);
      break;
    case 17:
      var value = new proto.ProtoMessages.OperatingSystemMessage;
      reader.readMessage(value,proto.ProtoMessages.OperatingSystemMessage.deserializeBinaryFromReader);
      msg.setOperatingsystemmessage(value);
      break;
    case 18:
      var value = new proto.ProtoMessages.ConfigurationHistoryMessage;
      reader.readMessage(value,proto.ProtoMessages.ConfigurationHistoryMessage.deserializeBinaryFromReader);
      msg.setConfigurationhistoryaction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.GeneralMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.GeneralMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.GeneralMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.GeneralMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagetype();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.MessageType.serializeBinaryToWriter
    );
  }
  f = message.getStatusinformationmessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.StatusInformationMessage.serializeBinaryToWriter
    );
  }
  f = message.getRealtimeinformationmessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.RealtimeInformationMessage.serializeBinaryToWriter
    );
  }
  f = message.getStaticinformationmessage();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.StaticInformationMessage.serializeBinaryToWriter
    );
  }
  f = message.getCommandmessage();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ProtoMessages.CommandMessage.serializeBinaryToWriter
    );
  }
  f = message.getCoachingadditionalanglemessage();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ProtoMessages.CoachingAdditionalAngleList.serializeBinaryToWriter
    );
  }
  f = message.getFileimportexportfile();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ProtoMessages.FileTransferMessage.serializeBinaryToWriter
    );
  }
  f = message.getVersionmessage();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ProtoMessages.VersionMessage.serializeBinaryToWriter
    );
  }
  f = message.getSingleparaminformationmessage();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ProtoMessages.SingleParamInformationMessage.serializeBinaryToWriter
    );
  }
  f = message.getCcuupdatemessage();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ProtoMessages.CcuUpdateMessage.serializeBinaryToWriter
    );
  }
  f = message.getConfigurationaction();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ProtoMessages.ConfigurationMessage.serializeBinaryToWriter
    );
  }
  f = message.getNetworktestrequest();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.ProtoMessages.NetworkTestRequest.serializeBinaryToWriter
    );
  }
  f = message.getNetworkvalidation();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.ProtoMessages.NetworkValidation.serializeBinaryToWriter
    );
  }
  f = message.getOperatingsystemmessage();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.ProtoMessages.OperatingSystemMessage.serializeBinaryToWriter
    );
  }
  f = message.getConfigurationhistoryaction();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.ProtoMessages.ConfigurationHistoryMessage.serializeBinaryToWriter
    );
  }
};


/**
 * optional MessageType messageType = 1;
 * @return {?proto.ProtoMessages.MessageType}
 */
proto.ProtoMessages.GeneralMessage.prototype.getMessagetype = function() {
  return /** @type{?proto.ProtoMessages.MessageType} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.MessageType, 1));
};


/**
 * @param {?proto.ProtoMessages.MessageType|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setMessagetype = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearMessagetype = function() {
  return this.setMessagetype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasMessagetype = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional StatusInformationMessage statusInformationMessage = 2;
 * @return {?proto.ProtoMessages.StatusInformationMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getStatusinformationmessage = function() {
  return /** @type{?proto.ProtoMessages.StatusInformationMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.StatusInformationMessage, 2));
};


/**
 * @param {?proto.ProtoMessages.StatusInformationMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setStatusinformationmessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearStatusinformationmessage = function() {
  return this.setStatusinformationmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasStatusinformationmessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RealtimeInformationMessage realtimeInformationMessage = 3;
 * @return {?proto.ProtoMessages.RealtimeInformationMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getRealtimeinformationmessage = function() {
  return /** @type{?proto.ProtoMessages.RealtimeInformationMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.RealtimeInformationMessage, 3));
};


/**
 * @param {?proto.ProtoMessages.RealtimeInformationMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setRealtimeinformationmessage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearRealtimeinformationmessage = function() {
  return this.setRealtimeinformationmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasRealtimeinformationmessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional StaticInformationMessage staticInformationMessage = 4;
 * @return {?proto.ProtoMessages.StaticInformationMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getStaticinformationmessage = function() {
  return /** @type{?proto.ProtoMessages.StaticInformationMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.StaticInformationMessage, 4));
};


/**
 * @param {?proto.ProtoMessages.StaticInformationMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setStaticinformationmessage = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearStaticinformationmessage = function() {
  return this.setStaticinformationmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasStaticinformationmessage = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional CommandMessage commandMessage = 5;
 * @return {?proto.ProtoMessages.CommandMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getCommandmessage = function() {
  return /** @type{?proto.ProtoMessages.CommandMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CommandMessage, 5));
};


/**
 * @param {?proto.ProtoMessages.CommandMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setCommandmessage = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearCommandmessage = function() {
  return this.setCommandmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasCommandmessage = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional CoachingAdditionalAngleList coachingAdditionalAngleMessage = 6;
 * @return {?proto.ProtoMessages.CoachingAdditionalAngleList}
 */
proto.ProtoMessages.GeneralMessage.prototype.getCoachingadditionalanglemessage = function() {
  return /** @type{?proto.ProtoMessages.CoachingAdditionalAngleList} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CoachingAdditionalAngleList, 6));
};


/**
 * @param {?proto.ProtoMessages.CoachingAdditionalAngleList|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setCoachingadditionalanglemessage = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearCoachingadditionalanglemessage = function() {
  return this.setCoachingadditionalanglemessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasCoachingadditionalanglemessage = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional FileTransferMessage fileImportExportFile = 7;
 * @return {?proto.ProtoMessages.FileTransferMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getFileimportexportfile = function() {
  return /** @type{?proto.ProtoMessages.FileTransferMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.FileTransferMessage, 7));
};


/**
 * @param {?proto.ProtoMessages.FileTransferMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setFileimportexportfile = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearFileimportexportfile = function() {
  return this.setFileimportexportfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasFileimportexportfile = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional VersionMessage versionMessage = 8;
 * @return {?proto.ProtoMessages.VersionMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getVersionmessage = function() {
  return /** @type{?proto.ProtoMessages.VersionMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.VersionMessage, 8));
};


/**
 * @param {?proto.ProtoMessages.VersionMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setVersionmessage = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearVersionmessage = function() {
  return this.setVersionmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasVersionmessage = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional SingleParamInformationMessage singleParamInformationMessage = 9;
 * @return {?proto.ProtoMessages.SingleParamInformationMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getSingleparaminformationmessage = function() {
  return /** @type{?proto.ProtoMessages.SingleParamInformationMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.SingleParamInformationMessage, 9));
};


/**
 * @param {?proto.ProtoMessages.SingleParamInformationMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setSingleparaminformationmessage = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearSingleparaminformationmessage = function() {
  return this.setSingleparaminformationmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasSingleparaminformationmessage = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional CcuUpdateMessage ccuUpdateMessage = 10;
 * @return {?proto.ProtoMessages.CcuUpdateMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getCcuupdatemessage = function() {
  return /** @type{?proto.ProtoMessages.CcuUpdateMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CcuUpdateMessage, 10));
};


/**
 * @param {?proto.ProtoMessages.CcuUpdateMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setCcuupdatemessage = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearCcuupdatemessage = function() {
  return this.setCcuupdatemessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasCcuupdatemessage = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional ConfigurationMessage configurationAction = 12;
 * @return {?proto.ProtoMessages.ConfigurationMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getConfigurationaction = function() {
  return /** @type{?proto.ProtoMessages.ConfigurationMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.ConfigurationMessage, 12));
};


/**
 * @param {?proto.ProtoMessages.ConfigurationMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setConfigurationaction = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearConfigurationaction = function() {
  return this.setConfigurationaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasConfigurationaction = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional NetworkTestRequest networkTestRequest = 14;
 * @return {?proto.ProtoMessages.NetworkTestRequest}
 */
proto.ProtoMessages.GeneralMessage.prototype.getNetworktestrequest = function() {
  return /** @type{?proto.ProtoMessages.NetworkTestRequest} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.NetworkTestRequest, 14));
};


/**
 * @param {?proto.ProtoMessages.NetworkTestRequest|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setNetworktestrequest = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearNetworktestrequest = function() {
  return this.setNetworktestrequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasNetworktestrequest = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional NetworkValidation networkValidation = 16;
 * @return {?proto.ProtoMessages.NetworkValidation}
 */
proto.ProtoMessages.GeneralMessage.prototype.getNetworkvalidation = function() {
  return /** @type{?proto.ProtoMessages.NetworkValidation} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.NetworkValidation, 16));
};


/**
 * @param {?proto.ProtoMessages.NetworkValidation|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setNetworkvalidation = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearNetworkvalidation = function() {
  return this.setNetworkvalidation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasNetworkvalidation = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional OperatingSystemMessage operatingSystemMessage = 17;
 * @return {?proto.ProtoMessages.OperatingSystemMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getOperatingsystemmessage = function() {
  return /** @type{?proto.ProtoMessages.OperatingSystemMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.OperatingSystemMessage, 17));
};


/**
 * @param {?proto.ProtoMessages.OperatingSystemMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setOperatingsystemmessage = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearOperatingsystemmessage = function() {
  return this.setOperatingsystemmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasOperatingsystemmessage = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional ConfigurationHistoryMessage configurationHistoryAction = 18;
 * @return {?proto.ProtoMessages.ConfigurationHistoryMessage}
 */
proto.ProtoMessages.GeneralMessage.prototype.getConfigurationhistoryaction = function() {
  return /** @type{?proto.ProtoMessages.ConfigurationHistoryMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.ConfigurationHistoryMessage, 18));
};


/**
 * @param {?proto.ProtoMessages.ConfigurationHistoryMessage|undefined} value
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
*/
proto.ProtoMessages.GeneralMessage.prototype.setConfigurationhistoryaction = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GeneralMessage} returns this
 */
proto.ProtoMessages.GeneralMessage.prototype.clearConfigurationhistoryaction = function() {
  return this.setConfigurationhistoryaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GeneralMessage.prototype.hasConfigurationhistoryaction = function() {
  return jspb.Message.getField(this, 18) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.StatusInformationMessage.repeatedFields_ = [34];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.StatusInformationMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.StatusInformationMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.StatusInformationMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    systemstatus: (f = msg.getSystemstatus()) && proto.ProtoMessages.GeneralStatus.toObject(includeInstance, f),
    vpustatus: (f = msg.getVpustatus()) && proto.ProtoMessages.VpuStatus.toObject(includeInstance, f),
    systemmode: (f = msg.getSystemmode()) && proto.ProtoMessages.SystemMode.toObject(includeInstance, f),
    workinghours: (f = msg.getWorkinghours()) && proto.ProtoMessages.WorkingHours.toObject(includeInstance, f),
    streamsinfo: (f = msg.getStreamsinfo()) && proto.ProtoMessages.StreamsInfo.toObject(includeInstance, f),
    currentevent: (f = msg.getCurrentevent()) && proto.ProtoMessages.EventInfo.toObject(includeInstance, f),
    upcomingevent: (f = msg.getUpcomingevent()) && proto.ProtoMessages.EventInfo.toObject(includeInstance, f),
    sportstype: (f = msg.getSportstype()) && proto.ProtoMessages.SportsType.toObject(includeInstance, f),
    highlightsenabled: (f = msg.getHighlightsenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    graphicsinfo: (f = msg.getGraphicsinfo()) && proto.ProtoMessages.GraphicEngineInfo.toObject(includeInstance, f),
    manualcameraenabled: (f = msg.getManualcameraenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    clipperliveenabled: (f = msg.getClipperliveenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    cameras: (f = msg.getCameras()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    lastmodifiedcalibration: (f = msg.getLastmodifiedcalibration()) && proto.ProtoMessages.Int64.toObject(includeInstance, f),
    lastmodifiedcolorbalance: (f = msg.getLastmodifiedcolorbalance()) && proto.ProtoMessages.Int64.toObject(includeInstance, f),
    lastmodifiedccu: (f = msg.getLastmodifiedccu()) && proto.ProtoMessages.Int64.toObject(includeInstance, f),
    audioenabled: (f = msg.getAudioenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    poelastreset: (f = msg.getPoelastreset()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    nicinfo: (f = msg.getNicinfo()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    autoproductionenabled: (f = msg.getAutoproductionenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    autolightcontrolenabled: (f = msg.getAutolightcontrolenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    stayinmaintenancemode: (f = msg.getStayinmaintenancemode()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    togglesetupmode: (f = msg.getTogglesetupmode()) && proto.ProtoMessages.ToggleSetupMode.toObject(includeInstance, f),
    setupmodeon: (f = msg.getSetupmodeon()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    cgenginestate: (f = msg.getCgenginestate()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    pipstate: (f = msg.getPipstate()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    testportsresultList: jspb.Message.toObjectList(msg.getTestportsresultList(),
    proto.ProtoMessages.TestPortsResult.toObject, includeInstance),
    sdienabled: (f = msg.getSdienabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    graphicsupdaterequired: (f = msg.getGraphicsupdaterequired()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    varsupportenabled: (f = msg.getVarsupportenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.StatusInformationMessage}
 */
proto.ProtoMessages.StatusInformationMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.StatusInformationMessage;
  return proto.ProtoMessages.StatusInformationMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.StatusInformationMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.StatusInformationMessage}
 */
proto.ProtoMessages.StatusInformationMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.GeneralStatus;
      reader.readMessage(value,proto.ProtoMessages.GeneralStatus.deserializeBinaryFromReader);
      msg.setSystemstatus(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.VpuStatus;
      reader.readMessage(value,proto.ProtoMessages.VpuStatus.deserializeBinaryFromReader);
      msg.setVpustatus(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.SystemMode;
      reader.readMessage(value,proto.ProtoMessages.SystemMode.deserializeBinaryFromReader);
      msg.setSystemmode(value);
      break;
    case 5:
      var value = new proto.ProtoMessages.WorkingHours;
      reader.readMessage(value,proto.ProtoMessages.WorkingHours.deserializeBinaryFromReader);
      msg.setWorkinghours(value);
      break;
    case 6:
      var value = new proto.ProtoMessages.StreamsInfo;
      reader.readMessage(value,proto.ProtoMessages.StreamsInfo.deserializeBinaryFromReader);
      msg.setStreamsinfo(value);
      break;
    case 7:
      var value = new proto.ProtoMessages.EventInfo;
      reader.readMessage(value,proto.ProtoMessages.EventInfo.deserializeBinaryFromReader);
      msg.setCurrentevent(value);
      break;
    case 8:
      var value = new proto.ProtoMessages.EventInfo;
      reader.readMessage(value,proto.ProtoMessages.EventInfo.deserializeBinaryFromReader);
      msg.setUpcomingevent(value);
      break;
    case 9:
      var value = new proto.ProtoMessages.SportsType;
      reader.readMessage(value,proto.ProtoMessages.SportsType.deserializeBinaryFromReader);
      msg.setSportstype(value);
      break;
    case 10:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setHighlightsenabled(value);
      break;
    case 11:
      var value = new proto.ProtoMessages.GraphicEngineInfo;
      reader.readMessage(value,proto.ProtoMessages.GraphicEngineInfo.deserializeBinaryFromReader);
      msg.setGraphicsinfo(value);
      break;
    case 12:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setManualcameraenabled(value);
      break;
    case 13:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setClipperliveenabled(value);
      break;
    case 14:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setCameras(value);
      break;
    case 15:
      var value = new proto.ProtoMessages.Int64;
      reader.readMessage(value,proto.ProtoMessages.Int64.deserializeBinaryFromReader);
      msg.setLastmodifiedcalibration(value);
      break;
    case 16:
      var value = new proto.ProtoMessages.Int64;
      reader.readMessage(value,proto.ProtoMessages.Int64.deserializeBinaryFromReader);
      msg.setLastmodifiedcolorbalance(value);
      break;
    case 17:
      var value = new proto.ProtoMessages.Int64;
      reader.readMessage(value,proto.ProtoMessages.Int64.deserializeBinaryFromReader);
      msg.setLastmodifiedccu(value);
      break;
    case 18:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setAudioenabled(value);
      break;
    case 19:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setPoelastreset(value);
      break;
    case 20:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setNicinfo(value);
      break;
    case 21:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setAutoproductionenabled(value);
      break;
    case 22:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setAutolightcontrolenabled(value);
      break;
    case 24:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setStayinmaintenancemode(value);
      break;
    case 25:
      var value = new proto.ProtoMessages.ToggleSetupMode;
      reader.readMessage(value,proto.ProtoMessages.ToggleSetupMode.deserializeBinaryFromReader);
      msg.setTogglesetupmode(value);
      break;
    case 26:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSetupmodeon(value);
      break;
    case 30:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setCgenginestate(value);
      break;
    case 31:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setPipstate(value);
      break;
    case 34:
      var value = new proto.ProtoMessages.TestPortsResult;
      reader.readMessage(value,proto.ProtoMessages.TestPortsResult.deserializeBinaryFromReader);
      msg.addTestportsresult(value);
      break;
    case 35:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSdienabled(value);
      break;
    case 37:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setGraphicsupdaterequired(value);
      break;
    case 38:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setVarsupportenabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.StatusInformationMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.StatusInformationMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.StatusInformationMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemstatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.GeneralStatus.serializeBinaryToWriter
    );
  }
  f = message.getVpustatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.VpuStatus.serializeBinaryToWriter
    );
  }
  f = message.getSystemmode();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.SystemMode.serializeBinaryToWriter
    );
  }
  f = message.getWorkinghours();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ProtoMessages.WorkingHours.serializeBinaryToWriter
    );
  }
  f = message.getStreamsinfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ProtoMessages.StreamsInfo.serializeBinaryToWriter
    );
  }
  f = message.getCurrentevent();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ProtoMessages.EventInfo.serializeBinaryToWriter
    );
  }
  f = message.getUpcomingevent();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ProtoMessages.EventInfo.serializeBinaryToWriter
    );
  }
  f = message.getSportstype();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ProtoMessages.SportsType.serializeBinaryToWriter
    );
  }
  f = message.getHighlightsenabled();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getGraphicsinfo();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ProtoMessages.GraphicEngineInfo.serializeBinaryToWriter
    );
  }
  f = message.getManualcameraenabled();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getClipperliveenabled();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getCameras();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getLastmodifiedcalibration();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.ProtoMessages.Int64.serializeBinaryToWriter
    );
  }
  f = message.getLastmodifiedcolorbalance();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.ProtoMessages.Int64.serializeBinaryToWriter
    );
  }
  f = message.getLastmodifiedccu();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.ProtoMessages.Int64.serializeBinaryToWriter
    );
  }
  f = message.getAudioenabled();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getPoelastreset();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getNicinfo();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getAutoproductionenabled();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getAutolightcontrolenabled();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getStayinmaintenancemode();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getTogglesetupmode();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      proto.ProtoMessages.ToggleSetupMode.serializeBinaryToWriter
    );
  }
  f = message.getSetupmodeon();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getCgenginestate();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getPipstate();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getTestportsresultList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      34,
      f,
      proto.ProtoMessages.TestPortsResult.serializeBinaryToWriter
    );
  }
  f = message.getSdienabled();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getGraphicsupdaterequired();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getVarsupportenabled();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional GeneralStatus systemStatus = 1;
 * @return {?proto.ProtoMessages.GeneralStatus}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getSystemstatus = function() {
  return /** @type{?proto.ProtoMessages.GeneralStatus} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.GeneralStatus, 1));
};


/**
 * @param {?proto.ProtoMessages.GeneralStatus|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setSystemstatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearSystemstatus = function() {
  return this.setSystemstatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasSystemstatus = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional VpuStatus vpuStatus = 2;
 * @return {?proto.ProtoMessages.VpuStatus}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getVpustatus = function() {
  return /** @type{?proto.ProtoMessages.VpuStatus} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.VpuStatus, 2));
};


/**
 * @param {?proto.ProtoMessages.VpuStatus|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setVpustatus = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearVpustatus = function() {
  return this.setVpustatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasVpustatus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SystemMode systemMode = 4;
 * @return {?proto.ProtoMessages.SystemMode}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getSystemmode = function() {
  return /** @type{?proto.ProtoMessages.SystemMode} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.SystemMode, 4));
};


/**
 * @param {?proto.ProtoMessages.SystemMode|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setSystemmode = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearSystemmode = function() {
  return this.setSystemmode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasSystemmode = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional WorkingHours workingHours = 5;
 * @return {?proto.ProtoMessages.WorkingHours}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getWorkinghours = function() {
  return /** @type{?proto.ProtoMessages.WorkingHours} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.WorkingHours, 5));
};


/**
 * @param {?proto.ProtoMessages.WorkingHours|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setWorkinghours = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearWorkinghours = function() {
  return this.setWorkinghours(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasWorkinghours = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional StreamsInfo streamsInfo = 6;
 * @return {?proto.ProtoMessages.StreamsInfo}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getStreamsinfo = function() {
  return /** @type{?proto.ProtoMessages.StreamsInfo} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.StreamsInfo, 6));
};


/**
 * @param {?proto.ProtoMessages.StreamsInfo|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setStreamsinfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearStreamsinfo = function() {
  return this.setStreamsinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasStreamsinfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EventInfo currentEvent = 7;
 * @return {?proto.ProtoMessages.EventInfo}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getCurrentevent = function() {
  return /** @type{?proto.ProtoMessages.EventInfo} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.EventInfo, 7));
};


/**
 * @param {?proto.ProtoMessages.EventInfo|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setCurrentevent = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearCurrentevent = function() {
  return this.setCurrentevent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasCurrentevent = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional EventInfo upcomingEvent = 8;
 * @return {?proto.ProtoMessages.EventInfo}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getUpcomingevent = function() {
  return /** @type{?proto.ProtoMessages.EventInfo} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.EventInfo, 8));
};


/**
 * @param {?proto.ProtoMessages.EventInfo|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setUpcomingevent = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearUpcomingevent = function() {
  return this.setUpcomingevent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasUpcomingevent = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional SportsType sportsType = 9;
 * @return {?proto.ProtoMessages.SportsType}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getSportstype = function() {
  return /** @type{?proto.ProtoMessages.SportsType} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.SportsType, 9));
};


/**
 * @param {?proto.ProtoMessages.SportsType|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setSportstype = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearSportstype = function() {
  return this.setSportstype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasSportstype = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Bool highlightsEnabled = 10;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getHighlightsenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 10));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setHighlightsenabled = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearHighlightsenabled = function() {
  return this.setHighlightsenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasHighlightsenabled = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional GraphicEngineInfo graphicsInfo = 11;
 * @return {?proto.ProtoMessages.GraphicEngineInfo}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getGraphicsinfo = function() {
  return /** @type{?proto.ProtoMessages.GraphicEngineInfo} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.GraphicEngineInfo, 11));
};


/**
 * @param {?proto.ProtoMessages.GraphicEngineInfo|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setGraphicsinfo = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearGraphicsinfo = function() {
  return this.setGraphicsinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasGraphicsinfo = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional Bool manualCameraEnabled = 12;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getManualcameraenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 12));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setManualcameraenabled = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearManualcameraenabled = function() {
  return this.setManualcameraenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasManualcameraenabled = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Bool clipperLiveEnabled = 13;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getClipperliveenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 13));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setClipperliveenabled = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearClipperliveenabled = function() {
  return this.setClipperliveenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasClipperliveenabled = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional String cameras = 14;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getCameras = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 14));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setCameras = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearCameras = function() {
  return this.setCameras(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasCameras = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Int64 lastModifiedCalibration = 15;
 * @return {?proto.ProtoMessages.Int64}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getLastmodifiedcalibration = function() {
  return /** @type{?proto.ProtoMessages.Int64} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int64, 15));
};


/**
 * @param {?proto.ProtoMessages.Int64|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setLastmodifiedcalibration = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearLastmodifiedcalibration = function() {
  return this.setLastmodifiedcalibration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasLastmodifiedcalibration = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional Int64 lastModifiedColorBalance = 16;
 * @return {?proto.ProtoMessages.Int64}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getLastmodifiedcolorbalance = function() {
  return /** @type{?proto.ProtoMessages.Int64} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int64, 16));
};


/**
 * @param {?proto.ProtoMessages.Int64|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setLastmodifiedcolorbalance = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearLastmodifiedcolorbalance = function() {
  return this.setLastmodifiedcolorbalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasLastmodifiedcolorbalance = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional Int64 lastModifiedCCU = 17;
 * @return {?proto.ProtoMessages.Int64}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getLastmodifiedccu = function() {
  return /** @type{?proto.ProtoMessages.Int64} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int64, 17));
};


/**
 * @param {?proto.ProtoMessages.Int64|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setLastmodifiedccu = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearLastmodifiedccu = function() {
  return this.setLastmodifiedccu(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasLastmodifiedccu = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional Bool audioEnabled = 18;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getAudioenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 18));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setAudioenabled = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearAudioenabled = function() {
  return this.setAudioenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasAudioenabled = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional String poeLastReset = 19;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getPoelastreset = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 19));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setPoelastreset = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearPoelastreset = function() {
  return this.setPoelastreset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasPoelastreset = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional String nicInfo = 20;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getNicinfo = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 20));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setNicinfo = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearNicinfo = function() {
  return this.setNicinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasNicinfo = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional Bool autoProductionEnabled = 21;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getAutoproductionenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 21));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setAutoproductionenabled = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearAutoproductionenabled = function() {
  return this.setAutoproductionenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasAutoproductionenabled = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional Bool autoLightControlEnabled = 22;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getAutolightcontrolenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 22));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setAutolightcontrolenabled = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearAutolightcontrolenabled = function() {
  return this.setAutolightcontrolenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasAutolightcontrolenabled = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional Bool stayInMaintenanceMode = 24;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getStayinmaintenancemode = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 24));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setStayinmaintenancemode = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearStayinmaintenancemode = function() {
  return this.setStayinmaintenancemode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasStayinmaintenancemode = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional ToggleSetupMode toggleSetupMode = 25;
 * @return {?proto.ProtoMessages.ToggleSetupMode}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getTogglesetupmode = function() {
  return /** @type{?proto.ProtoMessages.ToggleSetupMode} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.ToggleSetupMode, 25));
};


/**
 * @param {?proto.ProtoMessages.ToggleSetupMode|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setTogglesetupmode = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearTogglesetupmode = function() {
  return this.setTogglesetupmode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasTogglesetupmode = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional Bool setupModeOn = 26;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getSetupmodeon = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 26));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setSetupmodeon = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearSetupmodeon = function() {
  return this.setSetupmodeon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasSetupmodeon = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional Bool cgEngineState = 30;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getCgenginestate = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 30));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setCgenginestate = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearCgenginestate = function() {
  return this.setCgenginestate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasCgenginestate = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional Bool pipState = 31;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getPipstate = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 31));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setPipstate = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearPipstate = function() {
  return this.setPipstate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasPipstate = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * repeated TestPortsResult testPortsResult = 34;
 * @return {!Array<!proto.ProtoMessages.TestPortsResult>}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getTestportsresultList = function() {
  return /** @type{!Array<!proto.ProtoMessages.TestPortsResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.TestPortsResult, 34));
};


/**
 * @param {!Array<!proto.ProtoMessages.TestPortsResult>} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setTestportsresultList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 34, value);
};


/**
 * @param {!proto.ProtoMessages.TestPortsResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.TestPortsResult}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.addTestportsresult = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 34, opt_value, proto.ProtoMessages.TestPortsResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearTestportsresultList = function() {
  return this.setTestportsresultList([]);
};


/**
 * optional Bool sdiEnabled = 35;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getSdienabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 35));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setSdienabled = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearSdienabled = function() {
  return this.setSdienabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasSdienabled = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional Bool graphicsUpdateRequired = 37;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getGraphicsupdaterequired = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 37));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setGraphicsupdaterequired = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearGraphicsupdaterequired = function() {
  return this.setGraphicsupdaterequired(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasGraphicsupdaterequired = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional Bool varSupportEnabled = 38;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.getVarsupportenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 38));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
*/
proto.ProtoMessages.StatusInformationMessage.prototype.setVarsupportenabled = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StatusInformationMessage} returns this
 */
proto.ProtoMessages.StatusInformationMessage.prototype.clearVarsupportenabled = function() {
  return this.setVarsupportenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StatusInformationMessage.prototype.hasVarsupportenabled = function() {
  return jspb.Message.getField(this, 38) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.RealtimeInformationMessage.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.RealtimeInformationMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.RealtimeInformationMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.RealtimeInformationMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    cpuusage: (f = msg.getCpuusage()) && proto.ProtoMessages.Double.toObject(includeInstance, f),
    cputemperature: (f = msg.getCputemperature()) && proto.ProtoMessages.Double.toObject(includeInstance, f),
    gpuusage: (f = msg.getGpuusage()) && proto.ProtoMessages.Double.toObject(includeInstance, f),
    health: (f = msg.getHealth()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    drivesList: jspb.Message.toObjectList(msg.getDrivesList(),
    proto.ProtoMessages.DriveInformation.toObject, includeInstance),
    backendconnection: (f = msg.getBackendconnection()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    autoproductionstate: (f = msg.getAutoproductionstate()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    autolightcontrolstate: (f = msg.getAutolightcontrolstate()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    panostreamstatus: (f = msg.getPanostreamstatus()) && proto.ProtoMessages.GeneralStatus.toObject(includeInstance, f),
    hdstreamstatus: (f = msg.getHdstreamstatus()) && proto.ProtoMessages.GeneralStatus.toObject(includeInstance, f),
    audiostatus: (f = msg.getAudiostatus()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    memoryusage: (f = msg.getMemoryusage()) && proto.ProtoMessages.Double.toObject(includeInstance, f),
    autolightcontrolvalues: (f = msg.getAutolightcontrolvalues()) && proto.ProtoMessages.AutoLightControlValues.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage}
 */
proto.ProtoMessages.RealtimeInformationMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.RealtimeInformationMessage;
  return proto.ProtoMessages.RealtimeInformationMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.RealtimeInformationMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage}
 */
proto.ProtoMessages.RealtimeInformationMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Double;
      reader.readMessage(value,proto.ProtoMessages.Double.deserializeBinaryFromReader);
      msg.setCpuusage(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Double;
      reader.readMessage(value,proto.ProtoMessages.Double.deserializeBinaryFromReader);
      msg.setCputemperature(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Double;
      reader.readMessage(value,proto.ProtoMessages.Double.deserializeBinaryFromReader);
      msg.setGpuusage(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setHealth(value);
      break;
    case 5:
      var value = new proto.ProtoMessages.DriveInformation;
      reader.readMessage(value,proto.ProtoMessages.DriveInformation.deserializeBinaryFromReader);
      msg.addDrives(value);
      break;
    case 6:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setBackendconnection(value);
      break;
    case 7:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setAutoproductionstate(value);
      break;
    case 8:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setAutolightcontrolstate(value);
      break;
    case 9:
      var value = new proto.ProtoMessages.GeneralStatus;
      reader.readMessage(value,proto.ProtoMessages.GeneralStatus.deserializeBinaryFromReader);
      msg.setPanostreamstatus(value);
      break;
    case 10:
      var value = new proto.ProtoMessages.GeneralStatus;
      reader.readMessage(value,proto.ProtoMessages.GeneralStatus.deserializeBinaryFromReader);
      msg.setHdstreamstatus(value);
      break;
    case 11:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setAudiostatus(value);
      break;
    case 12:
      var value = new proto.ProtoMessages.Double;
      reader.readMessage(value,proto.ProtoMessages.Double.deserializeBinaryFromReader);
      msg.setMemoryusage(value);
      break;
    case 13:
      var value = new proto.ProtoMessages.AutoLightControlValues;
      reader.readMessage(value,proto.ProtoMessages.AutoLightControlValues.deserializeBinaryFromReader);
      msg.setAutolightcontrolvalues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.RealtimeInformationMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.RealtimeInformationMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.RealtimeInformationMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCpuusage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Double.serializeBinaryToWriter
    );
  }
  f = message.getCputemperature();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Double.serializeBinaryToWriter
    );
  }
  f = message.getGpuusage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Double.serializeBinaryToWriter
    );
  }
  f = message.getHealth();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getDrivesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.ProtoMessages.DriveInformation.serializeBinaryToWriter
    );
  }
  f = message.getBackendconnection();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getAutoproductionstate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getAutolightcontrolstate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getPanostreamstatus();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ProtoMessages.GeneralStatus.serializeBinaryToWriter
    );
  }
  f = message.getHdstreamstatus();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ProtoMessages.GeneralStatus.serializeBinaryToWriter
    );
  }
  f = message.getAudiostatus();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getMemoryusage();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ProtoMessages.Double.serializeBinaryToWriter
    );
  }
  f = message.getAutolightcontrolvalues();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.ProtoMessages.AutoLightControlValues.serializeBinaryToWriter
    );
  }
};


/**
 * optional Double cpuUsage = 1;
 * @return {?proto.ProtoMessages.Double}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getCpuusage = function() {
  return /** @type{?proto.ProtoMessages.Double} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Double, 1));
};


/**
 * @param {?proto.ProtoMessages.Double|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setCpuusage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearCpuusage = function() {
  return this.setCpuusage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasCpuusage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Double cpuTemperature = 2;
 * @return {?proto.ProtoMessages.Double}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getCputemperature = function() {
  return /** @type{?proto.ProtoMessages.Double} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Double, 2));
};


/**
 * @param {?proto.ProtoMessages.Double|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setCputemperature = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearCputemperature = function() {
  return this.setCputemperature(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasCputemperature = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Double gpuUsage = 3;
 * @return {?proto.ProtoMessages.Double}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getGpuusage = function() {
  return /** @type{?proto.ProtoMessages.Double} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Double, 3));
};


/**
 * @param {?proto.ProtoMessages.Double|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setGpuusage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearGpuusage = function() {
  return this.setGpuusage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasGpuusage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Bool health = 4;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getHealth = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 4));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setHealth = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearHealth = function() {
  return this.setHealth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasHealth = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated DriveInformation drives = 5;
 * @return {!Array<!proto.ProtoMessages.DriveInformation>}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getDrivesList = function() {
  return /** @type{!Array<!proto.ProtoMessages.DriveInformation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.DriveInformation, 5));
};


/**
 * @param {!Array<!proto.ProtoMessages.DriveInformation>} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setDrivesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.ProtoMessages.DriveInformation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.DriveInformation}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.addDrives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.ProtoMessages.DriveInformation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearDrivesList = function() {
  return this.setDrivesList([]);
};


/**
 * optional Bool backendConnection = 6;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getBackendconnection = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 6));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setBackendconnection = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearBackendconnection = function() {
  return this.setBackendconnection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasBackendconnection = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Bool autoProductionState = 7;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getAutoproductionstate = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 7));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setAutoproductionstate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearAutoproductionstate = function() {
  return this.setAutoproductionstate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasAutoproductionstate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Bool autoLightControlState = 8;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getAutolightcontrolstate = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 8));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setAutolightcontrolstate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearAutolightcontrolstate = function() {
  return this.setAutolightcontrolstate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasAutolightcontrolstate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional GeneralStatus panoStreamStatus = 9;
 * @return {?proto.ProtoMessages.GeneralStatus}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getPanostreamstatus = function() {
  return /** @type{?proto.ProtoMessages.GeneralStatus} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.GeneralStatus, 9));
};


/**
 * @param {?proto.ProtoMessages.GeneralStatus|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setPanostreamstatus = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearPanostreamstatus = function() {
  return this.setPanostreamstatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasPanostreamstatus = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional GeneralStatus hdStreamStatus = 10;
 * @return {?proto.ProtoMessages.GeneralStatus}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getHdstreamstatus = function() {
  return /** @type{?proto.ProtoMessages.GeneralStatus} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.GeneralStatus, 10));
};


/**
 * @param {?proto.ProtoMessages.GeneralStatus|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setHdstreamstatus = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearHdstreamstatus = function() {
  return this.setHdstreamstatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasHdstreamstatus = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Bool audioStatus = 11;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getAudiostatus = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 11));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setAudiostatus = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearAudiostatus = function() {
  return this.setAudiostatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasAudiostatus = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional Double memoryUsage = 12;
 * @return {?proto.ProtoMessages.Double}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getMemoryusage = function() {
  return /** @type{?proto.ProtoMessages.Double} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Double, 12));
};


/**
 * @param {?proto.ProtoMessages.Double|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setMemoryusage = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearMemoryusage = function() {
  return this.setMemoryusage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasMemoryusage = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional AutoLightControlValues autoLightControlValues = 13;
 * @return {?proto.ProtoMessages.AutoLightControlValues}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.getAutolightcontrolvalues = function() {
  return /** @type{?proto.ProtoMessages.AutoLightControlValues} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.AutoLightControlValues, 13));
};


/**
 * @param {?proto.ProtoMessages.AutoLightControlValues|undefined} value
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
*/
proto.ProtoMessages.RealtimeInformationMessage.prototype.setAutolightcontrolvalues = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RealtimeInformationMessage} returns this
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.clearAutolightcontrolvalues = function() {
  return this.setAutolightcontrolvalues(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RealtimeInformationMessage.prototype.hasAutolightcontrolvalues = function() {
  return jspb.Message.getField(this, 13) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.SingleParamInformationMessage.repeatedFields_ = [8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SingleParamInformationMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SingleParamInformationMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SingleParamInformationMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    cameraframesdata: (f = msg.getCameraframesdata()) && proto.ProtoMessages.CameraFramesData.toObject(includeInstance, f),
    licenseupdatesucceeded: (f = msg.getLicenseupdatesucceeded()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    forceleavesetupmode: (f = msg.getForceleavesetupmode()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    tryleavemaintenancemode: (f = msg.getTryleavemaintenancemode()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    panoramainfo: (f = msg.getPanoramainfo()) && proto.ProtoMessages.PanoramaInfo.toObject(includeInstance, f),
    ccupresetsList: jspb.Message.toObjectList(msg.getCcupresetsList(),
    proto.ProtoMessages.CCUPreset.toObject, includeInstance),
    detectedcamerasList: jspb.Message.toObjectList(msg.getDetectedcamerasList(),
    proto.ProtoMessages.String.toObject, includeInstance),
    camerarestoresucceeded: (f = msg.getCamerarestoresucceeded()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    entersetupmodefailed: (f = msg.getEntersetupmodefailed()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    headsetupframesdata: (f = msg.getHeadsetupframesdata()) && proto.ProtoMessages.CameraFramesData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage}
 */
proto.ProtoMessages.SingleParamInformationMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SingleParamInformationMessage;
  return proto.ProtoMessages.SingleParamInformationMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SingleParamInformationMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage}
 */
proto.ProtoMessages.SingleParamInformationMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.CameraFramesData;
      reader.readMessage(value,proto.ProtoMessages.CameraFramesData.deserializeBinaryFromReader);
      msg.setCameraframesdata(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setLicenseupdatesucceeded(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setForceleavesetupmode(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setTryleavemaintenancemode(value);
      break;
    case 7:
      var value = new proto.ProtoMessages.PanoramaInfo;
      reader.readMessage(value,proto.ProtoMessages.PanoramaInfo.deserializeBinaryFromReader);
      msg.setPanoramainfo(value);
      break;
    case 8:
      var value = new proto.ProtoMessages.CCUPreset;
      reader.readMessage(value,proto.ProtoMessages.CCUPreset.deserializeBinaryFromReader);
      msg.addCcupresets(value);
      break;
    case 9:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.addDetectedcameras(value);
      break;
    case 10:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setCamerarestoresucceeded(value);
      break;
    case 11:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setEntersetupmodefailed(value);
      break;
    case 12:
      var value = new proto.ProtoMessages.CameraFramesData;
      reader.readMessage(value,proto.ProtoMessages.CameraFramesData.deserializeBinaryFromReader);
      msg.setHeadsetupframesdata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SingleParamInformationMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SingleParamInformationMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SingleParamInformationMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCameraframesdata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.CameraFramesData.serializeBinaryToWriter
    );
  }
  f = message.getLicenseupdatesucceeded();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getForceleavesetupmode();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getTryleavemaintenancemode();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getPanoramainfo();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ProtoMessages.PanoramaInfo.serializeBinaryToWriter
    );
  }
  f = message.getCcupresetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.ProtoMessages.CCUPreset.serializeBinaryToWriter
    );
  }
  f = message.getDetectedcamerasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getCamerarestoresucceeded();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getEntersetupmodefailed();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getHeadsetupframesdata();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ProtoMessages.CameraFramesData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CameraFramesData cameraFramesData = 1;
 * @return {?proto.ProtoMessages.CameraFramesData}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.getCameraframesdata = function() {
  return /** @type{?proto.ProtoMessages.CameraFramesData} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CameraFramesData, 1));
};


/**
 * @param {?proto.ProtoMessages.CameraFramesData|undefined} value
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
*/
proto.ProtoMessages.SingleParamInformationMessage.prototype.setCameraframesdata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.clearCameraframesdata = function() {
  return this.setCameraframesdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.hasCameraframesdata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Bool licenseUpdateSucceeded = 2;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.getLicenseupdatesucceeded = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 2));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
*/
proto.ProtoMessages.SingleParamInformationMessage.prototype.setLicenseupdatesucceeded = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.clearLicenseupdatesucceeded = function() {
  return this.setLicenseupdatesucceeded(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.hasLicenseupdatesucceeded = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Bool forceLeaveSetupMode = 3;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.getForceleavesetupmode = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 3));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
*/
proto.ProtoMessages.SingleParamInformationMessage.prototype.setForceleavesetupmode = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.clearForceleavesetupmode = function() {
  return this.setForceleavesetupmode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.hasForceleavesetupmode = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Bool tryLeaveMaintenanceMode = 4;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.getTryleavemaintenancemode = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 4));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
*/
proto.ProtoMessages.SingleParamInformationMessage.prototype.setTryleavemaintenancemode = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.clearTryleavemaintenancemode = function() {
  return this.setTryleavemaintenancemode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.hasTryleavemaintenancemode = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PanoramaInfo panoramaInfo = 7;
 * @return {?proto.ProtoMessages.PanoramaInfo}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.getPanoramainfo = function() {
  return /** @type{?proto.ProtoMessages.PanoramaInfo} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.PanoramaInfo, 7));
};


/**
 * @param {?proto.ProtoMessages.PanoramaInfo|undefined} value
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
*/
proto.ProtoMessages.SingleParamInformationMessage.prototype.setPanoramainfo = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.clearPanoramainfo = function() {
  return this.setPanoramainfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.hasPanoramainfo = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated CCUPreset ccuPresets = 8;
 * @return {!Array<!proto.ProtoMessages.CCUPreset>}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.getCcupresetsList = function() {
  return /** @type{!Array<!proto.ProtoMessages.CCUPreset>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.CCUPreset, 8));
};


/**
 * @param {!Array<!proto.ProtoMessages.CCUPreset>} value
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
*/
proto.ProtoMessages.SingleParamInformationMessage.prototype.setCcupresetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.ProtoMessages.CCUPreset=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.CCUPreset}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.addCcupresets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.ProtoMessages.CCUPreset, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.clearCcupresetsList = function() {
  return this.setCcupresetsList([]);
};


/**
 * repeated String detectedCameras = 9;
 * @return {!Array<!proto.ProtoMessages.String>}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.getDetectedcamerasList = function() {
  return /** @type{!Array<!proto.ProtoMessages.String>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.String, 9));
};


/**
 * @param {!Array<!proto.ProtoMessages.String>} value
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
*/
proto.ProtoMessages.SingleParamInformationMessage.prototype.setDetectedcamerasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.ProtoMessages.String=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.String}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.addDetectedcameras = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.ProtoMessages.String, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.clearDetectedcamerasList = function() {
  return this.setDetectedcamerasList([]);
};


/**
 * optional Bool cameraRestoreSucceeded = 10;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.getCamerarestoresucceeded = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 10));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
*/
proto.ProtoMessages.SingleParamInformationMessage.prototype.setCamerarestoresucceeded = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.clearCamerarestoresucceeded = function() {
  return this.setCamerarestoresucceeded(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.hasCamerarestoresucceeded = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Bool enterSetupModeFailed = 11;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.getEntersetupmodefailed = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 11));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
*/
proto.ProtoMessages.SingleParamInformationMessage.prototype.setEntersetupmodefailed = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.clearEntersetupmodefailed = function() {
  return this.setEntersetupmodefailed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.hasEntersetupmodefailed = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional CameraFramesData headSetupFramesData = 12;
 * @return {?proto.ProtoMessages.CameraFramesData}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.getHeadsetupframesdata = function() {
  return /** @type{?proto.ProtoMessages.CameraFramesData} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CameraFramesData, 12));
};


/**
 * @param {?proto.ProtoMessages.CameraFramesData|undefined} value
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
*/
proto.ProtoMessages.SingleParamInformationMessage.prototype.setHeadsetupframesdata = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.SingleParamInformationMessage} returns this
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.clearHeadsetupframesdata = function() {
  return this.setHeadsetupframesdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.SingleParamInformationMessage.prototype.hasHeadsetupframesdata = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CameraPairingInformationMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CameraPairingInformationMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraPairingInformationMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    partnumbertocheck: (f = msg.getPartnumbertocheck()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    validpartnumber: (f = msg.getValidpartnumber()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    cameradata: (f = msg.getCameradata()) && proto.ProtoMessages.CameraData.toObject(includeInstance, f),
    runpairingwithdata: (f = msg.getRunpairingwithdata()) && proto.ProtoMessages.RunPairingWithData.toObject(includeInstance, f),
    pairingsuccess: (f = msg.getPairingsuccess()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    skipcalibration: (f = msg.getSkipcalibration()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage}
 */
proto.ProtoMessages.CameraPairingInformationMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CameraPairingInformationMessage;
  return proto.ProtoMessages.CameraPairingInformationMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CameraPairingInformationMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage}
 */
proto.ProtoMessages.CameraPairingInformationMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setPartnumbertocheck(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setValidpartnumber(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.CameraData;
      reader.readMessage(value,proto.ProtoMessages.CameraData.deserializeBinaryFromReader);
      msg.setCameradata(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.RunPairingWithData;
      reader.readMessage(value,proto.ProtoMessages.RunPairingWithData.deserializeBinaryFromReader);
      msg.setRunpairingwithdata(value);
      break;
    case 5:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setPairingsuccess(value);
      break;
    case 6:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSkipcalibration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CameraPairingInformationMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CameraPairingInformationMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraPairingInformationMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartnumbertocheck();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getValidpartnumber();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getCameradata();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.CameraData.serializeBinaryToWriter
    );
  }
  f = message.getRunpairingwithdata();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.RunPairingWithData.serializeBinaryToWriter
    );
  }
  f = message.getPairingsuccess();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getSkipcalibration();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional String partNumberToCheck = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.getPartnumbertocheck = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
*/
proto.ProtoMessages.CameraPairingInformationMessage.prototype.setPartnumbertocheck = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.clearPartnumbertocheck = function() {
  return this.setPartnumbertocheck(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.hasPartnumbertocheck = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Bool validPartNumber = 2;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.getValidpartnumber = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 2));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
*/
proto.ProtoMessages.CameraPairingInformationMessage.prototype.setValidpartnumber = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.clearValidpartnumber = function() {
  return this.setValidpartnumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.hasValidpartnumber = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CameraData cameraData = 3;
 * @return {?proto.ProtoMessages.CameraData}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.getCameradata = function() {
  return /** @type{?proto.ProtoMessages.CameraData} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CameraData, 3));
};


/**
 * @param {?proto.ProtoMessages.CameraData|undefined} value
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
*/
proto.ProtoMessages.CameraPairingInformationMessage.prototype.setCameradata = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.clearCameradata = function() {
  return this.setCameradata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.hasCameradata = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RunPairingWithData runPairingWithData = 4;
 * @return {?proto.ProtoMessages.RunPairingWithData}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.getRunpairingwithdata = function() {
  return /** @type{?proto.ProtoMessages.RunPairingWithData} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.RunPairingWithData, 4));
};


/**
 * @param {?proto.ProtoMessages.RunPairingWithData|undefined} value
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
*/
proto.ProtoMessages.CameraPairingInformationMessage.prototype.setRunpairingwithdata = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.clearRunpairingwithdata = function() {
  return this.setRunpairingwithdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.hasRunpairingwithdata = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Bool pairingSuccess = 5;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.getPairingsuccess = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 5));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
*/
proto.ProtoMessages.CameraPairingInformationMessage.prototype.setPairingsuccess = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.clearPairingsuccess = function() {
  return this.setPairingsuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.hasPairingsuccess = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Bool skipCalibration = 6;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.getSkipcalibration = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 6));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
*/
proto.ProtoMessages.CameraPairingInformationMessage.prototype.setSkipcalibration = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraPairingInformationMessage} returns this
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.clearSkipcalibration = function() {
  return this.setSkipcalibration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraPairingInformationMessage.prototype.hasSkipcalibration = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CameraData.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CameraData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CameraData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraData.toObject = function(includeInstance, msg) {
  var f, obj = {
    numofcameras: (f = msg.getNumofcameras()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    cameratype: (f = msg.getCameratype()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    lenstype: (f = msg.getLenstype()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    calibration: (f = msg.getCalibration()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    systemtype: jspb.Message.getFieldWithDefault(msg, 5, 0),
    isfirstpairing: (f = msg.getIsfirstpairing()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CameraData}
 */
proto.ProtoMessages.CameraData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CameraData;
  return proto.ProtoMessages.CameraData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CameraData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CameraData}
 */
proto.ProtoMessages.CameraData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setNumofcameras(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setCameratype(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setLenstype(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setCalibration(value);
      break;
    case 5:
      var value = /** @type {!proto.ProtoMessages.CameraData.Type} */ (reader.readEnum());
      msg.setSystemtype(value);
      break;
    case 6:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setIsfirstpairing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CameraData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CameraData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CameraData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumofcameras();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getCameratype();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getLenstype();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getCalibration();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getSystemtype();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getIsfirstpairing();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.CameraData.Type = {
  S1: 0,
  S2: 1,
  S3: 2,
  PRIME: 3,
  S2S: 4
};

/**
 * optional String numOfCameras = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CameraData.prototype.getNumofcameras = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CameraData} returns this
*/
proto.ProtoMessages.CameraData.prototype.setNumofcameras = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraData} returns this
 */
proto.ProtoMessages.CameraData.prototype.clearNumofcameras = function() {
  return this.setNumofcameras(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraData.prototype.hasNumofcameras = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional String cameraType = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CameraData.prototype.getCameratype = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CameraData} returns this
*/
proto.ProtoMessages.CameraData.prototype.setCameratype = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraData} returns this
 */
proto.ProtoMessages.CameraData.prototype.clearCameratype = function() {
  return this.setCameratype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraData.prototype.hasCameratype = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional String lensType = 3;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CameraData.prototype.getLenstype = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 3));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CameraData} returns this
*/
proto.ProtoMessages.CameraData.prototype.setLenstype = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraData} returns this
 */
proto.ProtoMessages.CameraData.prototype.clearLenstype = function() {
  return this.setLenstype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraData.prototype.hasLenstype = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional String calibration = 4;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CameraData.prototype.getCalibration = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 4));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CameraData} returns this
*/
proto.ProtoMessages.CameraData.prototype.setCalibration = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraData} returns this
 */
proto.ProtoMessages.CameraData.prototype.clearCalibration = function() {
  return this.setCalibration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraData.prototype.hasCalibration = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Type systemType = 5;
 * @return {!proto.ProtoMessages.CameraData.Type}
 */
proto.ProtoMessages.CameraData.prototype.getSystemtype = function() {
  return /** @type {!proto.ProtoMessages.CameraData.Type} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.ProtoMessages.CameraData.Type} value
 * @return {!proto.ProtoMessages.CameraData} returns this
 */
proto.ProtoMessages.CameraData.prototype.setSystemtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Bool isFirstPairing = 6;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.CameraData.prototype.getIsfirstpairing = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 6));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.CameraData} returns this
*/
proto.ProtoMessages.CameraData.prototype.setIsfirstpairing = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraData} returns this
 */
proto.ProtoMessages.CameraData.prototype.clearIsfirstpairing = function() {
  return this.setIsfirstpairing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraData.prototype.hasIsfirstpairing = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.RunPairingWithData.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.RunPairingWithData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.RunPairingWithData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.RunPairingWithData.toObject = function(includeInstance, msg) {
  var f, obj = {
    systemtype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    partnumber: (f = msg.getPartnumber()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    s2calibrationfolder: (f = msg.getS2calibrationfolder()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    videostandard: jspb.Message.getFieldWithDefault(msg, 4, 0),
    primeframestandard: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.RunPairingWithData}
 */
proto.ProtoMessages.RunPairingWithData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.RunPairingWithData;
  return proto.ProtoMessages.RunPairingWithData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.RunPairingWithData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.RunPairingWithData}
 */
proto.ProtoMessages.RunPairingWithData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.RunPairingWithData.Type} */ (reader.readEnum());
      msg.setSystemtype(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setPartnumber(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setS2calibrationfolder(value);
      break;
    case 4:
      var value = /** @type {!proto.ProtoMessages.RunPairingWithData.VideoStandard} */ (reader.readEnum());
      msg.setVideostandard(value);
      break;
    case 5:
      var value = /** @type {!proto.ProtoMessages.RunPairingWithData.FrameStandard} */ (reader.readEnum());
      msg.setPrimeframestandard(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.RunPairingWithData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.RunPairingWithData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.RunPairingWithData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.RunPairingWithData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemtype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPartnumber();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getS2calibrationfolder();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getVideostandard();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPrimeframestandard();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.RunPairingWithData.VideoStandard = {
  UNKNOWN: 0,
  PAL: 1,
  NTSC: 2
};

/**
 * @enum {number}
 */
proto.ProtoMessages.RunPairingWithData.FrameStandard = {
  UNKNOWNSIZE: 0,
  SMALL: 1,
  BIG: 2
};

/**
 * @enum {number}
 */
proto.ProtoMessages.RunPairingWithData.Type = {
  S1: 0,
  S2: 1,
  S3: 2,
  PRIME: 3,
  S2S: 4
};

/**
 * optional Type systemType = 1;
 * @return {!proto.ProtoMessages.RunPairingWithData.Type}
 */
proto.ProtoMessages.RunPairingWithData.prototype.getSystemtype = function() {
  return /** @type {!proto.ProtoMessages.RunPairingWithData.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.RunPairingWithData.Type} value
 * @return {!proto.ProtoMessages.RunPairingWithData} returns this
 */
proto.ProtoMessages.RunPairingWithData.prototype.setSystemtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional String partNumber = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.RunPairingWithData.prototype.getPartnumber = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.RunPairingWithData} returns this
*/
proto.ProtoMessages.RunPairingWithData.prototype.setPartnumber = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RunPairingWithData} returns this
 */
proto.ProtoMessages.RunPairingWithData.prototype.clearPartnumber = function() {
  return this.setPartnumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RunPairingWithData.prototype.hasPartnumber = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional String s2CalibrationFolder = 3;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.RunPairingWithData.prototype.getS2calibrationfolder = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 3));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.RunPairingWithData} returns this
*/
proto.ProtoMessages.RunPairingWithData.prototype.setS2calibrationfolder = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.RunPairingWithData} returns this
 */
proto.ProtoMessages.RunPairingWithData.prototype.clearS2calibrationfolder = function() {
  return this.setS2calibrationfolder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.RunPairingWithData.prototype.hasS2calibrationfolder = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional VideoStandard videoStandard = 4;
 * @return {!proto.ProtoMessages.RunPairingWithData.VideoStandard}
 */
proto.ProtoMessages.RunPairingWithData.prototype.getVideostandard = function() {
  return /** @type {!proto.ProtoMessages.RunPairingWithData.VideoStandard} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.ProtoMessages.RunPairingWithData.VideoStandard} value
 * @return {!proto.ProtoMessages.RunPairingWithData} returns this
 */
proto.ProtoMessages.RunPairingWithData.prototype.setVideostandard = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional FrameStandard primeFrameStandard = 5;
 * @return {!proto.ProtoMessages.RunPairingWithData.FrameStandard}
 */
proto.ProtoMessages.RunPairingWithData.prototype.getPrimeframestandard = function() {
  return /** @type {!proto.ProtoMessages.RunPairingWithData.FrameStandard} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.ProtoMessages.RunPairingWithData.FrameStandard} value
 * @return {!proto.ProtoMessages.RunPairingWithData} returns this
 */
proto.ProtoMessages.RunPairingWithData.prototype.setPrimeframestandard = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CcuUpdateMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CcuUpdateMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CcuUpdateMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CcuUpdateMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    newvpuccudata: (f = msg.getNewvpuccudata()) && proto.ProtoMessages.CCUData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CcuUpdateMessage}
 */
proto.ProtoMessages.CcuUpdateMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CcuUpdateMessage;
  return proto.ProtoMessages.CcuUpdateMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CcuUpdateMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CcuUpdateMessage}
 */
proto.ProtoMessages.CcuUpdateMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.CCUData;
      reader.readMessage(value,proto.ProtoMessages.CCUData.deserializeBinaryFromReader);
      msg.setNewvpuccudata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CcuUpdateMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CcuUpdateMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CcuUpdateMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CcuUpdateMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewvpuccudata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.CCUData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CCUData newVPUCCUData = 1;
 * @return {?proto.ProtoMessages.CCUData}
 */
proto.ProtoMessages.CcuUpdateMessage.prototype.getNewvpuccudata = function() {
  return /** @type{?proto.ProtoMessages.CCUData} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CCUData, 1));
};


/**
 * @param {?proto.ProtoMessages.CCUData|undefined} value
 * @return {!proto.ProtoMessages.CcuUpdateMessage} returns this
*/
proto.ProtoMessages.CcuUpdateMessage.prototype.setNewvpuccudata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CcuUpdateMessage} returns this
 */
proto.ProtoMessages.CcuUpdateMessage.prototype.clearNewvpuccudata = function() {
  return this.setNewvpuccudata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CcuUpdateMessage.prototype.hasNewvpuccudata = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.PanoramaInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.PanoramaInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.PanoramaInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PanoramaInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    panoramaerrormessage: (f = msg.getPanoramaerrormessage()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    panoramafile: (f = msg.getPanoramafile()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    ccudata: (f = msg.getCcudata()) && proto.ProtoMessages.CCUData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.PanoramaInfo}
 */
proto.ProtoMessages.PanoramaInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.PanoramaInfo;
  return proto.ProtoMessages.PanoramaInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.PanoramaInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.PanoramaInfo}
 */
proto.ProtoMessages.PanoramaInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setPanoramaerrormessage(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setPanoramafile(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.CCUData;
      reader.readMessage(value,proto.ProtoMessages.CCUData.deserializeBinaryFromReader);
      msg.setCcudata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.PanoramaInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.PanoramaInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.PanoramaInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PanoramaInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getPanoramaerrormessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getPanoramafile();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getCcudata();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.CCUData.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool success = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.PanoramaInfo.prototype.getSuccess = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.PanoramaInfo} returns this
*/
proto.ProtoMessages.PanoramaInfo.prototype.setSuccess = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.PanoramaInfo} returns this
 */
proto.ProtoMessages.PanoramaInfo.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.PanoramaInfo.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional String panoramaErrorMessage = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.PanoramaInfo.prototype.getPanoramaerrormessage = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.PanoramaInfo} returns this
*/
proto.ProtoMessages.PanoramaInfo.prototype.setPanoramaerrormessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.PanoramaInfo} returns this
 */
proto.ProtoMessages.PanoramaInfo.prototype.clearPanoramaerrormessage = function() {
  return this.setPanoramaerrormessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.PanoramaInfo.prototype.hasPanoramaerrormessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional String panoramaFile = 3;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.PanoramaInfo.prototype.getPanoramafile = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 3));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.PanoramaInfo} returns this
*/
proto.ProtoMessages.PanoramaInfo.prototype.setPanoramafile = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.PanoramaInfo} returns this
 */
proto.ProtoMessages.PanoramaInfo.prototype.clearPanoramafile = function() {
  return this.setPanoramafile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.PanoramaInfo.prototype.hasPanoramafile = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CCUData ccuData = 4;
 * @return {?proto.ProtoMessages.CCUData}
 */
proto.ProtoMessages.PanoramaInfo.prototype.getCcudata = function() {
  return /** @type{?proto.ProtoMessages.CCUData} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CCUData, 4));
};


/**
 * @param {?proto.ProtoMessages.CCUData|undefined} value
 * @return {!proto.ProtoMessages.PanoramaInfo} returns this
*/
proto.ProtoMessages.PanoramaInfo.prototype.setCcudata = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.PanoramaInfo} returns this
 */
proto.ProtoMessages.PanoramaInfo.prototype.clearCcudata = function() {
  return this.setCcudata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.PanoramaInfo.prototype.hasCcudata = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CCUData.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CCUData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CCUData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CCUData.toObject = function(includeInstance, msg) {
  var f, obj = {
    saturation: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    hue: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    gamma: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    contrast: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    intensity: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    rx1: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    rx2: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    gx1: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    gx2: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    bx1: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    bx2: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CCUData}
 */
proto.ProtoMessages.CCUData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CCUData;
  return proto.ProtoMessages.CCUData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CCUData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CCUData}
 */
proto.ProtoMessages.CCUData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSaturation(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGamma(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setContrast(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setIntensity(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRx1(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRx2(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGx1(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGx2(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBx1(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBx2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CCUData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CCUData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CCUData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CCUData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSaturation();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getHue();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getGamma();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getContrast();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getIntensity();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getRx1();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getRx2();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = message.getGx1();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getGx2();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getBx1();
  if (f !== 0.0) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = message.getBx2();
  if (f !== 0.0) {
    writer.writeFloat(
      12,
      f
    );
  }
};


/**
 * optional float saturation = 1;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getSaturation = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setSaturation = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float hue = 3;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getHue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setHue = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float gamma = 4;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getGamma = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setGamma = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float contrast = 5;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getContrast = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setContrast = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float intensity = 6;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getIntensity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setIntensity = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional float rx1 = 7;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getRx1 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setRx1 = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional float rx2 = 8;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getRx2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setRx2 = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional float gx1 = 9;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getGx1 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setGx1 = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional float gx2 = 10;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getGx2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setGx2 = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional float bx1 = 11;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getBx1 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setBx1 = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional float bx2 = 12;
 * @return {number}
 */
proto.ProtoMessages.CCUData.prototype.getBx2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CCUData} returns this
 */
proto.ProtoMessages.CCUData.prototype.setBx2 = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.AutoLightControlValues.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.AutoLightControlValues.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.AutoLightControlValues} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.AutoLightControlValues.toObject = function(includeInstance, msg) {
  var f, obj = {
    autolightcontrollivevalue: (f = msg.getAutolightcontrollivevalue()) && proto.ProtoMessages.Int32.toObject(includeInstance, f),
    autolightcontrolhealth: (f = msg.getAutolightcontrolhealth()) && proto.ProtoMessages.Int32.toObject(includeInstance, f),
    autolightcontroldesiredbrightness: (f = msg.getAutolightcontroldesiredbrightness()) && proto.ProtoMessages.Int32.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.AutoLightControlValues}
 */
proto.ProtoMessages.AutoLightControlValues.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.AutoLightControlValues;
  return proto.ProtoMessages.AutoLightControlValues.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.AutoLightControlValues} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.AutoLightControlValues}
 */
proto.ProtoMessages.AutoLightControlValues.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Int32;
      reader.readMessage(value,proto.ProtoMessages.Int32.deserializeBinaryFromReader);
      msg.setAutolightcontrollivevalue(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Int32;
      reader.readMessage(value,proto.ProtoMessages.Int32.deserializeBinaryFromReader);
      msg.setAutolightcontrolhealth(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Int32;
      reader.readMessage(value,proto.ProtoMessages.Int32.deserializeBinaryFromReader);
      msg.setAutolightcontroldesiredbrightness(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.AutoLightControlValues.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.AutoLightControlValues.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.AutoLightControlValues} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.AutoLightControlValues.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAutolightcontrollivevalue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Int32.serializeBinaryToWriter
    );
  }
  f = message.getAutolightcontrolhealth();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Int32.serializeBinaryToWriter
    );
  }
  f = message.getAutolightcontroldesiredbrightness();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Int32.serializeBinaryToWriter
    );
  }
};


/**
 * optional Int32 autoLightControlLiveValue = 1;
 * @return {?proto.ProtoMessages.Int32}
 */
proto.ProtoMessages.AutoLightControlValues.prototype.getAutolightcontrollivevalue = function() {
  return /** @type{?proto.ProtoMessages.Int32} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int32, 1));
};


/**
 * @param {?proto.ProtoMessages.Int32|undefined} value
 * @return {!proto.ProtoMessages.AutoLightControlValues} returns this
*/
proto.ProtoMessages.AutoLightControlValues.prototype.setAutolightcontrollivevalue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.AutoLightControlValues} returns this
 */
proto.ProtoMessages.AutoLightControlValues.prototype.clearAutolightcontrollivevalue = function() {
  return this.setAutolightcontrollivevalue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.AutoLightControlValues.prototype.hasAutolightcontrollivevalue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Int32 autoLightControlHealth = 2;
 * @return {?proto.ProtoMessages.Int32}
 */
proto.ProtoMessages.AutoLightControlValues.prototype.getAutolightcontrolhealth = function() {
  return /** @type{?proto.ProtoMessages.Int32} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int32, 2));
};


/**
 * @param {?proto.ProtoMessages.Int32|undefined} value
 * @return {!proto.ProtoMessages.AutoLightControlValues} returns this
*/
proto.ProtoMessages.AutoLightControlValues.prototype.setAutolightcontrolhealth = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.AutoLightControlValues} returns this
 */
proto.ProtoMessages.AutoLightControlValues.prototype.clearAutolightcontrolhealth = function() {
  return this.setAutolightcontrolhealth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.AutoLightControlValues.prototype.hasAutolightcontrolhealth = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Int32 autoLightControlDesiredBrightness = 3;
 * @return {?proto.ProtoMessages.Int32}
 */
proto.ProtoMessages.AutoLightControlValues.prototype.getAutolightcontroldesiredbrightness = function() {
  return /** @type{?proto.ProtoMessages.Int32} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int32, 3));
};


/**
 * @param {?proto.ProtoMessages.Int32|undefined} value
 * @return {!proto.ProtoMessages.AutoLightControlValues} returns this
*/
proto.ProtoMessages.AutoLightControlValues.prototype.setAutolightcontroldesiredbrightness = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.AutoLightControlValues} returns this
 */
proto.ProtoMessages.AutoLightControlValues.prototype.clearAutolightcontroldesiredbrightness = function() {
  return this.setAutolightcontroldesiredbrightness(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.AutoLightControlValues.prototype.hasAutolightcontroldesiredbrightness = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.FileTransferMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.FileTransferMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.FileTransferMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.FileTransferMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    filename: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filesize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    content: msg.getContent_asB64(),
    offset: jspb.Message.getFieldWithDefault(msg, 4, 0),
    count: jspb.Message.getFieldWithDefault(msg, 5, 0),
    filetype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    transfertype: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.FileTransferMessage}
 */
proto.ProtoMessages.FileTransferMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.FileTransferMessage;
  return proto.ProtoMessages.FileTransferMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.FileTransferMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.FileTransferMessage}
 */
proto.ProtoMessages.FileTransferMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFilesize(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setContent(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    case 6:
      var value = /** @type {!proto.ProtoMessages.FileTransferMessage.FileType} */ (reader.readEnum());
      msg.setFiletype(value);
      break;
    case 7:
      var value = /** @type {!proto.ProtoMessages.FileTransferMessage.TransferType} */ (reader.readEnum());
      msg.setTransfertype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.FileTransferMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.FileTransferMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.FileTransferMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.FileTransferMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilesize();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getFiletype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getTransfertype();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.FileTransferMessage.FileType = {
  CONFIGURATION_FILE: 0,
  CALIBRATION_FILE: 1,
  PIP_FILE: 2
};

/**
 * @enum {number}
 */
proto.ProtoMessages.FileTransferMessage.TransferType = {
  IMPORT: 0,
  EXPORT: 1
};

/**
 * optional string fileName = 1;
 * @return {string}
 */
proto.ProtoMessages.FileTransferMessage.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.FileTransferMessage} returns this
 */
proto.ProtoMessages.FileTransferMessage.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 fileSize = 2;
 * @return {number}
 */
proto.ProtoMessages.FileTransferMessage.prototype.getFilesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.FileTransferMessage} returns this
 */
proto.ProtoMessages.FileTransferMessage.prototype.setFilesize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bytes content = 3;
 * @return {!(string|Uint8Array)}
 */
proto.ProtoMessages.FileTransferMessage.prototype.getContent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes content = 3;
 * This is a type-conversion wrapper around `getContent()`
 * @return {string}
 */
proto.ProtoMessages.FileTransferMessage.prototype.getContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getContent()));
};


/**
 * optional bytes content = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getContent()`
 * @return {!Uint8Array}
 */
proto.ProtoMessages.FileTransferMessage.prototype.getContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.ProtoMessages.FileTransferMessage} returns this
 */
proto.ProtoMessages.FileTransferMessage.prototype.setContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional int32 offset = 4;
 * @return {number}
 */
proto.ProtoMessages.FileTransferMessage.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.FileTransferMessage} returns this
 */
proto.ProtoMessages.FileTransferMessage.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 count = 5;
 * @return {number}
 */
proto.ProtoMessages.FileTransferMessage.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.FileTransferMessage} returns this
 */
proto.ProtoMessages.FileTransferMessage.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional FileType fileType = 6;
 * @return {!proto.ProtoMessages.FileTransferMessage.FileType}
 */
proto.ProtoMessages.FileTransferMessage.prototype.getFiletype = function() {
  return /** @type {!proto.ProtoMessages.FileTransferMessage.FileType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.ProtoMessages.FileTransferMessage.FileType} value
 * @return {!proto.ProtoMessages.FileTransferMessage} returns this
 */
proto.ProtoMessages.FileTransferMessage.prototype.setFiletype = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional TransferType transferType = 7;
 * @return {!proto.ProtoMessages.FileTransferMessage.TransferType}
 */
proto.ProtoMessages.FileTransferMessage.prototype.getTransfertype = function() {
  return /** @type {!proto.ProtoMessages.FileTransferMessage.TransferType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.ProtoMessages.FileTransferMessage.TransferType} value
 * @return {!proto.ProtoMessages.FileTransferMessage} returns this
 */
proto.ProtoMessages.FileTransferMessage.prototype.setTransfertype = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.DriveInformation.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.DriveInformation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.DriveInformation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.DriveInformation.toObject = function(includeInstance, msg) {
  var f, obj = {
    letter: (f = msg.getLetter()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    totalspace: (f = msg.getTotalspace()) && proto.ProtoMessages.Int64.toObject(includeInstance, f),
    freespace: (f = msg.getFreespace()) && proto.ProtoMessages.Int64.toObject(includeInstance, f),
    tooltip: (f = msg.getTooltip()) && proto.ProtoMessages.String.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.DriveInformation}
 */
proto.ProtoMessages.DriveInformation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.DriveInformation;
  return proto.ProtoMessages.DriveInformation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.DriveInformation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.DriveInformation}
 */
proto.ProtoMessages.DriveInformation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setLetter(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Int64;
      reader.readMessage(value,proto.ProtoMessages.Int64.deserializeBinaryFromReader);
      msg.setTotalspace(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Int64;
      reader.readMessage(value,proto.ProtoMessages.Int64.deserializeBinaryFromReader);
      msg.setFreespace(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setTooltip(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.DriveInformation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.DriveInformation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.DriveInformation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.DriveInformation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLetter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getTotalspace();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Int64.serializeBinaryToWriter
    );
  }
  f = message.getFreespace();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Int64.serializeBinaryToWriter
    );
  }
  f = message.getTooltip();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
};


/**
 * optional String letter = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.DriveInformation.prototype.getLetter = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.DriveInformation} returns this
*/
proto.ProtoMessages.DriveInformation.prototype.setLetter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.DriveInformation} returns this
 */
proto.ProtoMessages.DriveInformation.prototype.clearLetter = function() {
  return this.setLetter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.DriveInformation.prototype.hasLetter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Int64 totalSpace = 2;
 * @return {?proto.ProtoMessages.Int64}
 */
proto.ProtoMessages.DriveInformation.prototype.getTotalspace = function() {
  return /** @type{?proto.ProtoMessages.Int64} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int64, 2));
};


/**
 * @param {?proto.ProtoMessages.Int64|undefined} value
 * @return {!proto.ProtoMessages.DriveInformation} returns this
*/
proto.ProtoMessages.DriveInformation.prototype.setTotalspace = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.DriveInformation} returns this
 */
proto.ProtoMessages.DriveInformation.prototype.clearTotalspace = function() {
  return this.setTotalspace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.DriveInformation.prototype.hasTotalspace = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Int64 freeSpace = 3;
 * @return {?proto.ProtoMessages.Int64}
 */
proto.ProtoMessages.DriveInformation.prototype.getFreespace = function() {
  return /** @type{?proto.ProtoMessages.Int64} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int64, 3));
};


/**
 * @param {?proto.ProtoMessages.Int64|undefined} value
 * @return {!proto.ProtoMessages.DriveInformation} returns this
*/
proto.ProtoMessages.DriveInformation.prototype.setFreespace = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.DriveInformation} returns this
 */
proto.ProtoMessages.DriveInformation.prototype.clearFreespace = function() {
  return this.setFreespace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.DriveInformation.prototype.hasFreespace = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional String toolTip = 4;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.DriveInformation.prototype.getTooltip = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 4));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.DriveInformation} returns this
*/
proto.ProtoMessages.DriveInformation.prototype.setTooltip = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.DriveInformation} returns this
 */
proto.ProtoMessages.DriveInformation.prototype.clearTooltip = function() {
  return this.setTooltip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.DriveInformation.prototype.hasTooltip = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.StaticInformationMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.StaticInformationMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.StaticInformationMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    venueid: (f = msg.getVenueid()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    venuename: (f = msg.getVenuename()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    venuedescription: (f = msg.getVenuedescription()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    systemtype: (f = msg.getSystemtype()) && proto.ProtoMessages.SystemType.toObject(includeInstance, f),
    totalmemory: (f = msg.getTotalmemory()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    switchinfo: (f = msg.getSwitchinfo()) && proto.ProtoMessages.SwitchInfo.toObject(includeInstance, f),
    licenseinfo: (f = msg.getLicenseinfo()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    softwareversion: (f = msg.getSoftwareversion()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    nasinfo: (f = msg.getNasinfo()) && proto.ProtoMessages.NasInfo.toObject(includeInstance, f),
    gpuname: (f = msg.getGpuname()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    gpudriverversion: (f = msg.getGpudriverversion()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    camerafps: (f = msg.getCamerafps()) && proto.ProtoMessages.Float.toObject(includeInstance, f),
    camerapartnumber: (f = msg.getCamerapartnumber()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    allowfpschange: (f = msg.getAllowfpschange()) && proto.ProtoMessages.CameraFPSChangeStatus.toObject(includeInstance, f),
    dongleid: (f = msg.getDongleid()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    headtype: (f = msg.getHeadtype()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    licenseinfovalid: (f = msg.getLicenseinfovalid()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    networkinfo: (f = msg.getNetworkinfo()) && proto.ProtoMessages.NetworkInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.StaticInformationMessage}
 */
proto.ProtoMessages.StaticInformationMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.StaticInformationMessage;
  return proto.ProtoMessages.StaticInformationMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.StaticInformationMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.StaticInformationMessage}
 */
proto.ProtoMessages.StaticInformationMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setVenueid(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setVenuename(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setVenuedescription(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.SystemType;
      reader.readMessage(value,proto.ProtoMessages.SystemType.deserializeBinaryFromReader);
      msg.setSystemtype(value);
      break;
    case 5:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setTotalmemory(value);
      break;
    case 6:
      var value = new proto.ProtoMessages.SwitchInfo;
      reader.readMessage(value,proto.ProtoMessages.SwitchInfo.deserializeBinaryFromReader);
      msg.setSwitchinfo(value);
      break;
    case 7:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setLicenseinfo(value);
      break;
    case 8:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setSoftwareversion(value);
      break;
    case 9:
      var value = new proto.ProtoMessages.NasInfo;
      reader.readMessage(value,proto.ProtoMessages.NasInfo.deserializeBinaryFromReader);
      msg.setNasinfo(value);
      break;
    case 10:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setGpuname(value);
      break;
    case 11:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setGpudriverversion(value);
      break;
    case 12:
      var value = new proto.ProtoMessages.Float;
      reader.readMessage(value,proto.ProtoMessages.Float.deserializeBinaryFromReader);
      msg.setCamerafps(value);
      break;
    case 13:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setCamerapartnumber(value);
      break;
    case 14:
      var value = new proto.ProtoMessages.CameraFPSChangeStatus;
      reader.readMessage(value,proto.ProtoMessages.CameraFPSChangeStatus.deserializeBinaryFromReader);
      msg.setAllowfpschange(value);
      break;
    case 15:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setDongleid(value);
      break;
    case 16:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setHeadtype(value);
      break;
    case 17:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setLicenseinfovalid(value);
      break;
    case 18:
      var value = new proto.ProtoMessages.NetworkInfo;
      reader.readMessage(value,proto.ProtoMessages.NetworkInfo.deserializeBinaryFromReader);
      msg.setNetworkinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.StaticInformationMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.StaticInformationMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.StaticInformationMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVenueid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getVenuename();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getVenuedescription();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getSystemtype();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.SystemType.serializeBinaryToWriter
    );
  }
  f = message.getTotalmemory();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getSwitchinfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ProtoMessages.SwitchInfo.serializeBinaryToWriter
    );
  }
  f = message.getLicenseinfo();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getSoftwareversion();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getNasinfo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ProtoMessages.NasInfo.serializeBinaryToWriter
    );
  }
  f = message.getGpuname();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getGpudriverversion();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getCamerafps();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ProtoMessages.Float.serializeBinaryToWriter
    );
  }
  f = message.getCamerapartnumber();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getAllowfpschange();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.ProtoMessages.CameraFPSChangeStatus.serializeBinaryToWriter
    );
  }
  f = message.getDongleid();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getHeadtype();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getLicenseinfovalid();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getNetworkinfo();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.ProtoMessages.NetworkInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional String venueId = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getVenueid = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setVenueid = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearVenueid = function() {
  return this.setVenueid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasVenueid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional String venueName = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getVenuename = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setVenuename = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearVenuename = function() {
  return this.setVenuename(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasVenuename = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional String venueDescription = 3;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getVenuedescription = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 3));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setVenuedescription = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearVenuedescription = function() {
  return this.setVenuedescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasVenuedescription = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SystemType systemType = 4;
 * @return {?proto.ProtoMessages.SystemType}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getSystemtype = function() {
  return /** @type{?proto.ProtoMessages.SystemType} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.SystemType, 4));
};


/**
 * @param {?proto.ProtoMessages.SystemType|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setSystemtype = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearSystemtype = function() {
  return this.setSystemtype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasSystemtype = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional String totalMemory = 5;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getTotalmemory = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 5));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setTotalmemory = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearTotalmemory = function() {
  return this.setTotalmemory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasTotalmemory = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional SwitchInfo switchInfo = 6;
 * @return {?proto.ProtoMessages.SwitchInfo}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getSwitchinfo = function() {
  return /** @type{?proto.ProtoMessages.SwitchInfo} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.SwitchInfo, 6));
};


/**
 * @param {?proto.ProtoMessages.SwitchInfo|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setSwitchinfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearSwitchinfo = function() {
  return this.setSwitchinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasSwitchinfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional String licenseInfo = 7;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getLicenseinfo = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 7));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setLicenseinfo = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearLicenseinfo = function() {
  return this.setLicenseinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasLicenseinfo = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional String softwareVersion = 8;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getSoftwareversion = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 8));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setSoftwareversion = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearSoftwareversion = function() {
  return this.setSoftwareversion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasSoftwareversion = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional NasInfo nasInfo = 9;
 * @return {?proto.ProtoMessages.NasInfo}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getNasinfo = function() {
  return /** @type{?proto.ProtoMessages.NasInfo} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.NasInfo, 9));
};


/**
 * @param {?proto.ProtoMessages.NasInfo|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setNasinfo = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearNasinfo = function() {
  return this.setNasinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasNasinfo = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional String gpuName = 10;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getGpuname = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 10));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setGpuname = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearGpuname = function() {
  return this.setGpuname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasGpuname = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional String gpuDriverVersion = 11;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getGpudriverversion = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 11));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setGpudriverversion = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearGpudriverversion = function() {
  return this.setGpudriverversion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasGpudriverversion = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional Float cameraFPS = 12;
 * @return {?proto.ProtoMessages.Float}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getCamerafps = function() {
  return /** @type{?proto.ProtoMessages.Float} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Float, 12));
};


/**
 * @param {?proto.ProtoMessages.Float|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setCamerafps = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearCamerafps = function() {
  return this.setCamerafps(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasCamerafps = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional String cameraPartNumber = 13;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getCamerapartnumber = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 13));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setCamerapartnumber = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearCamerapartnumber = function() {
  return this.setCamerapartnumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasCamerapartnumber = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional CameraFPSChangeStatus allowFpsChange = 14;
 * @return {?proto.ProtoMessages.CameraFPSChangeStatus}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getAllowfpschange = function() {
  return /** @type{?proto.ProtoMessages.CameraFPSChangeStatus} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CameraFPSChangeStatus, 14));
};


/**
 * @param {?proto.ProtoMessages.CameraFPSChangeStatus|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setAllowfpschange = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearAllowfpschange = function() {
  return this.setAllowfpschange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasAllowfpschange = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional String dongleId = 15;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getDongleid = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 15));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setDongleid = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearDongleid = function() {
  return this.setDongleid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasDongleid = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional String headType = 16;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getHeadtype = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 16));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setHeadtype = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearHeadtype = function() {
  return this.setHeadtype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasHeadtype = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional Bool licenseInfoValid = 17;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getLicenseinfovalid = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 17));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setLicenseinfovalid = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearLicenseinfovalid = function() {
  return this.setLicenseinfovalid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasLicenseinfovalid = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional NetworkInfo networkInfo = 18;
 * @return {?proto.ProtoMessages.NetworkInfo}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.getNetworkinfo = function() {
  return /** @type{?proto.ProtoMessages.NetworkInfo} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.NetworkInfo, 18));
};


/**
 * @param {?proto.ProtoMessages.NetworkInfo|undefined} value
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
*/
proto.ProtoMessages.StaticInformationMessage.prototype.setNetworkinfo = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StaticInformationMessage} returns this
 */
proto.ProtoMessages.StaticInformationMessage.prototype.clearNetworkinfo = function() {
  return this.setNetworkinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StaticInformationMessage.prototype.hasNetworkinfo = function() {
  return jspb.Message.getField(this, 18) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.EventInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.EventInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.EventInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.EventInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: (f = msg.getName()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    starttime: (f = msg.getStarttime()) && proto.ProtoMessages.Uint64.toObject(includeInstance, f),
    endtime: (f = msg.getEndtime()) && proto.ProtoMessages.Uint64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.EventInfo}
 */
proto.ProtoMessages.EventInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.EventInfo;
  return proto.ProtoMessages.EventInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.EventInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.EventInfo}
 */
proto.ProtoMessages.EventInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Uint64;
      reader.readMessage(value,proto.ProtoMessages.Uint64.deserializeBinaryFromReader);
      msg.setStarttime(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Uint64;
      reader.readMessage(value,proto.ProtoMessages.Uint64.deserializeBinaryFromReader);
      msg.setEndtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.EventInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.EventInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.EventInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.EventInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getStarttime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Uint64.serializeBinaryToWriter
    );
  }
  f = message.getEndtime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Uint64.serializeBinaryToWriter
    );
  }
};


/**
 * optional String name = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.EventInfo.prototype.getName = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.EventInfo} returns this
*/
proto.ProtoMessages.EventInfo.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.EventInfo} returns this
 */
proto.ProtoMessages.EventInfo.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.EventInfo.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Uint64 startTime = 2;
 * @return {?proto.ProtoMessages.Uint64}
 */
proto.ProtoMessages.EventInfo.prototype.getStarttime = function() {
  return /** @type{?proto.ProtoMessages.Uint64} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Uint64, 2));
};


/**
 * @param {?proto.ProtoMessages.Uint64|undefined} value
 * @return {!proto.ProtoMessages.EventInfo} returns this
*/
proto.ProtoMessages.EventInfo.prototype.setStarttime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.EventInfo} returns this
 */
proto.ProtoMessages.EventInfo.prototype.clearStarttime = function() {
  return this.setStarttime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.EventInfo.prototype.hasStarttime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Uint64 endTime = 3;
 * @return {?proto.ProtoMessages.Uint64}
 */
proto.ProtoMessages.EventInfo.prototype.getEndtime = function() {
  return /** @type{?proto.ProtoMessages.Uint64} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Uint64, 3));
};


/**
 * @param {?proto.ProtoMessages.Uint64|undefined} value
 * @return {!proto.ProtoMessages.EventInfo} returns this
*/
proto.ProtoMessages.EventInfo.prototype.setEndtime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.EventInfo} returns this
 */
proto.ProtoMessages.EventInfo.prototype.clearEndtime = function() {
  return this.setEndtime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.EventInfo.prototype.hasEndtime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.WorkingHours.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.WorkingHours.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.WorkingHours} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.WorkingHours.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: (f = msg.getFrom()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    to: (f = msg.getTo()) && proto.ProtoMessages.String.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.WorkingHours}
 */
proto.ProtoMessages.WorkingHours.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.WorkingHours;
  return proto.ProtoMessages.WorkingHours.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.WorkingHours} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.WorkingHours}
 */
proto.ProtoMessages.WorkingHours.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.WorkingHours.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.WorkingHours.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.WorkingHours} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.WorkingHours.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
};


/**
 * optional String from = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.WorkingHours.prototype.getFrom = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.WorkingHours} returns this
*/
proto.ProtoMessages.WorkingHours.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.WorkingHours} returns this
 */
proto.ProtoMessages.WorkingHours.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.WorkingHours.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional String to = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.WorkingHours.prototype.getTo = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.WorkingHours} returns this
*/
proto.ProtoMessages.WorkingHours.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.WorkingHours} returns this
 */
proto.ProtoMessages.WorkingHours.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.WorkingHours.prototype.hasTo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.StreamsInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.StreamsInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.StreamsInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.StreamsInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    hdenabled: (f = msg.getHdenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    hdbandwidth: (f = msg.getHdbandwidth()) && proto.ProtoMessages.Float.toObject(includeInstance, f),
    hdurl: (f = msg.getHdurl()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    panoenabled: (f = msg.getPanoenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    panobandwidth: (f = msg.getPanobandwidth()) && proto.ProtoMessages.Float.toObject(includeInstance, f),
    panourl: (f = msg.getPanourl()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    adaptivebitrateenabled: (f = msg.getAdaptivebitrateenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    hdvideoformat: (f = msg.getHdvideoformat()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    hdenablendi: (f = msg.getHdenablendi()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    cameraenabled: (f = msg.getCameraenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    camerabandwidth: (f = msg.getCamerabandwidth()) && proto.ProtoMessages.Float.toObject(includeInstance, f),
    cameraurl: (f = msg.getCameraurl()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    cameravideoformat: (f = msg.getCameravideoformat()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    cameraenablendi: (f = msg.getCameraenablendi()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    panographicsenabled: (f = msg.getPanographicsenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.StreamsInfo}
 */
proto.ProtoMessages.StreamsInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.StreamsInfo;
  return proto.ProtoMessages.StreamsInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.StreamsInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.StreamsInfo}
 */
proto.ProtoMessages.StreamsInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setHdenabled(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Float;
      reader.readMessage(value,proto.ProtoMessages.Float.deserializeBinaryFromReader);
      msg.setHdbandwidth(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setHdurl(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setPanoenabled(value);
      break;
    case 5:
      var value = new proto.ProtoMessages.Float;
      reader.readMessage(value,proto.ProtoMessages.Float.deserializeBinaryFromReader);
      msg.setPanobandwidth(value);
      break;
    case 6:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setPanourl(value);
      break;
    case 7:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setAdaptivebitrateenabled(value);
      break;
    case 8:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setHdvideoformat(value);
      break;
    case 9:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setHdenablendi(value);
      break;
    case 10:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setCameraenabled(value);
      break;
    case 11:
      var value = new proto.ProtoMessages.Float;
      reader.readMessage(value,proto.ProtoMessages.Float.deserializeBinaryFromReader);
      msg.setCamerabandwidth(value);
      break;
    case 12:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setCameraurl(value);
      break;
    case 13:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setCameravideoformat(value);
      break;
    case 14:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setCameraenablendi(value);
      break;
    case 15:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setPanographicsenabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.StreamsInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.StreamsInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.StreamsInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.StreamsInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHdenabled();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getHdbandwidth();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Float.serializeBinaryToWriter
    );
  }
  f = message.getHdurl();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getPanoenabled();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getPanobandwidth();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ProtoMessages.Float.serializeBinaryToWriter
    );
  }
  f = message.getPanourl();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getAdaptivebitrateenabled();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getHdvideoformat();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getHdenablendi();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getCameraenabled();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getCamerabandwidth();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ProtoMessages.Float.serializeBinaryToWriter
    );
  }
  f = message.getCameraurl();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getCameravideoformat();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getCameraenablendi();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getPanographicsenabled();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool hdEnabled = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StreamsInfo.prototype.getHdenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setHdenabled = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearHdenabled = function() {
  return this.setHdenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasHdenabled = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Float hdBandwidth = 2;
 * @return {?proto.ProtoMessages.Float}
 */
proto.ProtoMessages.StreamsInfo.prototype.getHdbandwidth = function() {
  return /** @type{?proto.ProtoMessages.Float} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Float, 2));
};


/**
 * @param {?proto.ProtoMessages.Float|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setHdbandwidth = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearHdbandwidth = function() {
  return this.setHdbandwidth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasHdbandwidth = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional String hdUrl = 3;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StreamsInfo.prototype.getHdurl = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 3));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setHdurl = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearHdurl = function() {
  return this.setHdurl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasHdurl = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Bool panoEnabled = 4;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StreamsInfo.prototype.getPanoenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 4));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setPanoenabled = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearPanoenabled = function() {
  return this.setPanoenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasPanoenabled = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Float panoBandwidth = 5;
 * @return {?proto.ProtoMessages.Float}
 */
proto.ProtoMessages.StreamsInfo.prototype.getPanobandwidth = function() {
  return /** @type{?proto.ProtoMessages.Float} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Float, 5));
};


/**
 * @param {?proto.ProtoMessages.Float|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setPanobandwidth = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearPanobandwidth = function() {
  return this.setPanobandwidth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasPanobandwidth = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional String panoUrl = 6;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StreamsInfo.prototype.getPanourl = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 6));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setPanourl = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearPanourl = function() {
  return this.setPanourl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasPanourl = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Bool adaptiveBitrateEnabled = 7;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StreamsInfo.prototype.getAdaptivebitrateenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 7));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setAdaptivebitrateenabled = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearAdaptivebitrateenabled = function() {
  return this.setAdaptivebitrateenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasAdaptivebitrateenabled = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional String hdVideoFormat = 8;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StreamsInfo.prototype.getHdvideoformat = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 8));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setHdvideoformat = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearHdvideoformat = function() {
  return this.setHdvideoformat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasHdvideoformat = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Bool hdEnableNDI = 9;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StreamsInfo.prototype.getHdenablendi = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 9));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setHdenablendi = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearHdenablendi = function() {
  return this.setHdenablendi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasHdenablendi = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Bool cameraEnabled = 10;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StreamsInfo.prototype.getCameraenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 10));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setCameraenabled = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearCameraenabled = function() {
  return this.setCameraenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasCameraenabled = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Float cameraBandwidth = 11;
 * @return {?proto.ProtoMessages.Float}
 */
proto.ProtoMessages.StreamsInfo.prototype.getCamerabandwidth = function() {
  return /** @type{?proto.ProtoMessages.Float} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Float, 11));
};


/**
 * @param {?proto.ProtoMessages.Float|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setCamerabandwidth = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearCamerabandwidth = function() {
  return this.setCamerabandwidth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasCamerabandwidth = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional String cameraUrl = 12;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StreamsInfo.prototype.getCameraurl = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 12));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setCameraurl = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearCameraurl = function() {
  return this.setCameraurl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasCameraurl = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional String cameraVideoFormat = 13;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.StreamsInfo.prototype.getCameravideoformat = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 13));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setCameravideoformat = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearCameravideoformat = function() {
  return this.setCameravideoformat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasCameravideoformat = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Bool cameraEnableNDI = 14;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StreamsInfo.prototype.getCameraenablendi = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 14));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setCameraenablendi = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearCameraenablendi = function() {
  return this.setCameraenablendi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasCameraenablendi = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Bool panoGraphicsEnabled = 15;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StreamsInfo.prototype.getPanographicsenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 15));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
*/
proto.ProtoMessages.StreamsInfo.prototype.setPanographicsenabled = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StreamsInfo} returns this
 */
proto.ProtoMessages.StreamsInfo.prototype.clearPanographicsenabled = function() {
  return this.setPanographicsenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StreamsInfo.prototype.hasPanographicsenabled = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SwitchInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SwitchInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SwitchInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SwitchInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    ip: (f = msg.getIp()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    type: (f = msg.getType()) && proto.ProtoMessages.SwitchType.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SwitchInfo}
 */
proto.ProtoMessages.SwitchInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SwitchInfo;
  return proto.ProtoMessages.SwitchInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SwitchInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SwitchInfo}
 */
proto.ProtoMessages.SwitchInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setIp(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.SwitchType;
      reader.readMessage(value,proto.ProtoMessages.SwitchType.deserializeBinaryFromReader);
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SwitchInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SwitchInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SwitchInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SwitchInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.SwitchType.serializeBinaryToWriter
    );
  }
};


/**
 * optional String ip = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.SwitchInfo.prototype.getIp = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.SwitchInfo} returns this
*/
proto.ProtoMessages.SwitchInfo.prototype.setIp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.SwitchInfo} returns this
 */
proto.ProtoMessages.SwitchInfo.prototype.clearIp = function() {
  return this.setIp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.SwitchInfo.prototype.hasIp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SwitchType type = 2;
 * @return {?proto.ProtoMessages.SwitchType}
 */
proto.ProtoMessages.SwitchInfo.prototype.getType = function() {
  return /** @type{?proto.ProtoMessages.SwitchType} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.SwitchType, 2));
};


/**
 * @param {?proto.ProtoMessages.SwitchType|undefined} value
 * @return {!proto.ProtoMessages.SwitchInfo} returns this
*/
proto.ProtoMessages.SwitchInfo.prototype.setType = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.SwitchInfo} returns this
 */
proto.ProtoMessages.SwitchInfo.prototype.clearType = function() {
  return this.setType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.SwitchInfo.prototype.hasType = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CGEngineLogoDisplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CGEngineLogoDisplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CGEngineLogoDisplay.toObject = function(includeInstance, msg) {
  var f, obj = {
    logoenabled: (f = msg.getLogoenabled()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    logofadein: (f = msg.getLogofadein()) && proto.ProtoMessages.Int32.toObject(includeInstance, f),
    logofadeout: (f = msg.getLogofadeout()) && proto.ProtoMessages.Int32.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CGEngineLogoDisplay}
 */
proto.ProtoMessages.CGEngineLogoDisplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CGEngineLogoDisplay;
  return proto.ProtoMessages.CGEngineLogoDisplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CGEngineLogoDisplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CGEngineLogoDisplay}
 */
proto.ProtoMessages.CGEngineLogoDisplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setLogoenabled(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Int32;
      reader.readMessage(value,proto.ProtoMessages.Int32.deserializeBinaryFromReader);
      msg.setLogofadein(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Int32;
      reader.readMessage(value,proto.ProtoMessages.Int32.deserializeBinaryFromReader);
      msg.setLogofadeout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CGEngineLogoDisplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CGEngineLogoDisplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CGEngineLogoDisplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLogoenabled();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getLogofadein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Int32.serializeBinaryToWriter
    );
  }
  f = message.getLogofadeout();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Int32.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool logoEnabled = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.getLogoenabled = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.CGEngineLogoDisplay} returns this
*/
proto.ProtoMessages.CGEngineLogoDisplay.prototype.setLogoenabled = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CGEngineLogoDisplay} returns this
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.clearLogoenabled = function() {
  return this.setLogoenabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.hasLogoenabled = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Int32 logoFadeIn = 2;
 * @return {?proto.ProtoMessages.Int32}
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.getLogofadein = function() {
  return /** @type{?proto.ProtoMessages.Int32} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int32, 2));
};


/**
 * @param {?proto.ProtoMessages.Int32|undefined} value
 * @return {!proto.ProtoMessages.CGEngineLogoDisplay} returns this
*/
proto.ProtoMessages.CGEngineLogoDisplay.prototype.setLogofadein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CGEngineLogoDisplay} returns this
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.clearLogofadein = function() {
  return this.setLogofadein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.hasLogofadein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Int32 logoFadeOut = 3;
 * @return {?proto.ProtoMessages.Int32}
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.getLogofadeout = function() {
  return /** @type{?proto.ProtoMessages.Int32} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int32, 3));
};


/**
 * @param {?proto.ProtoMessages.Int32|undefined} value
 * @return {!proto.ProtoMessages.CGEngineLogoDisplay} returns this
*/
proto.ProtoMessages.CGEngineLogoDisplay.prototype.setLogofadeout = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CGEngineLogoDisplay} returns this
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.clearLogofadeout = function() {
  return this.setLogofadeout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CGEngineLogoDisplay.prototype.hasLogofadeout = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.GraphicEngineInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.GraphicEngineInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.GraphicEngineInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    sbtype: (f = msg.getSbtype()) && proto.ProtoMessages.ScoreboardType.toObject(includeInstance, f),
    ip: (f = msg.getIp()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    pipurl: (f = msg.getPipurl()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    cgetype: (f = msg.getCgetype()) && proto.ProtoMessages.CGEngineType.toObject(includeInstance, f),
    logodisplay: (f = msg.getLogodisplay()) && proto.ProtoMessages.CGEngineLogoDisplay.toObject(includeInstance, f),
    usesingular: (f = msg.getUsesingular()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    useocr: (f = msg.getUseocr()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    authentication: (f = msg.getAuthentication()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    useenhancedpip: (f = msg.getUseenhancedpip()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.GraphicEngineInfo}
 */
proto.ProtoMessages.GraphicEngineInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.GraphicEngineInfo;
  return proto.ProtoMessages.GraphicEngineInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.GraphicEngineInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.GraphicEngineInfo}
 */
proto.ProtoMessages.GraphicEngineInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.ScoreboardType;
      reader.readMessage(value,proto.ProtoMessages.ScoreboardType.deserializeBinaryFromReader);
      msg.setSbtype(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setIp(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setPipurl(value);
      break;
    case 4:
      var value = new proto.ProtoMessages.CGEngineType;
      reader.readMessage(value,proto.ProtoMessages.CGEngineType.deserializeBinaryFromReader);
      msg.setCgetype(value);
      break;
    case 5:
      var value = new proto.ProtoMessages.CGEngineLogoDisplay;
      reader.readMessage(value,proto.ProtoMessages.CGEngineLogoDisplay.deserializeBinaryFromReader);
      msg.setLogodisplay(value);
      break;
    case 6:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setUsesingular(value);
      break;
    case 7:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setUseocr(value);
      break;
    case 8:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setAuthentication(value);
      break;
    case 9:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setUseenhancedpip(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.GraphicEngineInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.GraphicEngineInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.GraphicEngineInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSbtype();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.ScoreboardType.serializeBinaryToWriter
    );
  }
  f = message.getIp();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getPipurl();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getCgetype();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ProtoMessages.CGEngineType.serializeBinaryToWriter
    );
  }
  f = message.getLogodisplay();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ProtoMessages.CGEngineLogoDisplay.serializeBinaryToWriter
    );
  }
  f = message.getUsesingular();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getUseocr();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getAuthentication();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getUseenhancedpip();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional ScoreboardType sbType = 1;
 * @return {?proto.ProtoMessages.ScoreboardType}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.getSbtype = function() {
  return /** @type{?proto.ProtoMessages.ScoreboardType} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.ScoreboardType, 1));
};


/**
 * @param {?proto.ProtoMessages.ScoreboardType|undefined} value
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
*/
proto.ProtoMessages.GraphicEngineInfo.prototype.setSbtype = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.clearSbtype = function() {
  return this.setSbtype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.hasSbtype = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional String ip = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.getIp = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
*/
proto.ProtoMessages.GraphicEngineInfo.prototype.setIp = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.clearIp = function() {
  return this.setIp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.hasIp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional String pipUrl = 3;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.getPipurl = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 3));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
*/
proto.ProtoMessages.GraphicEngineInfo.prototype.setPipurl = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.clearPipurl = function() {
  return this.setPipurl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.hasPipurl = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CGEngineType cgeType = 4;
 * @return {?proto.ProtoMessages.CGEngineType}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.getCgetype = function() {
  return /** @type{?proto.ProtoMessages.CGEngineType} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CGEngineType, 4));
};


/**
 * @param {?proto.ProtoMessages.CGEngineType|undefined} value
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
*/
proto.ProtoMessages.GraphicEngineInfo.prototype.setCgetype = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.clearCgetype = function() {
  return this.setCgetype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.hasCgetype = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional CGEngineLogoDisplay logoDisplay = 5;
 * @return {?proto.ProtoMessages.CGEngineLogoDisplay}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.getLogodisplay = function() {
  return /** @type{?proto.ProtoMessages.CGEngineLogoDisplay} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CGEngineLogoDisplay, 5));
};


/**
 * @param {?proto.ProtoMessages.CGEngineLogoDisplay|undefined} value
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
*/
proto.ProtoMessages.GraphicEngineInfo.prototype.setLogodisplay = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.clearLogodisplay = function() {
  return this.setLogodisplay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.hasLogodisplay = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Bool useSingular = 6;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.getUsesingular = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 6));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
*/
proto.ProtoMessages.GraphicEngineInfo.prototype.setUsesingular = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.clearUsesingular = function() {
  return this.setUsesingular(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.hasUsesingular = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Bool useOcr = 7;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.getUseocr = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 7));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
*/
proto.ProtoMessages.GraphicEngineInfo.prototype.setUseocr = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.clearUseocr = function() {
  return this.setUseocr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.hasUseocr = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional String authentication = 8;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.getAuthentication = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 8));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
*/
proto.ProtoMessages.GraphicEngineInfo.prototype.setAuthentication = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.clearAuthentication = function() {
  return this.setAuthentication(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.hasAuthentication = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Bool useEnhancedPip = 9;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.getUseenhancedpip = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 9));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
*/
proto.ProtoMessages.GraphicEngineInfo.prototype.setUseenhancedpip = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GraphicEngineInfo} returns this
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.clearUseenhancedpip = function() {
  return this.setUseenhancedpip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GraphicEngineInfo.prototype.hasUseenhancedpip = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.VersionMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.VersionMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.VersionMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.VersionMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    version: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.VersionMessage}
 */
proto.ProtoMessages.VersionMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.VersionMessage;
  return proto.ProtoMessages.VersionMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.VersionMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.VersionMessage}
 */
proto.ProtoMessages.VersionMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.VersionMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.VersionMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.VersionMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.VersionMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string version = 1;
 * @return {string}
 */
proto.ProtoMessages.VersionMessage.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.VersionMessage} returns this
 */
proto.ProtoMessages.VersionMessage.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OperatingSystemMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OperatingSystemMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OperatingSystemMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OperatingSystemMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    ostype: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OperatingSystemMessage}
 */
proto.ProtoMessages.OperatingSystemMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OperatingSystemMessage;
  return proto.ProtoMessages.OperatingSystemMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OperatingSystemMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OperatingSystemMessage}
 */
proto.ProtoMessages.OperatingSystemMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.OperatingSystemMessage.Type} */ (reader.readEnum());
      msg.setOstype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OperatingSystemMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OperatingSystemMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OperatingSystemMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OperatingSystemMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOstype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.OperatingSystemMessage.Type = {
  WINDOWS: 0,
  LINUX: 1,
  UNKNOWN: 2
};

/**
 * optional Type OsType = 1;
 * @return {!proto.ProtoMessages.OperatingSystemMessage.Type}
 */
proto.ProtoMessages.OperatingSystemMessage.prototype.getOstype = function() {
  return /** @type {!proto.ProtoMessages.OperatingSystemMessage.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.OperatingSystemMessage.Type} value
 * @return {!proto.ProtoMessages.OperatingSystemMessage} returns this
 */
proto.ProtoMessages.OperatingSystemMessage.prototype.setOstype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.Token.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.Token.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.Token} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Token.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.Token}
 */
proto.ProtoMessages.Token.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.Token;
  return proto.ProtoMessages.Token.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.Token} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.Token}
 */
proto.ProtoMessages.Token.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.Token.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.Token.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.Token} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Token.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.ProtoMessages.Token.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.Token} returns this
 */
proto.ProtoMessages.Token.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.ToggleSetupMode.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.ToggleSetupMode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.ToggleSetupMode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ToggleSetupMode.toObject = function(includeInstance, msg) {
  var f, obj = {
    activate: (f = msg.getActivate()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    vpustatus: (f = msg.getVpustatus()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    ispairing: (f = msg.getIspairing()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.ToggleSetupMode}
 */
proto.ProtoMessages.ToggleSetupMode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.ToggleSetupMode;
  return proto.ProtoMessages.ToggleSetupMode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.ToggleSetupMode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.ToggleSetupMode}
 */
proto.ProtoMessages.ToggleSetupMode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setActivate(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setVpustatus(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setIspairing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.ToggleSetupMode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.ToggleSetupMode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.ToggleSetupMode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ToggleSetupMode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getVpustatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getIspairing();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool activate = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.ToggleSetupMode.prototype.getActivate = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.ToggleSetupMode} returns this
*/
proto.ProtoMessages.ToggleSetupMode.prototype.setActivate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.ToggleSetupMode} returns this
 */
proto.ProtoMessages.ToggleSetupMode.prototype.clearActivate = function() {
  return this.setActivate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.ToggleSetupMode.prototype.hasActivate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional String vpuStatus = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.ToggleSetupMode.prototype.getVpustatus = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.ToggleSetupMode} returns this
*/
proto.ProtoMessages.ToggleSetupMode.prototype.setVpustatus = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.ToggleSetupMode} returns this
 */
proto.ProtoMessages.ToggleSetupMode.prototype.clearVpustatus = function() {
  return this.setVpustatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.ToggleSetupMode.prototype.hasVpustatus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Bool isPairing = 3;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.ToggleSetupMode.prototype.getIspairing = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 3));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.ToggleSetupMode} returns this
*/
proto.ProtoMessages.ToggleSetupMode.prototype.setIspairing = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.ToggleSetupMode} returns this
 */
proto.ProtoMessages.ToggleSetupMode.prototype.clearIspairing = function() {
  return this.setIspairing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.ToggleSetupMode.prototype.hasIspairing = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.CameraFramesData.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CameraFramesData.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CameraFramesData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CameraFramesData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraFramesData.toObject = function(includeInstance, msg) {
  var f, obj = {
    numofframes: (f = msg.getNumofframes()) && proto.ProtoMessages.Int32.toObject(includeInstance, f),
    result: (f = msg.getResult()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    framesList: jspb.Message.toObjectList(msg.getFramesList(),
    proto.ProtoMessages.String.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CameraFramesData}
 */
proto.ProtoMessages.CameraFramesData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CameraFramesData;
  return proto.ProtoMessages.CameraFramesData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CameraFramesData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CameraFramesData}
 */
proto.ProtoMessages.CameraFramesData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Int32;
      reader.readMessage(value,proto.ProtoMessages.Int32.deserializeBinaryFromReader);
      msg.setNumofframes(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.addFrames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CameraFramesData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CameraFramesData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CameraFramesData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraFramesData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumofframes();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Int32.serializeBinaryToWriter
    );
  }
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getFramesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
};


/**
 * optional Int32 numOfFrames = 1;
 * @return {?proto.ProtoMessages.Int32}
 */
proto.ProtoMessages.CameraFramesData.prototype.getNumofframes = function() {
  return /** @type{?proto.ProtoMessages.Int32} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Int32, 1));
};


/**
 * @param {?proto.ProtoMessages.Int32|undefined} value
 * @return {!proto.ProtoMessages.CameraFramesData} returns this
*/
proto.ProtoMessages.CameraFramesData.prototype.setNumofframes = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraFramesData} returns this
 */
proto.ProtoMessages.CameraFramesData.prototype.clearNumofframes = function() {
  return this.setNumofframes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraFramesData.prototype.hasNumofframes = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional String Result = 2;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CameraFramesData.prototype.getResult = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 2));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CameraFramesData} returns this
*/
proto.ProtoMessages.CameraFramesData.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraFramesData} returns this
 */
proto.ProtoMessages.CameraFramesData.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraFramesData.prototype.hasResult = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated String frames = 3;
 * @return {!Array<!proto.ProtoMessages.String>}
 */
proto.ProtoMessages.CameraFramesData.prototype.getFramesList = function() {
  return /** @type{!Array<!proto.ProtoMessages.String>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.String, 3));
};


/**
 * @param {!Array<!proto.ProtoMessages.String>} value
 * @return {!proto.ProtoMessages.CameraFramesData} returns this
*/
proto.ProtoMessages.CameraFramesData.prototype.setFramesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.ProtoMessages.String=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.String}
 */
proto.ProtoMessages.CameraFramesData.prototype.addFrames = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.ProtoMessages.String, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.CameraFramesData} returns this
 */
proto.ProtoMessages.CameraFramesData.prototype.clearFramesList = function() {
  return this.setFramesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.TestPorts.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.TestPorts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.TestPorts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TestPorts.toObject = function(includeInstance, msg) {
  var f, obj = {
    portnumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
    index: jspb.Message.getFieldWithDefault(msg, 2, ""),
    testtcp: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    testudp: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.TestPorts}
 */
proto.ProtoMessages.TestPorts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.TestPorts;
  return proto.ProtoMessages.TestPorts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.TestPorts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.TestPorts}
 */
proto.ProtoMessages.TestPorts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPortnumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndex(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTesttcp(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTestudp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.TestPorts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.TestPorts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.TestPorts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TestPorts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortnumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIndex();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTesttcp();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTestudp();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int32 portNumber = 1;
 * @return {number}
 */
proto.ProtoMessages.TestPorts.prototype.getPortnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.TestPorts} returns this
 */
proto.ProtoMessages.TestPorts.prototype.setPortnumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string index = 2;
 * @return {string}
 */
proto.ProtoMessages.TestPorts.prototype.getIndex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.TestPorts} returns this
 */
proto.ProtoMessages.TestPorts.prototype.setIndex = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool testTCP = 3;
 * @return {boolean}
 */
proto.ProtoMessages.TestPorts.prototype.getTesttcp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.TestPorts} returns this
 */
proto.ProtoMessages.TestPorts.prototype.setTesttcp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool testUDP = 4;
 * @return {boolean}
 */
proto.ProtoMessages.TestPorts.prototype.getTestudp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.TestPorts} returns this
 */
proto.ProtoMessages.TestPorts.prototype.setTestudp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.TestPortsResult.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.TestPortsResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.TestPortsResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TestPortsResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    portnumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
    index: jspb.Message.getFieldWithDefault(msg, 2, ""),
    testtcpresult: jspb.Message.getFieldWithDefault(msg, 3, 0),
    testudpresult: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.TestPortsResult}
 */
proto.ProtoMessages.TestPortsResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.TestPortsResult;
  return proto.ProtoMessages.TestPortsResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.TestPortsResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.TestPortsResult}
 */
proto.ProtoMessages.TestPortsResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPortnumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndex(value);
      break;
    case 3:
      var value = /** @type {!proto.ProtoMessages.TestPortsResult.Result} */ (reader.readEnum());
      msg.setTesttcpresult(value);
      break;
    case 4:
      var value = /** @type {!proto.ProtoMessages.TestPortsResult.Result} */ (reader.readEnum());
      msg.setTestudpresult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.TestPortsResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.TestPortsResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.TestPortsResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TestPortsResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortnumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIndex();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTesttcpresult();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTestudpresult();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.TestPortsResult.Result = {
  NA: 0,
  CONNECTED: 1,
  BLOCKED: 2
};

/**
 * optional int32 portNumber = 1;
 * @return {number}
 */
proto.ProtoMessages.TestPortsResult.prototype.getPortnumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.TestPortsResult} returns this
 */
proto.ProtoMessages.TestPortsResult.prototype.setPortnumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string index = 2;
 * @return {string}
 */
proto.ProtoMessages.TestPortsResult.prototype.getIndex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.TestPortsResult} returns this
 */
proto.ProtoMessages.TestPortsResult.prototype.setIndex = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Result testTCPResult = 3;
 * @return {!proto.ProtoMessages.TestPortsResult.Result}
 */
proto.ProtoMessages.TestPortsResult.prototype.getTesttcpresult = function() {
  return /** @type {!proto.ProtoMessages.TestPortsResult.Result} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.ProtoMessages.TestPortsResult.Result} value
 * @return {!proto.ProtoMessages.TestPortsResult} returns this
 */
proto.ProtoMessages.TestPortsResult.prototype.setTesttcpresult = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Result testUDPResult = 4;
 * @return {!proto.ProtoMessages.TestPortsResult.Result}
 */
proto.ProtoMessages.TestPortsResult.prototype.getTestudpresult = function() {
  return /** @type {!proto.ProtoMessages.TestPortsResult.Result} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.ProtoMessages.TestPortsResult.Result} value
 * @return {!proto.ProtoMessages.TestPortsResult} returns this
 */
proto.ProtoMessages.TestPortsResult.prototype.setTestudpresult = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.TestStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.TestStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.TestStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TestStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    index: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.TestStatus}
 */
proto.ProtoMessages.TestStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.TestStatus;
  return proto.ProtoMessages.TestStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.TestStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.TestStatus}
 */
proto.ProtoMessages.TestStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.TestStatus.StatusType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.TestStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.TestStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.TestStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TestStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getIndex();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.TestStatus.StatusType = {
  NONE: 0,
  MAINBE: 1,
  RABBITMQ: 2
};

/**
 * optional StatusType type = 1;
 * @return {!proto.ProtoMessages.TestStatus.StatusType}
 */
proto.ProtoMessages.TestStatus.prototype.getType = function() {
  return /** @type {!proto.ProtoMessages.TestStatus.StatusType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.TestStatus.StatusType} value
 * @return {!proto.ProtoMessages.TestStatus} returns this
 */
proto.ProtoMessages.TestStatus.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string index = 2;
 * @return {string}
 */
proto.ProtoMessages.TestStatus.prototype.getIndex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.TestStatus} returns this
 */
proto.ProtoMessages.TestStatus.prototype.setIndex = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.TestStatusResult.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.TestStatusResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.TestStatusResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TestStatusResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    index: jspb.Message.getFieldWithDefault(msg, 2, ""),
    testresult: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.TestStatusResult}
 */
proto.ProtoMessages.TestStatusResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.TestStatusResult;
  return proto.ProtoMessages.TestStatusResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.TestStatusResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.TestStatusResult}
 */
proto.ProtoMessages.TestStatusResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.TestStatusResult.StatusType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndex(value);
      break;
    case 3:
      var value = /** @type {!proto.ProtoMessages.TestStatusResult.Result} */ (reader.readEnum());
      msg.setTestresult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.TestStatusResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.TestStatusResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.TestStatusResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TestStatusResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getIndex();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTestresult();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.TestStatusResult.Result = {
  NA: 0,
  CONNECTED: 1,
  BLOCKED: 2
};

/**
 * @enum {number}
 */
proto.ProtoMessages.TestStatusResult.StatusType = {
  NONE: 0,
  MAINBE: 1
};

/**
 * optional StatusType type = 1;
 * @return {!proto.ProtoMessages.TestStatusResult.StatusType}
 */
proto.ProtoMessages.TestStatusResult.prototype.getType = function() {
  return /** @type {!proto.ProtoMessages.TestStatusResult.StatusType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.TestStatusResult.StatusType} value
 * @return {!proto.ProtoMessages.TestStatusResult} returns this
 */
proto.ProtoMessages.TestStatusResult.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string index = 2;
 * @return {string}
 */
proto.ProtoMessages.TestStatusResult.prototype.getIndex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.TestStatusResult} returns this
 */
proto.ProtoMessages.TestStatusResult.prototype.setIndex = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Result testResult = 3;
 * @return {!proto.ProtoMessages.TestStatusResult.Result}
 */
proto.ProtoMessages.TestStatusResult.prototype.getTestresult = function() {
  return /** @type {!proto.ProtoMessages.TestStatusResult.Result} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.ProtoMessages.TestStatusResult.Result} value
 * @return {!proto.ProtoMessages.TestStatusResult} returns this
 */
proto.ProtoMessages.TestStatusResult.prototype.setTestresult = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.NetworkTestRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.NetworkTestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.NetworkTestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.NetworkTestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NetworkTestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestporttestingList: jspb.Message.toObjectList(msg.getRequestporttestingList(),
    proto.ProtoMessages.TestPorts.toObject, includeInstance),
    requeststatustestingList: jspb.Message.toObjectList(msg.getRequeststatustestingList(),
    proto.ProtoMessages.TestStatus.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.NetworkTestRequest}
 */
proto.ProtoMessages.NetworkTestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.NetworkTestRequest;
  return proto.ProtoMessages.NetworkTestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.NetworkTestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.NetworkTestRequest}
 */
proto.ProtoMessages.NetworkTestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.TestPorts;
      reader.readMessage(value,proto.ProtoMessages.TestPorts.deserializeBinaryFromReader);
      msg.addRequestporttesting(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.TestStatus;
      reader.readMessage(value,proto.ProtoMessages.TestStatus.deserializeBinaryFromReader);
      msg.addRequeststatustesting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.NetworkTestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.NetworkTestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.NetworkTestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NetworkTestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestporttestingList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ProtoMessages.TestPorts.serializeBinaryToWriter
    );
  }
  f = message.getRequeststatustestingList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.ProtoMessages.TestStatus.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TestPorts requestPortTesting = 1;
 * @return {!Array<!proto.ProtoMessages.TestPorts>}
 */
proto.ProtoMessages.NetworkTestRequest.prototype.getRequestporttestingList = function() {
  return /** @type{!Array<!proto.ProtoMessages.TestPorts>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.TestPorts, 1));
};


/**
 * @param {!Array<!proto.ProtoMessages.TestPorts>} value
 * @return {!proto.ProtoMessages.NetworkTestRequest} returns this
*/
proto.ProtoMessages.NetworkTestRequest.prototype.setRequestporttestingList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ProtoMessages.TestPorts=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.TestPorts}
 */
proto.ProtoMessages.NetworkTestRequest.prototype.addRequestporttesting = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ProtoMessages.TestPorts, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.NetworkTestRequest} returns this
 */
proto.ProtoMessages.NetworkTestRequest.prototype.clearRequestporttestingList = function() {
  return this.setRequestporttestingList([]);
};


/**
 * repeated TestStatus requestStatusTesting = 2;
 * @return {!Array<!proto.ProtoMessages.TestStatus>}
 */
proto.ProtoMessages.NetworkTestRequest.prototype.getRequeststatustestingList = function() {
  return /** @type{!Array<!proto.ProtoMessages.TestStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.TestStatus, 2));
};


/**
 * @param {!Array<!proto.ProtoMessages.TestStatus>} value
 * @return {!proto.ProtoMessages.NetworkTestRequest} returns this
*/
proto.ProtoMessages.NetworkTestRequest.prototype.setRequeststatustestingList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ProtoMessages.TestStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.TestStatus}
 */
proto.ProtoMessages.NetworkTestRequest.prototype.addRequeststatustesting = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ProtoMessages.TestStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.NetworkTestRequest} returns this
 */
proto.ProtoMessages.NetworkTestRequest.prototype.clearRequeststatustestingList = function() {
  return this.setRequeststatustestingList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.NetworkTestResult.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.NetworkTestResult.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.NetworkTestResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.NetworkTestResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NetworkTestResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    testportsresultList: jspb.Message.toObjectList(msg.getTestportsresultList(),
    proto.ProtoMessages.TestPortsResult.toObject, includeInstance),
    teststatusresultList: jspb.Message.toObjectList(msg.getTeststatusresultList(),
    proto.ProtoMessages.TestStatusResult.toObject, includeInstance),
    testpassed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.NetworkTestResult}
 */
proto.ProtoMessages.NetworkTestResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.NetworkTestResult;
  return proto.ProtoMessages.NetworkTestResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.NetworkTestResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.NetworkTestResult}
 */
proto.ProtoMessages.NetworkTestResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.TestPortsResult;
      reader.readMessage(value,proto.ProtoMessages.TestPortsResult.deserializeBinaryFromReader);
      msg.addTestportsresult(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.TestStatusResult;
      reader.readMessage(value,proto.ProtoMessages.TestStatusResult.deserializeBinaryFromReader);
      msg.addTeststatusresult(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTestpassed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.NetworkTestResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.NetworkTestResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.NetworkTestResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NetworkTestResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestportsresultList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ProtoMessages.TestPortsResult.serializeBinaryToWriter
    );
  }
  f = message.getTeststatusresultList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.ProtoMessages.TestStatusResult.serializeBinaryToWriter
    );
  }
  f = message.getTestpassed();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * repeated TestPortsResult testPortsResult = 1;
 * @return {!Array<!proto.ProtoMessages.TestPortsResult>}
 */
proto.ProtoMessages.NetworkTestResult.prototype.getTestportsresultList = function() {
  return /** @type{!Array<!proto.ProtoMessages.TestPortsResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.TestPortsResult, 1));
};


/**
 * @param {!Array<!proto.ProtoMessages.TestPortsResult>} value
 * @return {!proto.ProtoMessages.NetworkTestResult} returns this
*/
proto.ProtoMessages.NetworkTestResult.prototype.setTestportsresultList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ProtoMessages.TestPortsResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.TestPortsResult}
 */
proto.ProtoMessages.NetworkTestResult.prototype.addTestportsresult = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ProtoMessages.TestPortsResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.NetworkTestResult} returns this
 */
proto.ProtoMessages.NetworkTestResult.prototype.clearTestportsresultList = function() {
  return this.setTestportsresultList([]);
};


/**
 * repeated TestStatusResult testStatusResult = 2;
 * @return {!Array<!proto.ProtoMessages.TestStatusResult>}
 */
proto.ProtoMessages.NetworkTestResult.prototype.getTeststatusresultList = function() {
  return /** @type{!Array<!proto.ProtoMessages.TestStatusResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.TestStatusResult, 2));
};


/**
 * @param {!Array<!proto.ProtoMessages.TestStatusResult>} value
 * @return {!proto.ProtoMessages.NetworkTestResult} returns this
*/
proto.ProtoMessages.NetworkTestResult.prototype.setTeststatusresultList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ProtoMessages.TestStatusResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.TestStatusResult}
 */
proto.ProtoMessages.NetworkTestResult.prototype.addTeststatusresult = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ProtoMessages.TestStatusResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.NetworkTestResult} returns this
 */
proto.ProtoMessages.NetworkTestResult.prototype.clearTeststatusresultList = function() {
  return this.setTeststatusresultList([]);
};


/**
 * optional bool testPassed = 3;
 * @return {boolean}
 */
proto.ProtoMessages.NetworkTestResult.prototype.getTestpassed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.NetworkTestResult} returns this
 */
proto.ProtoMessages.NetworkTestResult.prototype.setTestpassed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.NetworkValidation.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.NetworkValidation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.NetworkValidation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NetworkValidation.toObject = function(includeInstance, msg) {
  var f, obj = {
    validated: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.NetworkValidation}
 */
proto.ProtoMessages.NetworkValidation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.NetworkValidation;
  return proto.ProtoMessages.NetworkValidation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.NetworkValidation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.NetworkValidation}
 */
proto.ProtoMessages.NetworkValidation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValidated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.NetworkValidation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.NetworkValidation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.NetworkValidation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.NetworkValidation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValidated();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool validated = 1;
 * @return {boolean}
 */
proto.ProtoMessages.NetworkValidation.prototype.getValidated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.NetworkValidation} returns this
 */
proto.ProtoMessages.NetworkValidation.prototype.setValidated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CCUPreset.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CCUPreset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CCUPreset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CCUPreset.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: (f = msg.getName()) && proto.ProtoMessages.String.toObject(includeInstance, f),
    presettype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ccuvalues: (f = msg.getCcuvalues()) && proto.ProtoMessages.CCUData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CCUPreset}
 */
proto.ProtoMessages.CCUPreset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CCUPreset;
  return proto.ProtoMessages.CCUPreset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CCUPreset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CCUPreset}
 */
proto.ProtoMessages.CCUPreset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.String;
      reader.readMessage(value,proto.ProtoMessages.String.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.ProtoMessages.CCUPreset.PresetType} */ (reader.readEnum());
      msg.setPresettype(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.CCUData;
      reader.readMessage(value,proto.ProtoMessages.CCUData.deserializeBinaryFromReader);
      msg.setCcuvalues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CCUPreset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CCUPreset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CCUPreset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CCUPreset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.String.serializeBinaryToWriter
    );
  }
  f = message.getPresettype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCcuvalues();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.CCUData.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.CCUPreset.PresetType = {
  PREDEFINED: 0,
  USER: 1
};

/**
 * optional String name = 1;
 * @return {?proto.ProtoMessages.String}
 */
proto.ProtoMessages.CCUPreset.prototype.getName = function() {
  return /** @type{?proto.ProtoMessages.String} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.String, 1));
};


/**
 * @param {?proto.ProtoMessages.String|undefined} value
 * @return {!proto.ProtoMessages.CCUPreset} returns this
*/
proto.ProtoMessages.CCUPreset.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CCUPreset} returns this
 */
proto.ProtoMessages.CCUPreset.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CCUPreset.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PresetType presetType = 2;
 * @return {!proto.ProtoMessages.CCUPreset.PresetType}
 */
proto.ProtoMessages.CCUPreset.prototype.getPresettype = function() {
  return /** @type {!proto.ProtoMessages.CCUPreset.PresetType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ProtoMessages.CCUPreset.PresetType} value
 * @return {!proto.ProtoMessages.CCUPreset} returns this
 */
proto.ProtoMessages.CCUPreset.prototype.setPresettype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional CCUData ccuValues = 3;
 * @return {?proto.ProtoMessages.CCUData}
 */
proto.ProtoMessages.CCUPreset.prototype.getCcuvalues = function() {
  return /** @type{?proto.ProtoMessages.CCUData} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.CCUData, 3));
};


/**
 * @param {?proto.ProtoMessages.CCUData|undefined} value
 * @return {!proto.ProtoMessages.CCUPreset} returns this
*/
proto.ProtoMessages.CCUPreset.prototype.setCcuvalues = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CCUPreset} returns this
 */
proto.ProtoMessages.CCUPreset.prototype.clearCcuvalues = function() {
  return this.setCcuvalues(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CCUPreset.prototype.hasCcuvalues = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.BigDataMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.BigDataMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.BigDataMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.BigDataMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    messagetypestr: jspb.Message.getFieldWithDefault(msg, 1, ""),
    uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    chunkindex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalchunks: jspb.Message.getFieldWithDefault(msg, 4, 0),
    totalbytes: jspb.Message.getFieldWithDefault(msg, 5, 0),
    offset: jspb.Message.getFieldWithDefault(msg, 6, 0),
    messagecontent: msg.getMessagecontent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.BigDataMessage}
 */
proto.ProtoMessages.BigDataMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.BigDataMessage;
  return proto.ProtoMessages.BigDataMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.BigDataMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.BigDataMessage}
 */
proto.ProtoMessages.BigDataMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessagetypestr(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setChunkindex(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalchunks(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalbytes(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOffset(value);
      break;
    case 7:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMessagecontent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.BigDataMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.BigDataMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.BigDataMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.BigDataMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagetypestr();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChunkindex();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotalchunks();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getTotalbytes();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getMessagecontent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      7,
      f
    );
  }
};


/**
 * optional string messageTypeStr = 1;
 * @return {string}
 */
proto.ProtoMessages.BigDataMessage.prototype.getMessagetypestr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.BigDataMessage} returns this
 */
proto.ProtoMessages.BigDataMessage.prototype.setMessagetypestr = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.ProtoMessages.BigDataMessage.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.BigDataMessage} returns this
 */
proto.ProtoMessages.BigDataMessage.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 chunkIndex = 3;
 * @return {number}
 */
proto.ProtoMessages.BigDataMessage.prototype.getChunkindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.BigDataMessage} returns this
 */
proto.ProtoMessages.BigDataMessage.prototype.setChunkindex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 totalChunks = 4;
 * @return {number}
 */
proto.ProtoMessages.BigDataMessage.prototype.getTotalchunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.BigDataMessage} returns this
 */
proto.ProtoMessages.BigDataMessage.prototype.setTotalchunks = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 totalBytes = 5;
 * @return {number}
 */
proto.ProtoMessages.BigDataMessage.prototype.getTotalbytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.BigDataMessage} returns this
 */
proto.ProtoMessages.BigDataMessage.prototype.setTotalbytes = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint64 offset = 6;
 * @return {number}
 */
proto.ProtoMessages.BigDataMessage.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.BigDataMessage} returns this
 */
proto.ProtoMessages.BigDataMessage.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bytes messageContent = 7;
 * @return {!(string|Uint8Array)}
 */
proto.ProtoMessages.BigDataMessage.prototype.getMessagecontent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * optional bytes messageContent = 7;
 * This is a type-conversion wrapper around `getMessagecontent()`
 * @return {string}
 */
proto.ProtoMessages.BigDataMessage.prototype.getMessagecontent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMessagecontent()));
};


/**
 * optional bytes messageContent = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessagecontent()`
 * @return {!Uint8Array}
 */
proto.ProtoMessages.BigDataMessage.prototype.getMessagecontent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMessagecontent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.ProtoMessages.BigDataMessage} returns this
 */
proto.ProtoMessages.BigDataMessage.prototype.setMessagecontent = function(value) {
  return jspb.Message.setProto3BytesField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.DataChunkMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.DataChunkMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.DataChunkMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.DataChunkMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalbytes: jspb.Message.getFieldWithDefault(msg, 1, 0),
    totalchunks: jspb.Message.getFieldWithDefault(msg, 2, 0),
    bytesperchunk: jspb.Message.getFieldWithDefault(msg, 3, 0),
    chunkindex: jspb.Message.getFieldWithDefault(msg, 4, 0),
    chunkoffset: jspb.Message.getFieldWithDefault(msg, 5, 0),
    chunksize: jspb.Message.getFieldWithDefault(msg, 6, 0),
    chunkcontent: msg.getChunkcontent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.DataChunkMessage}
 */
proto.ProtoMessages.DataChunkMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.DataChunkMessage;
  return proto.ProtoMessages.DataChunkMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.DataChunkMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.DataChunkMessage}
 */
proto.ProtoMessages.DataChunkMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalbytes(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalchunks(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBytesperchunk(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setChunkindex(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setChunkoffset(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setChunksize(value);
      break;
    case 7:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setChunkcontent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.DataChunkMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.DataChunkMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.DataChunkMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.DataChunkMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalbytes();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getTotalchunks();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getBytesperchunk();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getChunkindex();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getChunkoffset();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getChunksize();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getChunkcontent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      7,
      f
    );
  }
};


/**
 * optional uint32 totalBytes = 1;
 * @return {number}
 */
proto.ProtoMessages.DataChunkMessage.prototype.getTotalbytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.DataChunkMessage} returns this
 */
proto.ProtoMessages.DataChunkMessage.prototype.setTotalbytes = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 totalChunks = 2;
 * @return {number}
 */
proto.ProtoMessages.DataChunkMessage.prototype.getTotalchunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.DataChunkMessage} returns this
 */
proto.ProtoMessages.DataChunkMessage.prototype.setTotalchunks = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 bytesPerChunk = 3;
 * @return {number}
 */
proto.ProtoMessages.DataChunkMessage.prototype.getBytesperchunk = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.DataChunkMessage} returns this
 */
proto.ProtoMessages.DataChunkMessage.prototype.setBytesperchunk = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 chunkIndex = 4;
 * @return {number}
 */
proto.ProtoMessages.DataChunkMessage.prototype.getChunkindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.DataChunkMessage} returns this
 */
proto.ProtoMessages.DataChunkMessage.prototype.setChunkindex = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 chunkOffset = 5;
 * @return {number}
 */
proto.ProtoMessages.DataChunkMessage.prototype.getChunkoffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.DataChunkMessage} returns this
 */
proto.ProtoMessages.DataChunkMessage.prototype.setChunkoffset = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 chunkSize = 6;
 * @return {number}
 */
proto.ProtoMessages.DataChunkMessage.prototype.getChunksize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.DataChunkMessage} returns this
 */
proto.ProtoMessages.DataChunkMessage.prototype.setChunksize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bytes chunkContent = 7;
 * @return {!(string|Uint8Array)}
 */
proto.ProtoMessages.DataChunkMessage.prototype.getChunkcontent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * optional bytes chunkContent = 7;
 * This is a type-conversion wrapper around `getChunkcontent()`
 * @return {string}
 */
proto.ProtoMessages.DataChunkMessage.prototype.getChunkcontent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getChunkcontent()));
};


/**
 * optional bytes chunkContent = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChunkcontent()`
 * @return {!Uint8Array}
 */
proto.ProtoMessages.DataChunkMessage.prototype.getChunkcontent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getChunkcontent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.ProtoMessages.DataChunkMessage} returns this
 */
proto.ProtoMessages.DataChunkMessage.prototype.setChunkcontent = function(value) {
  return jspb.Message.setProto3BytesField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.FileChunkMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.FileChunkMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.FileChunkMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.FileChunkMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    datachunk: (f = msg.getDatachunk()) && proto.ProtoMessages.DataChunkMessage.toObject(includeInstance, f),
    filename: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.FileChunkMessage}
 */
proto.ProtoMessages.FileChunkMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.FileChunkMessage;
  return proto.ProtoMessages.FileChunkMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.FileChunkMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.FileChunkMessage}
 */
proto.ProtoMessages.FileChunkMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.DataChunkMessage;
      reader.readMessage(value,proto.ProtoMessages.DataChunkMessage.deserializeBinaryFromReader);
      msg.setDatachunk(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.FileChunkMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.FileChunkMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.FileChunkMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.FileChunkMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDatachunk();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.DataChunkMessage.serializeBinaryToWriter
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional DataChunkMessage dataChunk = 1;
 * @return {?proto.ProtoMessages.DataChunkMessage}
 */
proto.ProtoMessages.FileChunkMessage.prototype.getDatachunk = function() {
  return /** @type{?proto.ProtoMessages.DataChunkMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.DataChunkMessage, 1));
};


/**
 * @param {?proto.ProtoMessages.DataChunkMessage|undefined} value
 * @return {!proto.ProtoMessages.FileChunkMessage} returns this
*/
proto.ProtoMessages.FileChunkMessage.prototype.setDatachunk = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.FileChunkMessage} returns this
 */
proto.ProtoMessages.FileChunkMessage.prototype.clearDatachunk = function() {
  return this.setDatachunk(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.FileChunkMessage.prototype.hasDatachunk = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.ProtoMessages.FileChunkMessage.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.FileChunkMessage} returns this
 */
proto.ProtoMessages.FileChunkMessage.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CameraFramesRequestMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CameraFramesRequestMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CameraFramesRequestMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraFramesRequestMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    frametype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    replytype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rotateframes: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CameraFramesRequestMessage}
 */
proto.ProtoMessages.CameraFramesRequestMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CameraFramesRequestMessage;
  return proto.ProtoMessages.CameraFramesRequestMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CameraFramesRequestMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CameraFramesRequestMessage}
 */
proto.ProtoMessages.CameraFramesRequestMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {!proto.ProtoMessages.FrameType} */ (reader.readEnum());
      msg.setFrametype(value);
      break;
    case 3:
      var value = /** @type {!proto.ProtoMessages.CaptureFramesReplyType} */ (reader.readEnum());
      msg.setReplytype(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRotateframes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CameraFramesRequestMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CameraFramesRequestMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CameraFramesRequestMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraFramesRequestMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFrametype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReplytype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getRotateframes();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string requestId = 1;
 * @return {string}
 */
proto.ProtoMessages.CameraFramesRequestMessage.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraFramesRequestMessage} returns this
 */
proto.ProtoMessages.CameraFramesRequestMessage.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FrameType frameType = 2;
 * @return {!proto.ProtoMessages.FrameType}
 */
proto.ProtoMessages.CameraFramesRequestMessage.prototype.getFrametype = function() {
  return /** @type {!proto.ProtoMessages.FrameType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ProtoMessages.FrameType} value
 * @return {!proto.ProtoMessages.CameraFramesRequestMessage} returns this
 */
proto.ProtoMessages.CameraFramesRequestMessage.prototype.setFrametype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional CaptureFramesReplyType replyType = 3;
 * @return {!proto.ProtoMessages.CaptureFramesReplyType}
 */
proto.ProtoMessages.CameraFramesRequestMessage.prototype.getReplytype = function() {
  return /** @type {!proto.ProtoMessages.CaptureFramesReplyType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.ProtoMessages.CaptureFramesReplyType} value
 * @return {!proto.ProtoMessages.CameraFramesRequestMessage} returns this
 */
proto.ProtoMessages.CameraFramesRequestMessage.prototype.setReplytype = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool rotateFrames = 4;
 * @return {boolean}
 */
proto.ProtoMessages.CameraFramesRequestMessage.prototype.getRotateframes = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.CameraFramesRequestMessage} returns this
 */
proto.ProtoMessages.CameraFramesRequestMessage.prototype.setRotateframes = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CameraFramesReplyMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CameraFramesReplyMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraFramesReplyMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    frametype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    framescount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    frameindex: jspb.Message.getFieldWithDefault(msg, 4, 0),
    datamsg: (f = msg.getDatamsg()) && proto.ProtoMessages.DataChunkMessage.toObject(includeInstance, f),
    framerotation: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CameraFramesReplyMessage}
 */
proto.ProtoMessages.CameraFramesReplyMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CameraFramesReplyMessage;
  return proto.ProtoMessages.CameraFramesReplyMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CameraFramesReplyMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CameraFramesReplyMessage}
 */
proto.ProtoMessages.CameraFramesReplyMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {!proto.ProtoMessages.FrameType} */ (reader.readEnum());
      msg.setFrametype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFramescount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFrameindex(value);
      break;
    case 5:
      var value = new proto.ProtoMessages.DataChunkMessage;
      reader.readMessage(value,proto.ProtoMessages.DataChunkMessage.deserializeBinaryFromReader);
      msg.setDatamsg(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFramerotation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CameraFramesReplyMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CameraFramesReplyMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraFramesReplyMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFrametype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFramescount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getFrameindex();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getDatamsg();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ProtoMessages.DataChunkMessage.serializeBinaryToWriter
    );
  }
  f = message.getFramerotation();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string requestId = 1;
 * @return {string}
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraFramesReplyMessage} returns this
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FrameType frameType = 2;
 * @return {!proto.ProtoMessages.FrameType}
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.getFrametype = function() {
  return /** @type {!proto.ProtoMessages.FrameType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ProtoMessages.FrameType} value
 * @return {!proto.ProtoMessages.CameraFramesReplyMessage} returns this
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.setFrametype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint32 framesCount = 3;
 * @return {number}
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.getFramescount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CameraFramesReplyMessage} returns this
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.setFramescount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 frameIndex = 4;
 * @return {number}
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.getFrameindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CameraFramesReplyMessage} returns this
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.setFrameindex = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional DataChunkMessage dataMsg = 5;
 * @return {?proto.ProtoMessages.DataChunkMessage}
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.getDatamsg = function() {
  return /** @type{?proto.ProtoMessages.DataChunkMessage} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.DataChunkMessage, 5));
};


/**
 * @param {?proto.ProtoMessages.DataChunkMessage|undefined} value
 * @return {!proto.ProtoMessages.CameraFramesReplyMessage} returns this
*/
proto.ProtoMessages.CameraFramesReplyMessage.prototype.setDatamsg = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CameraFramesReplyMessage} returns this
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.clearDatamsg = function() {
  return this.setDatamsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.hasDatamsg = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 frameRotation = 6;
 * @return {number}
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.getFramerotation = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.CameraFramesReplyMessage} returns this
 */
proto.ProtoMessages.CameraFramesReplyMessage.prototype.setFramerotation = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CameraFramesFailureReplyMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CameraFramesFailureReplyMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    frametype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    failurereason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CameraFramesFailureReplyMessage}
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CameraFramesFailureReplyMessage;
  return proto.ProtoMessages.CameraFramesFailureReplyMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CameraFramesFailureReplyMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CameraFramesFailureReplyMessage}
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {!proto.ProtoMessages.FrameType} */ (reader.readEnum());
      msg.setFrametype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailurereason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CameraFramesFailureReplyMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CameraFramesFailureReplyMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFrametype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFailurereason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string requestId = 1;
 * @return {string}
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraFramesFailureReplyMessage} returns this
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FrameType frameType = 2;
 * @return {!proto.ProtoMessages.FrameType}
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.prototype.getFrametype = function() {
  return /** @type {!proto.ProtoMessages.FrameType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ProtoMessages.FrameType} value
 * @return {!proto.ProtoMessages.CameraFramesFailureReplyMessage} returns this
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.prototype.setFrametype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string failureReason = 3;
 * @return {string}
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.prototype.getFailurereason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraFramesFailureReplyMessage} returns this
 */
proto.ProtoMessages.CameraFramesFailureReplyMessage.prototype.setFailurereason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.Point2D.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.Point2D.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.Point2D} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Point2D.toObject = function(includeInstance, msg) {
  var f, obj = {
    x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.Point2D}
 */
proto.ProtoMessages.Point2D.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.Point2D;
  return proto.ProtoMessages.Point2D.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.Point2D} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.Point2D}
 */
proto.ProtoMessages.Point2D.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.Point2D.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.Point2D.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.Point2D} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.Point2D.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double x = 1;
 * @return {number}
 */
proto.ProtoMessages.Point2D.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.Point2D} returns this
 */
proto.ProtoMessages.Point2D.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y = 2;
 * @return {number}
 */
proto.ProtoMessages.Point2D.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.Point2D} returns this
 */
proto.ProtoMessages.Point2D.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.GroundPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.GroundPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.GroundPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.GroundPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    framepoint: (f = msg.getFramepoint()) && proto.ProtoMessages.Point2D.toObject(includeInstance, f),
    fieldpoint: (f = msg.getFieldpoint()) && proto.ProtoMessages.Point2D.toObject(includeInstance, f),
    cameraindex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    skipped: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.GroundPoint}
 */
proto.ProtoMessages.GroundPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.GroundPoint;
  return proto.ProtoMessages.GroundPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.GroundPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.GroundPoint}
 */
proto.ProtoMessages.GroundPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Point2D;
      reader.readMessage(value,proto.ProtoMessages.Point2D.deserializeBinaryFromReader);
      msg.setFramepoint(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Point2D;
      reader.readMessage(value,proto.ProtoMessages.Point2D.deserializeBinaryFromReader);
      msg.setFieldpoint(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCameraindex(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkipped(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.GroundPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.GroundPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.GroundPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.GroundPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFramepoint();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Point2D.serializeBinaryToWriter
    );
  }
  f = message.getFieldpoint();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Point2D.serializeBinaryToWriter
    );
  }
  f = message.getCameraindex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSkipped();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional Point2D framePoint = 1;
 * @return {?proto.ProtoMessages.Point2D}
 */
proto.ProtoMessages.GroundPoint.prototype.getFramepoint = function() {
  return /** @type{?proto.ProtoMessages.Point2D} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Point2D, 1));
};


/**
 * @param {?proto.ProtoMessages.Point2D|undefined} value
 * @return {!proto.ProtoMessages.GroundPoint} returns this
*/
proto.ProtoMessages.GroundPoint.prototype.setFramepoint = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GroundPoint} returns this
 */
proto.ProtoMessages.GroundPoint.prototype.clearFramepoint = function() {
  return this.setFramepoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GroundPoint.prototype.hasFramepoint = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Point2D fieldPoint = 2;
 * @return {?proto.ProtoMessages.Point2D}
 */
proto.ProtoMessages.GroundPoint.prototype.getFieldpoint = function() {
  return /** @type{?proto.ProtoMessages.Point2D} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Point2D, 2));
};


/**
 * @param {?proto.ProtoMessages.Point2D|undefined} value
 * @return {!proto.ProtoMessages.GroundPoint} returns this
*/
proto.ProtoMessages.GroundPoint.prototype.setFieldpoint = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.GroundPoint} returns this
 */
proto.ProtoMessages.GroundPoint.prototype.clearFieldpoint = function() {
  return this.setFieldpoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.GroundPoint.prototype.hasFieldpoint = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 cameraIndex = 3;
 * @return {number}
 */
proto.ProtoMessages.GroundPoint.prototype.getCameraindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.GroundPoint} returns this
 */
proto.ProtoMessages.GroundPoint.prototype.setCameraindex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool skipped = 4;
 * @return {boolean}
 */
proto.ProtoMessages.GroundPoint.prototype.getSkipped = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ProtoMessages.GroundPoint} returns this
 */
proto.ProtoMessages.GroundPoint.prototype.setSkipped = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SportTypeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SportTypeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SportTypeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SportTypeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayname: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SportTypeInfo}
 */
proto.ProtoMessages.SportTypeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SportTypeInfo;
  return proto.ProtoMessages.SportTypeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SportTypeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SportTypeInfo}
 */
proto.ProtoMessages.SportTypeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SportTypeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SportTypeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SportTypeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SportTypeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string displayName = 1;
 * @return {string}
 */
proto.ProtoMessages.SportTypeInfo.prototype.getDisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.SportTypeInfo} returns this
 */
proto.ProtoMessages.SportTypeInfo.prototype.setDisplayname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage}
 */
proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage;
  return proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage}
 */
proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    autoproductiontypesList: jspb.Message.toObjectList(msg.getAutoproductiontypesList(),
    proto.ProtoMessages.SportTypeInfo.toObject, includeInstance),
    fixedframetypesList: jspb.Message.toObjectList(msg.getFixedframetypesList(),
    proto.ProtoMessages.SportTypeInfo.toObject, includeInstance),
    result: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage}
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage;
  return proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage}
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.SportTypeInfo;
      reader.readMessage(value,proto.ProtoMessages.SportTypeInfo.deserializeBinaryFromReader);
      msg.addAutoproductiontypes(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.SportTypeInfo;
      reader.readMessage(value,proto.ProtoMessages.SportTypeInfo.deserializeBinaryFromReader);
      msg.addFixedframetypes(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAutoproductiontypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ProtoMessages.SportTypeInfo.serializeBinaryToWriter
    );
  }
  f = message.getFixedframetypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.ProtoMessages.SportTypeInfo.serializeBinaryToWriter
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated SportTypeInfo autoProductionTypes = 1;
 * @return {!Array<!proto.ProtoMessages.SportTypeInfo>}
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.getAutoproductiontypesList = function() {
  return /** @type{!Array<!proto.ProtoMessages.SportTypeInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.SportTypeInfo, 1));
};


/**
 * @param {!Array<!proto.ProtoMessages.SportTypeInfo>} value
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage} returns this
*/
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.setAutoproductiontypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ProtoMessages.SportTypeInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.SportTypeInfo}
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.addAutoproductiontypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ProtoMessages.SportTypeInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage} returns this
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.clearAutoproductiontypesList = function() {
  return this.setAutoproductiontypesList([]);
};


/**
 * repeated SportTypeInfo fixedFrameTypes = 2;
 * @return {!Array<!proto.ProtoMessages.SportTypeInfo>}
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.getFixedframetypesList = function() {
  return /** @type{!Array<!proto.ProtoMessages.SportTypeInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.SportTypeInfo, 2));
};


/**
 * @param {!Array<!proto.ProtoMessages.SportTypeInfo>} value
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage} returns this
*/
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.setFixedframetypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ProtoMessages.SportTypeInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.SportTypeInfo}
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.addFixedframetypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ProtoMessages.SportTypeInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage} returns this
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.clearFixedframetypesList = function() {
  return this.setFixedframetypesList([]);
};


/**
 * optional string result = 3;
 * @return {string}
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage} returns this
 */
proto.ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    groundpointsList: jspb.Message.toObjectList(msg.getGroundpointsList(),
    proto.ProtoMessages.GroundPoint.toObject, includeInstance),
    sporttype: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fieldwidth: jspb.Message.getFieldWithDefault(msg, 3, 0),
    fieldheight: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage;
  return proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.GroundPoint;
      reader.readMessage(value,proto.ProtoMessages.GroundPoint.deserializeBinaryFromReader);
      msg.addGroundpoints(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSporttype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFieldwidth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFieldheight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroundpointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ProtoMessages.GroundPoint.serializeBinaryToWriter
    );
  }
  f = message.getSporttype();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFieldwidth();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFieldheight();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated GroundPoint groundPoints = 1;
 * @return {!Array<!proto.ProtoMessages.GroundPoint>}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.getGroundpointsList = function() {
  return /** @type{!Array<!proto.ProtoMessages.GroundPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.GroundPoint, 1));
};


/**
 * @param {!Array<!proto.ProtoMessages.GroundPoint>} value
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage} returns this
*/
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.setGroundpointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ProtoMessages.GroundPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.GroundPoint}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.addGroundpoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ProtoMessages.GroundPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage} returns this
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.clearGroundpointsList = function() {
  return this.setGroundpointsList([]);
};


/**
 * optional string sportType = 2;
 * @return {string}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.getSporttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage} returns this
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.setSporttype = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 fieldWidth = 3;
 * @return {number}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.getFieldwidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage} returns this
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.setFieldwidth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 fieldHeight = 4;
 * @return {number}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.getFieldheight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage} returns this
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage.prototype.setFieldheight = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage;
  return proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string result = 1;
 * @return {string}
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage} returns this
 */
proto.ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CheckPipCameraPairedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CheckPipCameraPairedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CheckPipCameraPairedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CheckPipCameraPairedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    request: (f = msg.getRequest()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CheckPipCameraPairedRequest}
 */
proto.ProtoMessages.CheckPipCameraPairedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CheckPipCameraPairedRequest;
  return proto.ProtoMessages.CheckPipCameraPairedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CheckPipCameraPairedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CheckPipCameraPairedRequest}
 */
proto.ProtoMessages.CheckPipCameraPairedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CheckPipCameraPairedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CheckPipCameraPairedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CheckPipCameraPairedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CheckPipCameraPairedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool request = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.CheckPipCameraPairedRequest.prototype.getRequest = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.CheckPipCameraPairedRequest} returns this
*/
proto.ProtoMessages.CheckPipCameraPairedRequest.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CheckPipCameraPairedRequest} returns this
 */
proto.ProtoMessages.CheckPipCameraPairedRequest.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CheckPipCameraPairedRequest.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CheckPipCameraPairedReply.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CheckPipCameraPairedReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CheckPipCameraPairedReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CheckPipCameraPairedReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    paired: (f = msg.getPaired()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CheckPipCameraPairedReply}
 */
proto.ProtoMessages.CheckPipCameraPairedReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CheckPipCameraPairedReply;
  return proto.ProtoMessages.CheckPipCameraPairedReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CheckPipCameraPairedReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CheckPipCameraPairedReply}
 */
proto.ProtoMessages.CheckPipCameraPairedReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setPaired(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CheckPipCameraPairedReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CheckPipCameraPairedReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CheckPipCameraPairedReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CheckPipCameraPairedReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaired();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool Paired = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.CheckPipCameraPairedReply.prototype.getPaired = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.CheckPipCameraPairedReply} returns this
*/
proto.ProtoMessages.CheckPipCameraPairedReply.prototype.setPaired = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.CheckPipCameraPairedReply} returns this
 */
proto.ProtoMessages.CheckPipCameraPairedReply.prototype.clearPaired = function() {
  return this.setPaired(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.CheckPipCameraPairedReply.prototype.hasPaired = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.PipCameraPairingComplete.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.PipCameraPairingComplete.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.PipCameraPairingComplete} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraPairingComplete.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    errormessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.PipCameraPairingComplete}
 */
proto.ProtoMessages.PipCameraPairingComplete.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.PipCameraPairingComplete;
  return proto.ProtoMessages.PipCameraPairingComplete.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.PipCameraPairingComplete} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.PipCameraPairingComplete}
 */
proto.ProtoMessages.PipCameraPairingComplete.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.PipCameraPairingComplete.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.PipCameraPairingComplete.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.PipCameraPairingComplete} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraPairingComplete.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getErrormessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Bool success = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.PipCameraPairingComplete.prototype.getSuccess = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.PipCameraPairingComplete} returns this
*/
proto.ProtoMessages.PipCameraPairingComplete.prototype.setSuccess = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.PipCameraPairingComplete} returns this
 */
proto.ProtoMessages.PipCameraPairingComplete.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.PipCameraPairingComplete.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string errorMessage = 2;
 * @return {string}
 */
proto.ProtoMessages.PipCameraPairingComplete.prototype.getErrormessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.PipCameraPairingComplete} returns this
 */
proto.ProtoMessages.PipCameraPairingComplete.prototype.setErrormessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.PipCameraFocusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.PipCameraFocusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.PipCameraFocusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraFocusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    focus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    requestid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.PipCameraFocusRequest}
 */
proto.ProtoMessages.PipCameraFocusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.PipCameraFocusRequest;
  return proto.ProtoMessages.PipCameraFocusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.PipCameraFocusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.PipCameraFocusRequest}
 */
proto.ProtoMessages.PipCameraFocusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFocus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.PipCameraFocusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.PipCameraFocusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.PipCameraFocusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraFocusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFocus();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 focus = 1;
 * @return {number}
 */
proto.ProtoMessages.PipCameraFocusRequest.prototype.getFocus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.PipCameraFocusRequest} returns this
 */
proto.ProtoMessages.PipCameraFocusRequest.prototype.setFocus = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string requestId = 2;
 * @return {string}
 */
proto.ProtoMessages.PipCameraFocusRequest.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.PipCameraFocusRequest} returns this
 */
proto.ProtoMessages.PipCameraFocusRequest.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.PipCameraZoomRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.PipCameraZoomRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.PipCameraZoomRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraZoomRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    zoom: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fine: (f = msg.getFine()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    requestid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.PipCameraZoomRequest}
 */
proto.ProtoMessages.PipCameraZoomRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.PipCameraZoomRequest;
  return proto.ProtoMessages.PipCameraZoomRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.PipCameraZoomRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.PipCameraZoomRequest}
 */
proto.ProtoMessages.PipCameraZoomRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setZoom(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setFine(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.PipCameraZoomRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.PipCameraZoomRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.PipCameraZoomRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraZoomRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getZoom();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFine();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 zoom = 1;
 * @return {number}
 */
proto.ProtoMessages.PipCameraZoomRequest.prototype.getZoom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.PipCameraZoomRequest} returns this
 */
proto.ProtoMessages.PipCameraZoomRequest.prototype.setZoom = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Bool fine = 2;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.PipCameraZoomRequest.prototype.getFine = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 2));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.PipCameraZoomRequest} returns this
*/
proto.ProtoMessages.PipCameraZoomRequest.prototype.setFine = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.PipCameraZoomRequest} returns this
 */
proto.ProtoMessages.PipCameraZoomRequest.prototype.clearFine = function() {
  return this.setFine(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.PipCameraZoomRequest.prototype.hasFine = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string requestId = 3;
 * @return {string}
 */
proto.ProtoMessages.PipCameraZoomRequest.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.PipCameraZoomRequest} returns this
 */
proto.ProtoMessages.PipCameraZoomRequest.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.PipCameraIrisChangeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.PipCameraIrisChangeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.PipCameraIrisChangeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraIrisChangeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newirisvalue: jspb.Message.getFieldWithDefault(msg, 1, 0),
    requestid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.PipCameraIrisChangeRequest}
 */
proto.ProtoMessages.PipCameraIrisChangeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.PipCameraIrisChangeRequest;
  return proto.ProtoMessages.PipCameraIrisChangeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.PipCameraIrisChangeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.PipCameraIrisChangeRequest}
 */
proto.ProtoMessages.PipCameraIrisChangeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNewirisvalue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.PipCameraIrisChangeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.PipCameraIrisChangeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.PipCameraIrisChangeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraIrisChangeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewirisvalue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 newIrisValue = 1;
 * @return {number}
 */
proto.ProtoMessages.PipCameraIrisChangeRequest.prototype.getNewirisvalue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.PipCameraIrisChangeRequest} returns this
 */
proto.ProtoMessages.PipCameraIrisChangeRequest.prototype.setNewirisvalue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string requestId = 2;
 * @return {string}
 */
proto.ProtoMessages.PipCameraIrisChangeRequest.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.PipCameraIrisChangeRequest} returns this
 */
proto.ProtoMessages.PipCameraIrisChangeRequest.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.PipCameraChangeExposureModeChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.PipCameraChangeExposureModeChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    newmode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.PipCameraChangeExposureModeChange}
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.PipCameraChangeExposureModeChange;
  return proto.ProtoMessages.PipCameraChangeExposureModeChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.PipCameraChangeExposureModeChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.PipCameraChangeExposureModeChange}
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewmode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.PipCameraChangeExposureModeChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.PipCameraChangeExposureModeChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewmode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string newMode = 1;
 * @return {string}
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange.prototype.getNewmode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.PipCameraChangeExposureModeChange} returns this
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange.prototype.setNewmode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string requestId = 2;
 * @return {string}
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.PipCameraChangeExposureModeChange} returns this
 */
proto.ProtoMessages.PipCameraChangeExposureModeChange.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.PipCameraGainChangeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.PipCameraGainChangeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.PipCameraGainChangeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraGainChangeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newgainvalue: jspb.Message.getFieldWithDefault(msg, 1, 0),
    requestid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.PipCameraGainChangeRequest}
 */
proto.ProtoMessages.PipCameraGainChangeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.PipCameraGainChangeRequest;
  return proto.ProtoMessages.PipCameraGainChangeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.PipCameraGainChangeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.PipCameraGainChangeRequest}
 */
proto.ProtoMessages.PipCameraGainChangeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNewgainvalue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.PipCameraGainChangeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.PipCameraGainChangeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.PipCameraGainChangeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PipCameraGainChangeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewgainvalue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 newGainValue = 1;
 * @return {number}
 */
proto.ProtoMessages.PipCameraGainChangeRequest.prototype.getNewgainvalue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.PipCameraGainChangeRequest} returns this
 */
proto.ProtoMessages.PipCameraGainChangeRequest.prototype.setNewgainvalue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string requestId = 2;
 * @return {string}
 */
proto.ProtoMessages.PipCameraGainChangeRequest.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.PipCameraGainChangeRequest} returns this
 */
proto.ProtoMessages.PipCameraGainChangeRequest.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OcrCameraParametersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OcrCameraParametersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OcrCameraParametersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OcrCameraParametersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    request: (f = msg.getRequest()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OcrCameraParametersRequest}
 */
proto.ProtoMessages.OcrCameraParametersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OcrCameraParametersRequest;
  return proto.ProtoMessages.OcrCameraParametersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OcrCameraParametersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OcrCameraParametersRequest}
 */
proto.ProtoMessages.OcrCameraParametersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OcrCameraParametersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OcrCameraParametersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OcrCameraParametersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OcrCameraParametersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool request = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OcrCameraParametersRequest.prototype.getRequest = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OcrCameraParametersRequest} returns this
*/
proto.ProtoMessages.OcrCameraParametersRequest.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OcrCameraParametersRequest} returns this
 */
proto.ProtoMessages.OcrCameraParametersRequest.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OcrCameraParametersRequest.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OcrCameraParametersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OcrCameraParametersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OcrCameraParametersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OcrCameraParametersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    errormessage: jspb.Message.getFieldWithDefault(msg, 2, ""),
    params: (f = msg.getParams()) && proto.ProtoMessages.OcrCameraParams.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OcrCameraParametersResponse}
 */
proto.ProtoMessages.OcrCameraParametersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OcrCameraParametersResponse;
  return proto.ProtoMessages.OcrCameraParametersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OcrCameraParametersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OcrCameraParametersResponse}
 */
proto.ProtoMessages.OcrCameraParametersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessage(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.OcrCameraParams;
      reader.readMessage(value,proto.ProtoMessages.OcrCameraParams.deserializeBinaryFromReader);
      msg.setParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OcrCameraParametersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OcrCameraParametersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OcrCameraParametersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OcrCameraParametersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getErrormessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParams();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.OcrCameraParams.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool success = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OcrCameraParametersResponse.prototype.getSuccess = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OcrCameraParametersResponse} returns this
*/
proto.ProtoMessages.OcrCameraParametersResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OcrCameraParametersResponse} returns this
 */
proto.ProtoMessages.OcrCameraParametersResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OcrCameraParametersResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string errorMessage = 2;
 * @return {string}
 */
proto.ProtoMessages.OcrCameraParametersResponse.prototype.getErrormessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OcrCameraParametersResponse} returns this
 */
proto.ProtoMessages.OcrCameraParametersResponse.prototype.setErrormessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional OcrCameraParams params = 3;
 * @return {?proto.ProtoMessages.OcrCameraParams}
 */
proto.ProtoMessages.OcrCameraParametersResponse.prototype.getParams = function() {
  return /** @type{?proto.ProtoMessages.OcrCameraParams} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.OcrCameraParams, 3));
};


/**
 * @param {?proto.ProtoMessages.OcrCameraParams|undefined} value
 * @return {!proto.ProtoMessages.OcrCameraParametersResponse} returns this
*/
proto.ProtoMessages.OcrCameraParametersResponse.prototype.setParams = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OcrCameraParametersResponse} returns this
 */
proto.ProtoMessages.OcrCameraParametersResponse.prototype.clearParams = function() {
  return this.setParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OcrCameraParametersResponse.prototype.hasParams = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OcrCameraParams.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OcrCameraParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OcrCameraParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OcrCameraParams.toObject = function(includeInstance, msg) {
  var f, obj = {
    gain: jspb.Message.getFieldWithDefault(msg, 1, 0),
    iris: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OcrCameraParams}
 */
proto.ProtoMessages.OcrCameraParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OcrCameraParams;
  return proto.ProtoMessages.OcrCameraParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OcrCameraParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OcrCameraParams}
 */
proto.ProtoMessages.OcrCameraParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIris(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OcrCameraParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OcrCameraParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OcrCameraParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OcrCameraParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGain();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIris();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 gain = 1;
 * @return {number}
 */
proto.ProtoMessages.OcrCameraParams.prototype.getGain = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.OcrCameraParams} returns this
 */
proto.ProtoMessages.OcrCameraParams.prototype.setGain = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 iris = 2;
 * @return {number}
 */
proto.ProtoMessages.OcrCameraParams.prototype.getIris = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.OcrCameraParams} returns this
 */
proto.ProtoMessages.OcrCameraParams.prototype.setIris = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.StartAdditionalAngleCameraPairing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.StartAdditionalAngleCameraPairing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.toObject = function(includeInstance, msg) {
  var f, obj = {
    request: (f = msg.getRequest()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    requestid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.StartAdditionalAngleCameraPairing}
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.StartAdditionalAngleCameraPairing;
  return proto.ProtoMessages.StartAdditionalAngleCameraPairing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.StartAdditionalAngleCameraPairing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.StartAdditionalAngleCameraPairing}
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.StartAdditionalAngleCameraPairing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.StartAdditionalAngleCameraPairing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Bool request = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.prototype.getRequest = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.StartAdditionalAngleCameraPairing} returns this
*/
proto.ProtoMessages.StartAdditionalAngleCameraPairing.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.StartAdditionalAngleCameraPairing} returns this
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string requestId = 2;
 * @return {string}
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.StartAdditionalAngleCameraPairing} returns this
 */
proto.ProtoMessages.StartAdditionalAngleCameraPairing.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.PairingStageUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.PairingStageUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.PairingStageUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PairingStageUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    stage: jspb.Message.getFieldWithDefault(msg, 1, 0),
    stagesuccess: (f = msg.getStagesuccess()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    errormessege: jspb.Message.getFieldWithDefault(msg, 3, ""),
    errorcode: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.PairingStageUpdate}
 */
proto.ProtoMessages.PairingStageUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.PairingStageUpdate;
  return proto.ProtoMessages.PairingStageUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.PairingStageUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.PairingStageUpdate}
 */
proto.ProtoMessages.PairingStageUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.PairingStage} */ (reader.readEnum());
      msg.setStage(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setStagesuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessege(value);
      break;
    case 4:
      var value = /** @type {!proto.ProtoMessages.PairingStageUpdate.PairingErrorCode} */ (reader.readEnum());
      msg.setErrorcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.PairingStageUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.PairingStageUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.PairingStageUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PairingStageUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStage();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStagesuccess();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getErrormessege();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getErrorcode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.PairingStageUpdate.PairingErrorCode = {
  NA: 0,
  NO_CAMERA_FOUND: 1,
  MULTIPLE_CAMERAS_FOUND: 2
};

/**
 * optional PairingStage stage = 1;
 * @return {!proto.ProtoMessages.PairingStage}
 */
proto.ProtoMessages.PairingStageUpdate.prototype.getStage = function() {
  return /** @type {!proto.ProtoMessages.PairingStage} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.PairingStage} value
 * @return {!proto.ProtoMessages.PairingStageUpdate} returns this
 */
proto.ProtoMessages.PairingStageUpdate.prototype.setStage = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Bool stageSuccess = 2;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.PairingStageUpdate.prototype.getStagesuccess = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 2));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.PairingStageUpdate} returns this
*/
proto.ProtoMessages.PairingStageUpdate.prototype.setStagesuccess = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.PairingStageUpdate} returns this
 */
proto.ProtoMessages.PairingStageUpdate.prototype.clearStagesuccess = function() {
  return this.setStagesuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.PairingStageUpdate.prototype.hasStagesuccess = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string errorMessege = 3;
 * @return {string}
 */
proto.ProtoMessages.PairingStageUpdate.prototype.getErrormessege = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.PairingStageUpdate} returns this
 */
proto.ProtoMessages.PairingStageUpdate.prototype.setErrormessege = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional PairingErrorCode errorCode = 4;
 * @return {!proto.ProtoMessages.PairingStageUpdate.PairingErrorCode}
 */
proto.ProtoMessages.PairingStageUpdate.prototype.getErrorcode = function() {
  return /** @type {!proto.ProtoMessages.PairingStageUpdate.PairingErrorCode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.ProtoMessages.PairingStageUpdate.PairingErrorCode} value
 * @return {!proto.ProtoMessages.PairingStageUpdate} returns this
 */
proto.ProtoMessages.PairingStageUpdate.prototype.setErrorcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.ExistingCalibrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.ExistingCalibrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.ExistingCalibrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ExistingCalibrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    request: (f = msg.getRequest()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.ExistingCalibrationRequest}
 */
proto.ProtoMessages.ExistingCalibrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.ExistingCalibrationRequest;
  return proto.ProtoMessages.ExistingCalibrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.ExistingCalibrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.ExistingCalibrationRequest}
 */
proto.ProtoMessages.ExistingCalibrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.ExistingCalibrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.ExistingCalibrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.ExistingCalibrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.ExistingCalibrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool request = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.ExistingCalibrationRequest.prototype.getRequest = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.ExistingCalibrationRequest} returns this
*/
proto.ProtoMessages.ExistingCalibrationRequest.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.ExistingCalibrationRequest} returns this
 */
proto.ProtoMessages.ExistingCalibrationRequest.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.ExistingCalibrationRequest.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.RefreshOcrImageAndPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.RefreshOcrImageAndPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.RefreshOcrImageAndPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.RefreshOcrImageAndPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
    reqid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.RefreshOcrImageAndPreview}
 */
proto.ProtoMessages.RefreshOcrImageAndPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.RefreshOcrImageAndPreview;
  return proto.ProtoMessages.RefreshOcrImageAndPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.RefreshOcrImageAndPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.RefreshOcrImageAndPreview}
 */
proto.ProtoMessages.RefreshOcrImageAndPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReqid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.RefreshOcrImageAndPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.RefreshOcrImageAndPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.RefreshOcrImageAndPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.RefreshOcrImageAndPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReqid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string reqId = 1;
 * @return {string}
 */
proto.ProtoMessages.RefreshOcrImageAndPreview.prototype.getReqid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.RefreshOcrImageAndPreview} returns this
 */
proto.ProtoMessages.RefreshOcrImageAndPreview.prototype.setReqid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingGetCurrentNetworkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    request: (f = msg.getRequest()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingGetCurrentNetworkRequest}
 */
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingGetCurrentNetworkRequest;
  return proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingGetCurrentNetworkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingGetCurrentNetworkRequest}
 */
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingGetCurrentNetworkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool request = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.prototype.getRequest = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingGetCurrentNetworkRequest} returns this
*/
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingGetCurrentNetworkRequest} returns this
 */
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingGetCurrentNetworkRequest.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingNetworkSetupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingNetworkSetupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    manual: (f = msg.getManual()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    ip: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mask: jspb.Message.getFieldWithDefault(msg, 3, ""),
    gateway: jspb.Message.getFieldWithDefault(msg, 4, ""),
    dns1: jspb.Message.getFieldWithDefault(msg, 5, ""),
    dns2: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupRequest}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingNetworkSetupRequest;
  return proto.ProtoMessages.OnboardingNetworkSetupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingNetworkSetupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupRequest}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setManual(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMask(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGateway(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDns1(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDns2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingNetworkSetupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingNetworkSetupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManual();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getIp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMask();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGateway();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDns1();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDns2();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional Bool manual = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.getManual = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupRequest} returns this
*/
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.setManual = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupRequest} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.clearManual = function() {
  return this.setManual(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.hasManual = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string ip = 2;
 * @return {string}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupRequest} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.setIp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mask = 3;
 * @return {string}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.getMask = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupRequest} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.setMask = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string gateway = 4;
 * @return {string}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.getGateway = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupRequest} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.setGateway = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string dns1 = 5;
 * @return {string}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.getDns1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupRequest} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.setDns1 = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string dns2 = 6;
 * @return {string}
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.getDns2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupRequest} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupRequest.prototype.setDns2 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingFullNetworkTestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingFullNetworkTestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingFullNetworkTestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingFullNetworkTestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    test: (f = msg.getTest()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingFullNetworkTestRequest}
 */
proto.ProtoMessages.OnboardingFullNetworkTestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingFullNetworkTestRequest;
  return proto.ProtoMessages.OnboardingFullNetworkTestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingFullNetworkTestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingFullNetworkTestRequest}
 */
proto.ProtoMessages.OnboardingFullNetworkTestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setTest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingFullNetworkTestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingFullNetworkTestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingFullNetworkTestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingFullNetworkTestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool test = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingFullNetworkTestRequest.prototype.getTest = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingFullNetworkTestRequest} returns this
*/
proto.ProtoMessages.OnboardingFullNetworkTestRequest.prototype.setTest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingFullNetworkTestRequest} returns this
 */
proto.ProtoMessages.OnboardingFullNetworkTestRequest.prototype.clearTest = function() {
  return this.setTest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingFullNetworkTestRequest.prototype.hasTest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingNetworkSetupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingNetworkSetupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    manual: (f = msg.getManual()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    ip: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mask: jspb.Message.getFieldWithDefault(msg, 4, ""),
    gateway: jspb.Message.getFieldWithDefault(msg, 5, ""),
    dns1: jspb.Message.getFieldWithDefault(msg, 6, ""),
    dns2: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingNetworkSetupResponse;
  return proto.ProtoMessages.OnboardingNetworkSetupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingNetworkSetupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setManual(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMask(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setGateway(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDns1(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDns2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingNetworkSetupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingNetworkSetupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getManual();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getIp();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMask();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGateway();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDns1();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDns2();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional Bool success = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.getSuccess = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse} returns this
*/
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Bool manual = 2;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.getManual = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 2));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse} returns this
*/
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.setManual = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.clearManual = function() {
  return this.setManual(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.hasManual = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string ip = 3;
 * @return {string}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.setIp = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mask = 4;
 * @return {string}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.getMask = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.setMask = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string gateway = 5;
 * @return {string}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.getGateway = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.setGateway = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string dns1 = 6;
 * @return {string}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.getDns1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.setDns1 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string dns2 = 7;
 * @return {string}
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.getDns2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingNetworkSetupResponse} returns this
 */
proto.ProtoMessages.OnboardingNetworkSetupResponse.prototype.setDns2 = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.PairingInProgressQuery.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.PairingInProgressQuery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.PairingInProgressQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PairingInProgressQuery.toObject = function(includeInstance, msg) {
  var f, obj = {
    checkforrunningpairing: (f = msg.getCheckforrunningpairing()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.PairingInProgressQuery}
 */
proto.ProtoMessages.PairingInProgressQuery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.PairingInProgressQuery;
  return proto.ProtoMessages.PairingInProgressQuery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.PairingInProgressQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.PairingInProgressQuery}
 */
proto.ProtoMessages.PairingInProgressQuery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setCheckforrunningpairing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.PairingInProgressQuery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.PairingInProgressQuery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.PairingInProgressQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PairingInProgressQuery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCheckforrunningpairing();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool checkForRunningPairing = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.PairingInProgressQuery.prototype.getCheckforrunningpairing = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.PairingInProgressQuery} returns this
*/
proto.ProtoMessages.PairingInProgressQuery.prototype.setCheckforrunningpairing = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.PairingInProgressQuery} returns this
 */
proto.ProtoMessages.PairingInProgressQuery.prototype.clearCheckforrunningpairing = function() {
  return this.setCheckforrunningpairing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.PairingInProgressQuery.prototype.hasCheckforrunningpairing = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.PairingInProgressResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.PairingInProgressResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.PairingInProgressResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PairingInProgressResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pairingalreadyrunning: (f = msg.getPairingalreadyrunning()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.PairingInProgressResponse}
 */
proto.ProtoMessages.PairingInProgressResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.PairingInProgressResponse;
  return proto.ProtoMessages.PairingInProgressResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.PairingInProgressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.PairingInProgressResponse}
 */
proto.ProtoMessages.PairingInProgressResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setPairingalreadyrunning(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.PairingInProgressResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.PairingInProgressResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.PairingInProgressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.PairingInProgressResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPairingalreadyrunning();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool pairingAlreadyRunning = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.PairingInProgressResponse.prototype.getPairingalreadyrunning = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.PairingInProgressResponse} returns this
*/
proto.ProtoMessages.PairingInProgressResponse.prototype.setPairingalreadyrunning = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.PairingInProgressResponse} returns this
 */
proto.ProtoMessages.PairingInProgressResponse.prototype.clearPairingalreadyrunning = function() {
  return this.setPairingalreadyrunning(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.PairingInProgressResponse.prototype.hasPairingalreadyrunning = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.TokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.TokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.TokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requesttoken: (f = msg.getRequesttoken()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.TokenRequest}
 */
proto.ProtoMessages.TokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.TokenRequest;
  return proto.ProtoMessages.TokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.TokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.TokenRequest}
 */
proto.ProtoMessages.TokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRequesttoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.TokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.TokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.TokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequesttoken();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool requestToken = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.TokenRequest.prototype.getRequesttoken = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.TokenRequest} returns this
*/
proto.ProtoMessages.TokenRequest.prototype.setRequesttoken = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.TokenRequest} returns this
 */
proto.ProtoMessages.TokenRequest.prototype.clearRequesttoken = function() {
  return this.setRequesttoken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.TokenRequest.prototype.hasRequesttoken = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.TokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.TokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.TokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    wsproxyaddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
    token: jspb.Message.getFieldWithDefault(msg, 2, ""),
    success: (f = msg.getSuccess()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    errormessage: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.TokenResponse}
 */
proto.ProtoMessages.TokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.TokenResponse;
  return proto.ProtoMessages.TokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.TokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.TokenResponse}
 */
proto.ProtoMessages.TokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWsproxyaddress(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.TokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.TokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.TokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.TokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWsproxyaddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getErrormessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string wsproxyAddress = 1;
 * @return {string}
 */
proto.ProtoMessages.TokenResponse.prototype.getWsproxyaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.TokenResponse} returns this
 */
proto.ProtoMessages.TokenResponse.prototype.setWsproxyaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.ProtoMessages.TokenResponse.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.TokenResponse} returns this
 */
proto.ProtoMessages.TokenResponse.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Bool success = 3;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.TokenResponse.prototype.getSuccess = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 3));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.TokenResponse} returns this
*/
proto.ProtoMessages.TokenResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.TokenResponse} returns this
 */
proto.ProtoMessages.TokenResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.TokenResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string errorMessage = 4;
 * @return {string}
 */
proto.ProtoMessages.TokenResponse.prototype.getErrormessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.TokenResponse} returns this
 */
proto.ProtoMessages.TokenResponse.prototype.setErrormessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.VenueSelfTestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.VenueSelfTestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.VenueSelfTestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.VenueSelfTestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    runtest: (f = msg.getRuntest()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.VenueSelfTestRequest}
 */
proto.ProtoMessages.VenueSelfTestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.VenueSelfTestRequest;
  return proto.ProtoMessages.VenueSelfTestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.VenueSelfTestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.VenueSelfTestRequest}
 */
proto.ProtoMessages.VenueSelfTestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRuntest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.VenueSelfTestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.VenueSelfTestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.VenueSelfTestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.VenueSelfTestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRuntest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool runTest = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.VenueSelfTestRequest.prototype.getRuntest = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.VenueSelfTestRequest} returns this
*/
proto.ProtoMessages.VenueSelfTestRequest.prototype.setRuntest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.VenueSelfTestRequest} returns this
 */
proto.ProtoMessages.VenueSelfTestRequest.prototype.clearRuntest = function() {
  return this.setRuntest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.VenueSelfTestRequest.prototype.hasRuntest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingCameraTestResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingCameraTestResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingCameraTestResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingCameraTestResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    errormessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingCameraTestResponse}
 */
proto.ProtoMessages.OnboardingCameraTestResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingCameraTestResponse;
  return proto.ProtoMessages.OnboardingCameraTestResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingCameraTestResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingCameraTestResponse}
 */
proto.ProtoMessages.OnboardingCameraTestResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingCameraTestResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingCameraTestResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingCameraTestResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingCameraTestResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getErrormessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Bool success = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingCameraTestResponse.prototype.getSuccess = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingCameraTestResponse} returns this
*/
proto.ProtoMessages.OnboardingCameraTestResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingCameraTestResponse} returns this
 */
proto.ProtoMessages.OnboardingCameraTestResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingCameraTestResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string errorMessage = 2;
 * @return {string}
 */
proto.ProtoMessages.OnboardingCameraTestResponse.prototype.getErrormessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingCameraTestResponse} returns this
 */
proto.ProtoMessages.OnboardingCameraTestResponse.prototype.setErrormessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingGPUTestResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingGPUTestResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingGPUTestResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingGPUTestResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    errormessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingGPUTestResponse}
 */
proto.ProtoMessages.OnboardingGPUTestResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingGPUTestResponse;
  return proto.ProtoMessages.OnboardingGPUTestResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingGPUTestResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingGPUTestResponse}
 */
proto.ProtoMessages.OnboardingGPUTestResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingGPUTestResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingGPUTestResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingGPUTestResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingGPUTestResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getErrormessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Bool success = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingGPUTestResponse.prototype.getSuccess = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingGPUTestResponse} returns this
*/
proto.ProtoMessages.OnboardingGPUTestResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingGPUTestResponse} returns this
 */
proto.ProtoMessages.OnboardingGPUTestResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingGPUTestResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string errorMessage = 2;
 * @return {string}
 */
proto.ProtoMessages.OnboardingGPUTestResponse.prototype.getErrormessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingGPUTestResponse} returns this
 */
proto.ProtoMessages.OnboardingGPUTestResponse.prototype.setErrormessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.VenueSelfTestResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.VenueSelfTestResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.VenueSelfTestResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    networktestresponse: (f = msg.getNetworktestresponse()) && proto.ProtoMessages.NetworkTestResult.toObject(includeInstance, f),
    cameratestresponse: (f = msg.getCameratestresponse()) && proto.ProtoMessages.OnboardingCameraTestResponse.toObject(includeInstance, f),
    gputestresponse: (f = msg.getGputestresponse()) && proto.ProtoMessages.OnboardingGPUTestResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.VenueSelfTestResponse}
 */
proto.ProtoMessages.VenueSelfTestResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.VenueSelfTestResponse;
  return proto.ProtoMessages.VenueSelfTestResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.VenueSelfTestResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.VenueSelfTestResponse}
 */
proto.ProtoMessages.VenueSelfTestResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.NetworkTestResult;
      reader.readMessage(value,proto.ProtoMessages.NetworkTestResult.deserializeBinaryFromReader);
      msg.setNetworktestresponse(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.OnboardingCameraTestResponse;
      reader.readMessage(value,proto.ProtoMessages.OnboardingCameraTestResponse.deserializeBinaryFromReader);
      msg.setCameratestresponse(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.OnboardingGPUTestResponse;
      reader.readMessage(value,proto.ProtoMessages.OnboardingGPUTestResponse.deserializeBinaryFromReader);
      msg.setGputestresponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.VenueSelfTestResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.VenueSelfTestResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.VenueSelfTestResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworktestresponse();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.NetworkTestResult.serializeBinaryToWriter
    );
  }
  f = message.getCameratestresponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ProtoMessages.OnboardingCameraTestResponse.serializeBinaryToWriter
    );
  }
  f = message.getGputestresponse();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ProtoMessages.OnboardingGPUTestResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional NetworkTestResult networkTestResponse = 1;
 * @return {?proto.ProtoMessages.NetworkTestResult}
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.getNetworktestresponse = function() {
  return /** @type{?proto.ProtoMessages.NetworkTestResult} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.NetworkTestResult, 1));
};


/**
 * @param {?proto.ProtoMessages.NetworkTestResult|undefined} value
 * @return {!proto.ProtoMessages.VenueSelfTestResponse} returns this
*/
proto.ProtoMessages.VenueSelfTestResponse.prototype.setNetworktestresponse = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.VenueSelfTestResponse} returns this
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.clearNetworktestresponse = function() {
  return this.setNetworktestresponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.hasNetworktestresponse = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OnboardingCameraTestResponse cameraTestResponse = 2;
 * @return {?proto.ProtoMessages.OnboardingCameraTestResponse}
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.getCameratestresponse = function() {
  return /** @type{?proto.ProtoMessages.OnboardingCameraTestResponse} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.OnboardingCameraTestResponse, 2));
};


/**
 * @param {?proto.ProtoMessages.OnboardingCameraTestResponse|undefined} value
 * @return {!proto.ProtoMessages.VenueSelfTestResponse} returns this
*/
proto.ProtoMessages.VenueSelfTestResponse.prototype.setCameratestresponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.VenueSelfTestResponse} returns this
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.clearCameratestresponse = function() {
  return this.setCameratestresponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.hasCameratestresponse = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional OnboardingGPUTestResponse gpuTestResponse = 3;
 * @return {?proto.ProtoMessages.OnboardingGPUTestResponse}
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.getGputestresponse = function() {
  return /** @type{?proto.ProtoMessages.OnboardingGPUTestResponse} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.OnboardingGPUTestResponse, 3));
};


/**
 * @param {?proto.ProtoMessages.OnboardingGPUTestResponse|undefined} value
 * @return {!proto.ProtoMessages.VenueSelfTestResponse} returns this
*/
proto.ProtoMessages.VenueSelfTestResponse.prototype.setGputestresponse = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.VenueSelfTestResponse} returns this
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.clearGputestresponse = function() {
  return this.setGputestresponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.VenueSelfTestResponse.prototype.hasGputestresponse = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingHandshakeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingHandshakeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingHandshakeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingHandshakeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    request: (f = msg.getRequest()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingHandshakeRequest}
 */
proto.ProtoMessages.OnboardingHandshakeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingHandshakeRequest;
  return proto.ProtoMessages.OnboardingHandshakeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingHandshakeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingHandshakeRequest}
 */
proto.ProtoMessages.OnboardingHandshakeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingHandshakeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingHandshakeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingHandshakeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingHandshakeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool request = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingHandshakeRequest.prototype.getRequest = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingHandshakeRequest} returns this
*/
proto.ProtoMessages.OnboardingHandshakeRequest.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingHandshakeRequest} returns this
 */
proto.ProtoMessages.OnboardingHandshakeRequest.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingHandshakeRequest.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingHandshakeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingHandshakeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingHandshakeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingHandshakeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    version: jspb.Message.getFieldWithDefault(msg, 1, ""),
    venueid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingHandshakeReply}
 */
proto.ProtoMessages.OnboardingHandshakeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingHandshakeReply;
  return proto.ProtoMessages.OnboardingHandshakeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingHandshakeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingHandshakeReply}
 */
proto.ProtoMessages.OnboardingHandshakeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVenueid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingHandshakeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingHandshakeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingHandshakeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingHandshakeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVenueid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string version = 1;
 * @return {string}
 */
proto.ProtoMessages.OnboardingHandshakeReply.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingHandshakeReply} returns this
 */
proto.ProtoMessages.OnboardingHandshakeReply.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string venueId = 2;
 * @return {string}
 */
proto.ProtoMessages.OnboardingHandshakeReply.prototype.getVenueid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingHandshakeReply} returns this
 */
proto.ProtoMessages.OnboardingHandshakeReply.prototype.setVenueid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingOcrZoomRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingOcrZoomRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingOcrZoomRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingOcrZoomRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    zoom: jspb.Message.getFieldWithDefault(msg, 1, 0),
    requestid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingOcrZoomRequest}
 */
proto.ProtoMessages.OnboardingOcrZoomRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingOcrZoomRequest;
  return proto.ProtoMessages.OnboardingOcrZoomRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingOcrZoomRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingOcrZoomRequest}
 */
proto.ProtoMessages.OnboardingOcrZoomRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setZoom(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingOcrZoomRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingOcrZoomRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingOcrZoomRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingOcrZoomRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getZoom();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 zoom = 1;
 * @return {number}
 */
proto.ProtoMessages.OnboardingOcrZoomRequest.prototype.getZoom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ProtoMessages.OnboardingOcrZoomRequest} returns this
 */
proto.ProtoMessages.OnboardingOcrZoomRequest.prototype.setZoom = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string requestId = 2;
 * @return {string}
 */
proto.ProtoMessages.OnboardingOcrZoomRequest.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingOcrZoomRequest} returns this
 */
proto.ProtoMessages.OnboardingOcrZoomRequest.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingOcrAutoFocusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingOcrAutoFocusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    request: (f = msg.getRequest()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    requestid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingOcrAutoFocusRequest}
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingOcrAutoFocusRequest;
  return proto.ProtoMessages.OnboardingOcrAutoFocusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingOcrAutoFocusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingOcrAutoFocusRequest}
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingOcrAutoFocusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingOcrAutoFocusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Bool request = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.prototype.getRequest = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingOcrAutoFocusRequest} returns this
*/
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingOcrAutoFocusRequest} returns this
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string requestId = 2;
 * @return {string}
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingOcrAutoFocusRequest} returns this
 */
proto.ProtoMessages.OnboardingOcrAutoFocusRequest.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingPipCameraPairingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingPipCameraPairingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingPipCameraPairingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingPipCameraPairingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    request: (f = msg.getRequest()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingPipCameraPairingRequest}
 */
proto.ProtoMessages.OnboardingPipCameraPairingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingPipCameraPairingRequest;
  return proto.ProtoMessages.OnboardingPipCameraPairingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingPipCameraPairingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingPipCameraPairingRequest}
 */
proto.ProtoMessages.OnboardingPipCameraPairingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingPipCameraPairingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingPipCameraPairingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingPipCameraPairingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingPipCameraPairingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool request = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingPipCameraPairingRequest.prototype.getRequest = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingPipCameraPairingRequest} returns this
*/
proto.ProtoMessages.OnboardingPipCameraPairingRequest.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingPipCameraPairingRequest} returns this
 */
proto.ProtoMessages.OnboardingPipCameraPairingRequest.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingPipCameraPairingRequest.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingPipCameraPairingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingPipCameraPairingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.ProtoMessages.Bool.toObject(includeInstance, f),
    errormessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingPipCameraPairingResponse}
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingPipCameraPairingResponse;
  return proto.ProtoMessages.OnboardingPipCameraPairingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingPipCameraPairingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingPipCameraPairingResponse}
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingPipCameraPairingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingPipCameraPairingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
  f = message.getErrormessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Bool success = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.prototype.getSuccess = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingPipCameraPairingResponse} returns this
*/
proto.ProtoMessages.OnboardingPipCameraPairingResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingPipCameraPairingResponse} returns this
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string errorMessage = 2;
 * @return {string}
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.prototype.getErrormessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.OnboardingPipCameraPairingResponse} returns this
 */
proto.ProtoMessages.OnboardingPipCameraPairingResponse.prototype.setErrormessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingRunPipInSetupModeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    run: (f = msg.getRun()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingRunPipInSetupModeRequest}
 */
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingRunPipInSetupModeRequest;
  return proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingRunPipInSetupModeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingRunPipInSetupModeRequest}
 */
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setRun(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingRunPipInSetupModeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRun();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool run = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.prototype.getRun = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingRunPipInSetupModeRequest} returns this
*/
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.prototype.setRun = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingRunPipInSetupModeRequest} returns this
 */
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.prototype.clearRun = function() {
  return this.setRun(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingRunPipInSetupModeRequest.prototype.hasRun = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.OnboardingStopPipInSetupModeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    stop: (f = msg.getStop()) && proto.ProtoMessages.Bool.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.OnboardingStopPipInSetupModeRequest}
 */
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.OnboardingStopPipInSetupModeRequest;
  return proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.OnboardingStopPipInSetupModeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.OnboardingStopPipInSetupModeRequest}
 */
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ProtoMessages.Bool;
      reader.readMessage(value,proto.ProtoMessages.Bool.deserializeBinaryFromReader);
      msg.setStop(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.OnboardingStopPipInSetupModeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStop();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ProtoMessages.Bool.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bool stop = 1;
 * @return {?proto.ProtoMessages.Bool}
 */
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.prototype.getStop = function() {
  return /** @type{?proto.ProtoMessages.Bool} */ (
    jspb.Message.getWrapperField(this, proto.ProtoMessages.Bool, 1));
};


/**
 * @param {?proto.ProtoMessages.Bool|undefined} value
 * @return {!proto.ProtoMessages.OnboardingStopPipInSetupModeRequest} returns this
*/
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.prototype.setStop = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ProtoMessages.OnboardingStopPipInSetupModeRequest} returns this
 */
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.prototype.clearStop = function() {
  return this.setStop(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ProtoMessages.OnboardingStopPipInSetupModeRequest.prototype.hasStop = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CameraInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CameraInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CameraInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ip: jspb.Message.getFieldWithDefault(msg, 2, ""),
    model: jspb.Message.getFieldWithDefault(msg, 3, ""),
    url: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CameraInfo}
 */
proto.ProtoMessages.CameraInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CameraInfo;
  return proto.ProtoMessages.CameraInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CameraInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CameraInfo}
 */
proto.ProtoMessages.CameraInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CameraInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CameraInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CameraInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.ProtoMessages.CameraInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraInfo} returns this
 */
proto.ProtoMessages.CameraInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ip = 2;
 * @return {string}
 */
proto.ProtoMessages.CameraInfo.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraInfo} returns this
 */
proto.ProtoMessages.CameraInfo.prototype.setIp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string model = 3;
 * @return {string}
 */
proto.ProtoMessages.CameraInfo.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraInfo} returns this
 */
proto.ProtoMessages.CameraInfo.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string url = 4;
 * @return {string}
 */
proto.ProtoMessages.CameraInfo.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraInfo} returns this
 */
proto.ProtoMessages.CameraInfo.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ProtoMessages.CameraControlMessage.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ProtoMessages.CameraControlMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ProtoMessages.CameraControlMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ProtoMessages.CameraControlMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraControlMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    headcamerasList: jspb.Message.toObjectList(msg.getHeadcamerasList(),
    proto.ProtoMessages.CameraInfo.toObject, includeInstance),
    aditionalanglescamerasList: jspb.Message.toObjectList(msg.getAditionalanglescamerasList(),
    proto.ProtoMessages.CameraInfo.toObject, includeInstance),
    cameratoconnect: jspb.Message.getFieldWithDefault(msg, 4, ""),
    input: jspb.Message.getFieldWithDefault(msg, 5, ""),
    data: jspb.Message.getFieldWithDefault(msg, 6, ""),
    msg: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ProtoMessages.CameraControlMessage}
 */
proto.ProtoMessages.CameraControlMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ProtoMessages.CameraControlMessage;
  return proto.ProtoMessages.CameraControlMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ProtoMessages.CameraControlMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ProtoMessages.CameraControlMessage}
 */
proto.ProtoMessages.CameraControlMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ProtoMessages.CameraControlMessage.CameraControlMessageType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.ProtoMessages.CameraInfo;
      reader.readMessage(value,proto.ProtoMessages.CameraInfo.deserializeBinaryFromReader);
      msg.addHeadcameras(value);
      break;
    case 3:
      var value = new proto.ProtoMessages.CameraInfo;
      reader.readMessage(value,proto.ProtoMessages.CameraInfo.deserializeBinaryFromReader);
      msg.addAditionalanglescameras(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCameratoconnect(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInput(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ProtoMessages.CameraControlMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ProtoMessages.CameraControlMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ProtoMessages.CameraControlMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ProtoMessages.CameraControlMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getHeadcamerasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.ProtoMessages.CameraInfo.serializeBinaryToWriter
    );
  }
  f = message.getAditionalanglescamerasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.ProtoMessages.CameraInfo.serializeBinaryToWriter
    );
  }
  f = message.getCameratoconnect();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInput();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ProtoMessages.CameraControlMessage.CameraControlMessageType = {
  GET_CAMERAS: 0,
  CONNECT_TO_CAMERA: 1,
  CAMERA_CONTROL_FRAME: 2,
  CAMERA_CONTROL_INPUT: 3,
  CLOSE_CONNECTION: 4,
  FRAME_ACK: 5
};

/**
 * optional CameraControlMessageType type = 1;
 * @return {!proto.ProtoMessages.CameraControlMessage.CameraControlMessageType}
 */
proto.ProtoMessages.CameraControlMessage.prototype.getType = function() {
  return /** @type {!proto.ProtoMessages.CameraControlMessage.CameraControlMessageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ProtoMessages.CameraControlMessage.CameraControlMessageType} value
 * @return {!proto.ProtoMessages.CameraControlMessage} returns this
 */
proto.ProtoMessages.CameraControlMessage.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated CameraInfo headCameras = 2;
 * @return {!Array<!proto.ProtoMessages.CameraInfo>}
 */
proto.ProtoMessages.CameraControlMessage.prototype.getHeadcamerasList = function() {
  return /** @type{!Array<!proto.ProtoMessages.CameraInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.CameraInfo, 2));
};


/**
 * @param {!Array<!proto.ProtoMessages.CameraInfo>} value
 * @return {!proto.ProtoMessages.CameraControlMessage} returns this
*/
proto.ProtoMessages.CameraControlMessage.prototype.setHeadcamerasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ProtoMessages.CameraInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.CameraInfo}
 */
proto.ProtoMessages.CameraControlMessage.prototype.addHeadcameras = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ProtoMessages.CameraInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.CameraControlMessage} returns this
 */
proto.ProtoMessages.CameraControlMessage.prototype.clearHeadcamerasList = function() {
  return this.setHeadcamerasList([]);
};


/**
 * repeated CameraInfo aditionalAnglesCameras = 3;
 * @return {!Array<!proto.ProtoMessages.CameraInfo>}
 */
proto.ProtoMessages.CameraControlMessage.prototype.getAditionalanglescamerasList = function() {
  return /** @type{!Array<!proto.ProtoMessages.CameraInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ProtoMessages.CameraInfo, 3));
};


/**
 * @param {!Array<!proto.ProtoMessages.CameraInfo>} value
 * @return {!proto.ProtoMessages.CameraControlMessage} returns this
*/
proto.ProtoMessages.CameraControlMessage.prototype.setAditionalanglescamerasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.ProtoMessages.CameraInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ProtoMessages.CameraInfo}
 */
proto.ProtoMessages.CameraControlMessage.prototype.addAditionalanglescameras = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.ProtoMessages.CameraInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ProtoMessages.CameraControlMessage} returns this
 */
proto.ProtoMessages.CameraControlMessage.prototype.clearAditionalanglescamerasList = function() {
  return this.setAditionalanglescamerasList([]);
};


/**
 * optional string cameraToConnect = 4;
 * @return {string}
 */
proto.ProtoMessages.CameraControlMessage.prototype.getCameratoconnect = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraControlMessage} returns this
 */
proto.ProtoMessages.CameraControlMessage.prototype.setCameratoconnect = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string input = 5;
 * @return {string}
 */
proto.ProtoMessages.CameraControlMessage.prototype.getInput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraControlMessage} returns this
 */
proto.ProtoMessages.CameraControlMessage.prototype.setInput = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string data = 6;
 * @return {string}
 */
proto.ProtoMessages.CameraControlMessage.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraControlMessage} returns this
 */
proto.ProtoMessages.CameraControlMessage.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string msg = 7;
 * @return {string}
 */
proto.ProtoMessages.CameraControlMessage.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.ProtoMessages.CameraControlMessage} returns this
 */
proto.ProtoMessages.CameraControlMessage.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * @enum {number}
 */
proto.ProtoMessages.ConfigurationAction = {
  CONFIGURATION_ACTION_GET: 0,
  CONFIGURATION_ACTION_SET: 1,
  CONFIGURATION_ACTION_RESULT: 2,
  CONFIGURATION_ACTION_GET_HISTORY: 3,
  CONFIGURATION_ACTION_RESULT_HISTORY: 4
};

/**
 * @enum {number}
 */
proto.ProtoMessages.FrameType = {
  FRAME_TYPE_UNDEFINED: 0,
  SMALL_FRAMES: 1,
  LARGE_FRAMES: 2,
  PANO_IMAGE: 3,
  PIP_IMAGE: 4,
  AA_IMAGE: 5
};

/**
 * @enum {number}
 */
proto.ProtoMessages.CaptureFramesReplyType = {
  REPLY_TYPE_UNDEFINED: 0,
  REPLY_WITH_BIG_DATA_MESSAGE: 1,
  REPLY_WITH_DATA_CHUNK_MESSAGE: 2
};

/**
 * @enum {number}
 */
proto.ProtoMessages.PairingStage = {
  CALIBRATION_COPY: 0,
  FIND_CAMERAS: 1,
  IP_SETUP: 2,
  FW_FLASH: 3,
  CONFIG_FLASH: 4,
  ALL: 5
};

goog.object.extend(exports, proto.ProtoMessages);



// WEBPACK FOOTER //
// ./src/proto/Messages_pb.js